// noinspection JSUnusedGlobalSymbols

/**
 * This file was generated by the GraphQL Code Generator.
 * DO NOT EDIT.
 * @source: graphql-codegen/codegen.yml
 */

/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string, without a time component.
   */
  Date: { input: any; output: any };
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: { input: any; output: any };
  /**
   * The `Decimal` scalar type represents signed double-precision fractional
   * values parsed by the `Decimal` library. The Decimal appears in a JSON
   * response as a string to preserve precision.
   */
  Decimal: { input: any; output: any };
  /** Arbitrary JSON */
  Json: { input: unknown; output: unknown };
};

/** Where an account opening stands. A card names its applicant through card.user. */
export type AccountOpening = {
  accountId: Scalars['ID']['output'];
  /** The applicant a review verb resolved; null otherwise. */
  applicantIndex?: Maybe<Scalars['Int']['output']>;
  cards: Array<Card>;
  /** Null until the account boards. */
  loanId?: Maybe<Scalars['ID']['output']>;
  /** Applicant indices still owed an issued card; re-submitting the opening retries them. */
  pendingCards: Array<Scalars['Int']['output']>;
  replayed: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

export type AccountOpeningAddressInput = {
  city: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AccountOpeningApplicantInput = {
  address: AccountOpeningAddressInput;
  /** IMPORT only: the card the issuer already gave this applicant; omitted boards them without one. */
  card?: InputMaybe<AccountOpeningCardInput>;
  /** YYYY-MM-DD. */
  dateOfBirth: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** E.164, such as +18005551234: the identity provider keys the person on it. */
  phone: Scalars['String']['input'];
  /** May be omitted only for an attested import. */
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type AccountOpeningCardInput = {
  /** The issuer's reference: letters, digits and dashes, never a card number or a Lithic card token. */
  cardRef: Scalars['String']['input'];
  /** The card's last four digits. */
  lastFour: Scalars['String']['input'];
};

export type AccountOpeningInput = {
  applicants: Array<AccountOpeningApplicantInput>;
  /** Why the operator vouches for the applicants, in at most 255 characters: required with ATTEST, refused with SCREEN. */
  attestationReason?: InputMaybe<Scalars['String']['input']>;
  cardPlan: CardPlan;
  kyc: KycSource;
  partnerAccountNumber: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  /** Required for a primary-ledger program, refused for a shadow one. */
  terms?: InputMaybe<AccountOpeningTermsInput>;
};

/** The signed agreement's money and dates: whole cents, rates as decimal strings, YYYY-MM-DD dates. */
export type AccountOpeningTermsInput = {
  aprMargin: Scalars['String']['input'];
  creditLimit: Scalars['Int']['input'];
  initialApr: Scalars['String']['input'];
  /** The opening balance drawn at origination; omitted means none. */
  initialBalance?: InputMaybe<Scalars['Int']['input']>;
  originationDate: Scalars['String']['input'];
  /** The first day WITHOUT the 0% promo; omitted means the loan has no promo. */
  promoEndDate?: InputMaybe<Scalars['String']['input']>;
};

export enum AccrualBase {
  /** Interest accrues on the full balance, including billed interest and fees. */
  FullBalance = 'FULL_BALANCE',
  /** Interest accrues on the principal (spend) balances only — anti-compounding. */
  PrincipalOnly = 'PRINCIPAL_ONLY',
}

export type AchAuthorization = {
  acceptedAtClient?: Maybe<Scalars['DateTime']['output']>;
  acceptedAtServer?: Maybe<Scalars['DateTime']['output']>;
  autoPaySettingsId?: Maybe<Scalars['ID']['output']>;
  bankAccountLast4?: Maybe<Scalars['String']['output']>;
  deviceIdentifier?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  loanId?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['Json']['output']>;
  parentAuthorizationId?: Maybe<Scalars['ID']['output']>;
  plaidAccountId?: Maybe<Scalars['ID']['output']>;
  plaidItemId?: Maybe<Scalars['ID']['output']>;
  recordType: AchAuthorizationRecordType;
  renderedTextSnapshot?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  status: AchAuthorizationStatus;
  textVersion?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export enum AchAuthorizationRecordType {
  AutopayRecurringAuthorization = 'AUTOPAY_RECURRING_AUTHORIZATION',
  LinkAcceptanceEvent = 'LINK_ACCEPTANCE_EVENT',
  LinkAccountCoverage = 'LINK_ACCOUNT_COVERAGE',
}

export enum AchAuthorizationStatus {
  Active = 'ACTIVE',
  LegacyUnverified = 'LEGACY_UNVERIFIED',
  Revoked = 'REVOKED',
}

export type AchEvent = {
  achRequestId?: Maybe<Scalars['ID']['output']>;
  authCode?: Maybe<Scalars['String']['output']>;
  avsCode?: Maybe<Scalars['String']['output']>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['Json']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  finalStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AchRecoveryAvailability = {
  blockedReason?: Maybe<Scalars['String']['output']>;
  cancel: Scalars['Boolean']['output'];
  retry: Scalars['Boolean']['output'];
};

export type AchRequest = {
  achEvents?: Maybe<Array<Maybe<AchEvent>>>;
  achType?: Maybe<Scalars['String']['output']>;
  amountCents?: Maybe<Scalars['Int']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inFlight: Scalars['Boolean']['output'];
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  ledgerRefId?: Maybe<Scalars['ID']['output']>;
  loan?: Maybe<Loan>;
  lockVersion?: Maybe<Scalars['Int']['output']>;
  parkedFromStatus?: Maybe<Scalars['String']['output']>;
  plaidAccountId?: Maybe<Scalars['ID']['output']>;
  recovery?: Maybe<AchRecoveryAvailability>;
  returnCode?: Maybe<Scalars['String']['output']>;
  returnInitiatedAt?: Maybe<Scalars['DateTime']['output']>;
  returnProcessedAt?: Maybe<Scalars['DateTime']['output']>;
  settledAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
  usioConfirmation?: Maybe<Scalars['String']['output']>;
};

export enum AchRequestStatus {
  AwaitingPartnerFunding = 'AWAITING_PARTNER_FUNDING',
  Cancelled = 'CANCELLED',
  Cancelling = 'CANCELLING',
  DepositRequested = 'DEPOSIT_REQUESTED',
  Failed = 'FAILED',
  HoldPlaced = 'HOLD_PLACED',
  Initiated = 'INITIATED',
  Processing = 'PROCESSING',
  ReturnInitiated = 'RETURN_INITIATED',
  ReturnProcessed = 'RETURN_PROCESSED',
  Scheduled = 'SCHEDULED',
  Settled = 'SETTLED',
  SettledFail = 'SETTLED_FAIL',
  SubmissionUnknown = 'SUBMISSION_UNKNOWN',
  Submitting = 'SUBMITTING',
  TransferInitiated = 'TRANSFER_INITIATED',
}

export enum AchRequestType {
  Drawdown = 'DRAWDOWN',
  Repayment = 'REPAYMENT',
}

export type AchReturnResult = {
  achRequest: AchRequest;
  affectedStatementIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  allocationsReversed?: Maybe<Scalars['Int']['output']>;
  allocationsToReverse?: Maybe<Array<Maybe<AllocationPreview>>>;
  delinquencyTriggered?: Maybe<Scalars['Boolean']['output']>;
  dryRun: Scalars['Boolean']['output'];
  feeAdjustments?: Maybe<Array<Maybe<AdjustmentSummary>>>;
  interestAdjustments?: Maybe<Array<Maybe<AdjustmentSummary>>>;
  message?: Maybe<Scalars['String']['output']>;
  repaymentAmountCents: Scalars['Int']['output'];
  returnCategory: Scalars['String']['output'];
  returnCode: Scalars['String']['output'];
  returnFeeCents?: Maybe<Scalars['Int']['output']>;
  returnFeeWillPost: Scalars['Boolean']['output'];
  returnReason: Scalars['String']['output'];
};

export enum AchReturnType {
  /** Admin-initiated void (skips return fee) */
  AdminVoid = 'ADMIN_VOID',
  /** Bank-initiated return (charges return fee) */
  BankReturn = 'BANK_RETURN',
}

export type AddFeeTransactionPayload = {
  transactionId: Scalars['String']['output'];
};

export type Address = {
  addressFirstLine?: Maybe<Scalars['String']['output']>;
  addressSecondLine?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isBilling?: Maybe<Scalars['Boolean']['output']>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isDebitPayment?: Maybe<Scalars['Boolean']['output']>;
  isPoBox?: Maybe<Scalars['Boolean']['output']>;
  isShipping?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  addressFirstLine?: InputMaybe<Scalars['String']['input']>;
  addressSecondLine?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  isBilling?: InputMaybe<Scalars['Boolean']['input']>;
  isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  isPoBox?: InputMaybe<Scalars['Boolean']['input']>;
  isShipping?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AdjustmentSummary = {
  amountCents: Scalars['Int']['output'];
  effectiveDate: Scalars['String']['output'];
  statementId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type AdminActionRecord = {
  action?: Maybe<Scalars['String']['output']>;
  actor?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['Json']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The loan the action was applied to; null when the action was not recorded against a loan. */
  loan?: Maybe<Loan>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export enum AdminRole {
  PartnerAdmin = 'PARTNER_ADMIN',
  SupportAgent = 'SUPPORT_AGENT',
}

export type Alert = {
  details?: Maybe<Scalars['Json']['output']>;
  handled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AllocationPreview = {
  amount: Scalars['Decimal']['output'];
  targetAccountId: Scalars['String']['output'];
};

export type AutoPaySettings = {
  daysBeforePayment?: Maybe<Scalars['Int']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  loan?: Maybe<Loan>;
  paymentType?: Maybe<Scalars['String']['output']>;
  plaidAccountId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type AutoPaySettingsInput = {
  daysBeforePayment: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  paymentType: Scalars['String']['input'];
  plaidAccountId: Scalars['ID']['input'];
};

export type BalanceDetails = {
  availableEncumbrance?: Maybe<Scalars['String']['output']>;
  availablePending?: Maybe<Scalars['String']['output']>;
  availableSettled?: Maybe<Scalars['String']['output']>;
  pending?: Maybe<Scalars['String']['output']>;
};

export type BalanceRawDetails = {
  available?: Maybe<BalanceRawItem>;
  encumbrance?: Maybe<BalanceRawItem>;
  pending?: Maybe<BalanceRawItem>;
  settled?: Maybe<BalanceRawItem>;
};

export type BalanceRawItem = {
  cr?: Maybe<Scalars['String']['output']>;
  dr?: Maybe<Scalars['String']['output']>;
  normal?: Maybe<Scalars['String']['output']>;
};

export enum BlockUnblockCardAction {
  Block = 'BLOCK',
  Unblock = 'UNBLOCK',
}

export type Card = {
  active?: Maybe<Scalars['Boolean']['output']>;
  blockedReason?: Maybe<Scalars['String']['output']>;
  cardEvents: Array<CardEvent>;
  dateOpened?: Maybe<Scalars['DateTime']['output']>;
  expDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  lastFour?: Maybe<Scalars['String']['output']>;
  loan?: Maybe<Loan>;
  physicalActivatedAt?: Maybe<Scalars['DateTime']['output']>;
  processor?: Maybe<CardProcessor>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CardStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type CardDispute = {
  agentId?: Maybe<Scalars['String']['output']>;
  cardRefNo?: Maybe<Scalars['String']['output']>;
  creditType?: Maybe<Scalars['String']['output']>;
  declineReasons?: Maybe<Scalars['String']['output']>;
  disputeTransId: Scalars['String']['output'];
  events?: Maybe<Array<Maybe<CardDisputeEvent>>>;
  filedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  loan?: Maybe<Loan>;
  loanId?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['Json']['output']>;
  originalAmountCents?: Maybe<Scalars['Int']['output']>;
  recalculationCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedAmountCents?: Maybe<Scalars['Int']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  status: DisputeStatus;
  twispAccountId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export type CardDisputeEvent = {
  amountCents?: Maybe<Scalars['Int']['output']>;
  de31?: Maybe<Scalars['String']['output']>;
  de80Parsed?: Maybe<Scalars['Json']['output']>;
  de80Raw?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  mti?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  twispTransactionId?: Maybe<Scalars['String']['output']>;
  webhookEventId: Scalars['String']['output'];
};

export type CardEvent = {
  actor?: Maybe<User>;
  card?: Maybe<Card>;
  details?: Maybe<Scalars['Json']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum CardPlan {
  /** Board each applicant with the card reference the issuer already gave them. */
  Import = 'IMPORT',
  /** Mint each applicant a Lithic card once the account boards. */
  Issue = 'ISSUE',
}

export enum CardProcessor {
  I2C = 'I2C',
  Lithic = 'LITHIC',
}

export enum CardStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Closed = 'CLOSED',
  Lost = 'LOST',
  NotActivated = 'NOT_ACTIVATED',
  Replaced = 'REPLACED',
  Stolen = 'STOLEN',
}

export type CloseStatementCycleOptions = {
  /** @deprecated no effect */
  adb?: InputMaybe<Scalars['Boolean']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  creditLimit?: InputMaybe<Scalars['Int']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  genPdf?: InputMaybe<Scalars['Boolean']['input']>;
  genTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  minPayment?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated no effect */
  ytd?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateAdminUserInput = {
  adminProgramId?: InputMaybe<Scalars['ID']['input']>;
  authId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  phone: Scalars['String']['input'];
  role: AdminRole;
};

export type CreatePartnerInput = {
  name: Scalars['String']['input'];
};

export type CreatePrimeRateInput = {
  effectiveDate: Scalars['Date']['input'];
  rate: Scalars['Decimal']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProgramInput = {
  accrualBase: AccrualBase;
  /** The autopay payment types members may enrol in: minimum, statement, full. */
  autopayPaymentTypes: Array<Scalars['String']['input']>;
  cashAdvanceFeeMinCents: Scalars['Int']['input'];
  cashAdvanceFeeRate: Scalars['Decimal']['input'];
  cashAdvanceMccs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether cardholders may take cash (ATM, teller, cash back). Absent, the sponsor-bank baseline is recorded: false. An explicit null is rejected. setProgramMerchantPolicy changes it later, audited. */
  cashAdvancesAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  chargeDrawdownFee: Scalars['Boolean']['input'];
  firstLateFeeAmount: Scalars['Int']['input'];
  foreignTransactionFeeRate: Scalars['Decimal']['input'];
  graceStrategy: GraceStrategy;
  id: Scalars['ID']['input'];
  interestPostingPolicy: InterestPostingPolicy;
  /** Grace window in days after the payment due date. Late fees can first be assessed the following day (7 means day 8; 10 means day 11). Zero means no deferral. */
  lateFeeGracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  lateFeeStrategy: LateFeeStrategy;
  maxApr: Scalars['Decimal']['input'];
  minApr: Scalars['Decimal']['input'];
  minimumPaymentAllocationOrder: MinimumPaymentAllocationOrder;
  minimumPaymentClassOrder: MinimumPaymentClassOrder;
  minimumPaymentFloorCents?: InputMaybe<Scalars['Int']['input']>;
  minimumPaymentRate?: InputMaybe<Scalars['Decimal']['input']>;
  minimumPaymentStrategy: MinimumPaymentStrategy;
  name: Scalars['String']['input'];
  partnerId: Scalars['ID']['input'];
  /** Minimum days from statement period end to payment due date across every month. */
  paymentDueDateGracePeriodDays: Scalars['Int']['input'];
  paymentDueDay?: InputMaybe<Scalars['Int']['input']>;
  pdfTemplate: PdfTemplate;
  replacementCardFeeCents: Scalars['Int']['input'];
  returnedPaymentFeeCents: Scalars['Int']['input'];
  returnedPaymentFeeStrategy: ReturnedPaymentFeeStrategy;
  slug?: InputMaybe<Scalars['String']['input']>;
  statementGenerateDay: Scalars['Int']['input'];
  subsequentLateFeeAmount?: InputMaybe<Scalars['Int']['input']>;
  targetInterestRate: Scalars['Decimal']['input'];
  twispExposureAccountSetId?: InputMaybe<Scalars['ID']['input']>;
  twispIsoConfigId?: InputMaybe<Scalars['ID']['input']>;
  twispJournalId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateShadowProgramInput = {
  active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  partnerId: Scalars['ID']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  twispExposureAccountSetId?: InputMaybe<Scalars['ID']['input']>;
  twispIsoConfigId?: InputMaybe<Scalars['ID']['input']>;
  twispJournalId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreditUtilizationData = {
  availableAmount: Scalars['String']['output'];
  balance: Scalars['String']['output'];
  limit: Scalars['String']['output'];
  remaining: Scalars['String']['output'];
  spent: Scalars['String']['output'];
};

export type DailyReport = {
  cardFeesBalance?: Maybe<Scalars['Int']['output']>;
  cardInterestBalance?: Maybe<Scalars['Int']['output']>;
  cardSetBalance?: Maybe<Scalars['Int']['output']>;
  cardSpendBalance?: Maybe<Scalars['Int']['output']>;
  creditLimit?: Maybe<Scalars['Int']['output']>;
  creditLineFeesBalance?: Maybe<Scalars['Int']['output']>;
  creditLineInterestBalance?: Maybe<Scalars['Int']['output']>;
  creditLineSetBalance?: Maybe<Scalars['Int']['output']>;
  creditLineSpendBalance?: Maybe<Scalars['Int']['output']>;
  feesBalance?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  lastPaymentAmount?: Maybe<Scalars['Int']['output']>;
  lastPaymentDate?: Maybe<Scalars['Date']['output']>;
  latestBalance?: Maybe<Scalars['Int']['output']>;
  loan?: Maybe<Loan>;
  loanBalance?: Maybe<Scalars['Int']['output']>;
  loanId?: Maybe<Scalars['ID']['output']>;
  recalculationBatchId?: Maybe<Scalars['ID']['output']>;
  recalculationReason?: Maybe<Scalars['String']['output']>;
  repaymentBalance?: Maybe<Scalars['Int']['output']>;
  reportDate?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DelinquencyResult = {
  affectedCards: Array<Card>;
  loan?: Maybe<Loan>;
  message?: Maybe<Scalars['String']['output']>;
};

export type DeviceToken = {
  appVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceType>;
  id?: Maybe<Scalars['ID']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum DeviceType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB',
}

export enum DisputeStatus {
  AdminCredit = 'ADMIN_CREDIT',
  Filed = 'FILED',
  MerchantWin = 'MERCHANT_WIN',
  NetworkCredit = 'NETWORK_CREDIT',
  NoCredit = 'NO_CREDIT',
  UnderReview = 'UNDER_REVIEW',
}

export type DueDateOptions = {
  addInterest?: InputMaybe<Scalars['Boolean']['input']>;
  addLateFee?: InputMaybe<Scalars['Boolean']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  cureDelinquency?: InputMaybe<Scalars['Boolean']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  lateFeeAmount?: InputMaybe<Scalars['Int']['input']>;
  lateFeeGracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  markDelinquent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DueDateProcessingResult = {
  daysDelinquent?: Maybe<Scalars['Int']['output']>;
  interestApplied?: Maybe<Scalars['String']['output']>;
  isDelinquent?: Maybe<Scalars['Boolean']['output']>;
  lateFeeApplied?: Maybe<Scalars['String']['output']>;
  paymentAmount?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  remainingBalance?: Maybe<Scalars['String']['output']>;
};

export type ExternalRepaymentResult = {
  correlationId?: Maybe<Scalars['String']['output']>;
  delinquencyCured: Scalars['Boolean']['output'];
  remainingUnallocatedCents: Scalars['Int']['output'];
  settlementTransactionId?: Maybe<Scalars['String']['output']>;
  status: ExternalRepaymentStatus;
};

export enum ExternalRepaymentStatus {
  /** Settled and fully allocated through the waterfall */
  Allocated = 'ALLOCATED',
  /** payment_ref was already settled on a prior call */
  AlreadyProcessed = 'ALREADY_PROCESSED',
}

export enum GraceStrategy {
  /** Deferred interest posts at the due date when the grace test fails — dwelling-secured plans only (Reg Z §1026.54 does not cover them). */
  Retroactive = 'RETROACTIVE',
  /** Reg Z §1026.54: on a failed grace test only the unpaid portion bills, only for the current cycle's days, at the next close. */
  Waive = 'WAIVE',
}

export enum InterestPostingPolicy {
  SameCycleStatementClose = 'SAME_CYCLE_STATEMENT_CLOSE',
  TrailingNextStatement = 'TRAILING_NEXT_STATEMENT',
}

export enum KycSource {
  /** The operator vouches for each applicant's identity. */
  Attest = 'ATTEST',
  /** The identity vendor screens each applicant. */
  Screen = 'SCREEN',
}

export type LateFeeProcessingResult = {
  actionsTaken?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  feeTier?: Maybe<Scalars['String']['output']>;
  lateFeeApplied?: Maybe<Scalars['Int']['output']>;
  minimumPaymentDue?: Maybe<Scalars['Int']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  statementDueDate?: Maybe<Scalars['Date']['output']>;
  statementId?: Maybe<Scalars['String']['output']>;
  statementNewBalance?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum LateFeeStrategy {
  /** Flat first/subsequent amount, capped at the missed minimum (Reg Z §1026.52(b)) — the cap binds an operator's fee override too. Subsequent applies when a fee exists within the six-cycle lookback. */
  FlatTiered = 'FLAT_TIERED',
  /** min(5% × minimum payment, first_late_fee_amount) — the HELOC formula. */
  PercentOfMinimum = 'PERCENT_OF_MINIMUM',
}

export type LedgerBalance = {
  available?: Maybe<Scalars['String']['output']>;
  pending?: Maybe<Scalars['String']['output']>;
};

export type LedgerBalancesData = {
  twispCardAccount: LedgerBalance;
  twispCardFeesAccount: LedgerBalance;
  twispCardInterestAccount: LedgerBalance;
  twispCreditLineAccount: LedgerBalance;
  twispCreditLineFeesAccount: LedgerBalance;
  twispCreditLineInterestAccount: LedgerBalance;
  twispFeesAccount: LedgerBalance;
  twispInterestAccount: LedgerBalance;
  twispLoanAccount: LedgerBalance;
  twispRepaymentAccount: LedgerBalance;
};

export enum LedgerEntryLayer {
  Encumbrance = 'ENCUMBRANCE',
  Pending = 'PENDING',
  Settled = 'SETTLED',
}

export type LedgerTransactionDetail = {
  accountId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  balanceRecordId?: Maybe<Scalars['String']['output']>;
  balanceRecordVersion?: Maybe<Scalars['Int']['output']>;
  correlationId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  entryId?: Maybe<Scalars['ID']['output']>;
  entryType?: Maybe<Scalars['String']['output']>;
  journalId?: Maybe<Scalars['ID']['output']>;
  layer?: Maybe<Scalars['String']['output']>;
  loanId?: Maybe<Scalars['ID']['output']>;
  merchantDetails?: Maybe<MerchantDetails>;
  metadata?: Maybe<Scalars['Json']['output']>;
  modified?: Maybe<Scalars['String']['output']>;
  rawEntry?: Maybe<Scalars['Json']['output']>;
  rawTranCode?: Maybe<Scalars['String']['output']>;
  recordId?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  tranCode?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['ID']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export enum LedgerTransactionEntryScope {
  BalancingEntry = 'BALANCING_ENTRY',
  UserAccountEntry = 'USER_ACCOUNT_ENTRY',
}

export enum LedgerTransactionStatus {
  Encumbered = 'ENCUMBERED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Settled = 'SETTLED',
}

export type LedgerTransactionsList = {
  pagination: PaginationDetails;
  transactions?: Maybe<Array<Maybe<TransactionDetailsSuperAdmin>>>;
};

export type ListAchAuthorizationsResult = {
  achAuthorizations?: Maybe<Array<AchAuthorization>>;
  pagination: PaginationDetails;
};

export type ListAchRequestsResult = {
  achRequests?: Maybe<Array<AchRequest>>;
  pagination: PaginationDetails;
};

export type ListAdminActionRecordsResult = {
  adminActionRecords?: Maybe<Array<AdminActionRecord>>;
  pagination: PaginationDetails;
};

export type ListCardsResult = {
  cards?: Maybe<Array<Card>>;
  pagination: PaginationDetails;
};

export type ListDevicesResult = {
  devices?: Maybe<Array<DeviceToken>>;
  pagination: PaginationDetails;
};

export type ListDisputesResult = {
  disputes?: Maybe<Array<CardDispute>>;
  pagination: PaginationDetails;
};

export type ListLoansResult = {
  loans: Array<Loan>;
  pagination: PaginationDetails;
};

export type ListProgramsResult = {
  pagination: PaginationDetails;
  programs: Array<Program>;
};

export type ListStatementsResult = {
  pagination: PaginationDetails;
  statements?: Maybe<Array<Statement>>;
};

export type ListUsersResult = {
  pagination: PaginationDetails;
  users?: Maybe<Array<User>>;
};

export type Loan = {
  achRequests: Array<AchRequest>;
  aprMargin?: Maybe<Scalars['String']['output']>;
  autoPaySettings?: Maybe<AutoPaySettings>;
  cardEvents: Array<CardEvent>;
  cards: Array<Card>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  closureReason?: Maybe<LoanClosureReason>;
  closureRequestedAt?: Maybe<Scalars['Date']['output']>;
  creditLimit?: Maybe<Scalars['Int']['output']>;
  currentApr?: Maybe<Scalars['String']['output']>;
  currentPrimeRate?: Maybe<Scalars['String']['output']>;
  dailyReports: Array<DailyReport>;
  daysDelinquent?: Maybe<Scalars['Int']['output']>;
  delinquentSince?: Maybe<Scalars['Date']['output']>;
  disputes: Array<CardDispute>;
  id: Scalars['ID']['output'];
  initialApr?: Maybe<Scalars['String']['output']>;
  initialBalance?: Maybe<Scalars['Int']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  isDelinquent?: Maybe<Scalars['Boolean']['output']>;
  isVariableApr?: Maybe<Scalars['Boolean']['output']>;
  loanEvents: Array<LoanEvent>;
  originationDate?: Maybe<Scalars['Date']['output']>;
  partnerAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Payment due day frozen when the loan was boarded; null for shadow loans. */
  paymentDueDay?: Maybe<Scalars['Int']['output']>;
  program?: Maybe<Program>;
  programId?: Maybe<Scalars['ID']['output']>;
  promoEndDate?: Maybe<Scalars['Date']['output']>;
  /** Statement generation day frozen when the loan was boarded; null for shadow loans. */
  statementDay?: Maybe<Scalars['Int']['output']>;
  statements: Array<Statement>;
  status?: Maybe<LoanStatus>;
  terminalCloseOn?: Maybe<Scalars['Date']['output']>;
  twispCardAccountSetId?: Maybe<Scalars['String']['output']>;
  twispCardFeesId?: Maybe<Scalars['String']['output']>;
  twispCardInterestId?: Maybe<Scalars['String']['output']>;
  twispCardSpendSetId?: Maybe<Scalars['String']['output']>;
  twispCreditLineAccountSetId?: Maybe<Scalars['String']['output']>;
  twispCreditLineFeesId?: Maybe<Scalars['String']['output']>;
  twispCreditLineInterestId?: Maybe<Scalars['String']['output']>;
  twispCreditLineSpendId?: Maybe<Scalars['String']['output']>;
  twispFeesId?: Maybe<Scalars['String']['output']>;
  twispLoanId?: Maybe<Scalars['String']['output']>;
  twispRepaymentId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userEvents: Array<UserEvent>;
  users: Array<User>;
};

export enum LoanClosureReason {
  ChargedOff = 'CHARGED_OFF',
  CustomerRequest = 'CUSTOMER_REQUEST',
  Death = 'DEATH',
  Fraud = 'FRAUD',
  HomelightInitiated = 'HOMELIGHT_INITIATED',
  PaidOff = 'PAID_OFF',
  Refinance = 'REFINANCE',
}

export type LoanEvent = {
  actor?: Maybe<User>;
  details?: Maybe<Scalars['Json']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  loan?: Maybe<Loan>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LoanMember = {
  firstName?: Maybe<Scalars['String']['output']>;
  joinedAt: Scalars['DateTime']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export enum LoanStatus {
  Boarded = 'BOARDED',
  Closed = 'CLOSED',
  Delinquent = 'DELINQUENT',
}

export type LoanWithoutServicingData = {
  id: Scalars['ID']['output'];
  members: Array<LoanMember>;
  originationDate?: Maybe<Scalars['Date']['output']>;
  partnerAccountNumber?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type MerchantDetails = {
  city?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export enum MinimumPaymentAllocationOrder {
  /** The required-minimum part pays the dearest APR bucket first — the same direction §1026.53(a) fixes for the part above the minimum. */
  HighestAprFirst = 'HIGHEST_APR_FIRST',
  /** The required-minimum part of a payment pays the cheapest APR bucket first — Reg Z §1026.53 leaves the minimum's order to the issuer. */
  LowestAprFirst = 'LOWEST_APR_FIRST',
}

export enum MinimumPaymentClassOrder {
  /** The required-minimum part of a payment pays loan-level fees, then one APR bucket at a time — interest, fees, principal — buckets in the direction minimumPaymentAllocationOrder picks. */
  InterestBeforePrincipal = 'INTEREST_BEFORE_PRINCIPAL',
  /** The required-minimum part pays every interest-bearing balance first — the fees and principal inside each APR bucket — then interest, then the fees that bear no interest. */
  PrincipalBeforeInterest = 'PRINCIPAL_BEFORE_INTEREST',
}

export enum MinimumPaymentStrategy {
  CreditCardPercentOfBalance = 'CREDIT_CARD_PERCENT_OF_BALANCE',
  HelocCumulative = 'HELOC_CUMULATIVE',
}

export type PaginationDetails = {
  hasNextPage: Scalars['Boolean']['output'];
  pageNumber: Scalars['Int']['output'];
  resultsPerPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type Partner = {
  active: Scalars['Boolean']['output'];
  forwardDecisionUrl?: Maybe<Scalars['String']['output']>;
  forwardDecisionWhsecRef?: Maybe<Scalars['String']['output']>;
  forwardDisputesUrl?: Maybe<Scalars['String']['output']>;
  forwardDisputesWhsecRef?: Maybe<Scalars['String']['output']>;
  forwardEventsUrl?: Maybe<Scalars['String']['output']>;
  forwardEventsWhsecRef?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PartnerAccountApplicant = {
  address: Scalars['String']['output'];
  dateOfBirth: Scalars['String']['output'];
  email: Scalars['String']['output'];
  existingUserId?: Maybe<Scalars['ID']['output']>;
  firstName: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  reviewHold?: Maybe<Scalars['String']['output']>;
  ssnLastFour?: Maybe<Scalars['String']['output']>;
};

export type PartnerAccountCheck = {
  applicantIndex: Scalars['Int']['output'];
  decidedAt: Scalars['DateTime']['output'];
  decision: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  reasonCodes?: Maybe<Scalars['Json']['output']>;
  reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  reviewerId?: Maybe<Scalars['ID']['output']>;
};

export type PartnerAccountIntake = {
  accountId: Scalars['ID']['output'];
  applicants: Array<PartnerAccountApplicant>;
  checks: Array<PartnerAccountCheck>;
  partnerAccountNumber: Scalars['String']['output'];
  programId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type PartnerProvisioningResult = {
  clientId: Scalars['ID']['output'];
  clientSecret: Scalars['String']['output'];
  partner: Partner;
};

export enum PaymentDirection {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
}

export enum PdfTemplate {
  StatementCardGeneric = 'STATEMENT_CARD_GENERIC',
  StatementHomelight = 'STATEMENT_HOMELIGHT',
  StatementLfcu = 'STATEMENT_LFCU',
}

/** A billing period named by its bounds alone. */
export type PeriodBounds = {
  from: Scalars['Date']['output'];
  to: Scalars['Date']['output'];
};

export type PlatformBalanceAccount = {
  balance: LedgerBalance;
  code?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  kind: PlatformBalanceAccountKind;
  label: Scalars['String']['output'];
  normalBalanceType?: Maybe<Scalars['String']['output']>;
  twispId: Scalars['ID']['output'];
};

export enum PlatformBalanceAccountKind {
  Account = 'ACCOUNT',
  AccountSet = 'ACCOUNT_SET',
}

export type PlatformBalancesData = {
  accounts: Array<PlatformBalanceAccount>;
  achSettlement: LedgerBalance;
  cardSettlement: LedgerBalance;
  disputes: LedgerBalance;
  exposureRollup: LedgerBalance;
  externalOpeningBalance: LedgerBalance;
  externalRepayment: LedgerBalance;
  repayment: LedgerBalance;
  revenue: LedgerBalance;
};

export type PrimeRate = {
  effectiveDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  rate: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Program = {
  accrualBase?: Maybe<AccrualBase>;
  active: Scalars['Boolean']['output'];
  autopayPaymentTypes?: Maybe<Array<Scalars['String']['output']>>;
  cashAdvanceFeeMinCents?: Maybe<Scalars['Int']['output']>;
  cashAdvanceFeeRate?: Maybe<Scalars['Decimal']['output']>;
  cashAdvanceMccs?: Maybe<Array<Scalars['String']['output']>>;
  cashAdvancesAllowed?: Maybe<Scalars['Boolean']['output']>;
  chargeDrawdownFee?: Maybe<Scalars['Boolean']['output']>;
  firstLateFeeAmount?: Maybe<Scalars['Int']['output']>;
  foreignTransactionFeeRate?: Maybe<Scalars['Decimal']['output']>;
  graceStrategy?: Maybe<GraceStrategy>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  interestPostingPolicy?: Maybe<InterestPostingPolicy>;
  lateFeeGracePeriodDays?: Maybe<Scalars['Int']['output']>;
  lateFeeStrategy?: Maybe<LateFeeStrategy>;
  lithicCardProgramToken?: Maybe<Scalars['String']['output']>;
  /** @deprecated renamed to slug — one name across both apps */
  lithicCredentialsKey?: Maybe<Scalars['String']['output']>;
  lithicProductId?: Maybe<Scalars['String']['output']>;
  maxApr?: Maybe<Scalars['String']['output']>;
  minApr?: Maybe<Scalars['String']['output']>;
  minimumPaymentAllocationOrder?: Maybe<MinimumPaymentAllocationOrder>;
  minimumPaymentClassOrder?: Maybe<MinimumPaymentClassOrder>;
  minimumPaymentFloorCents?: Maybe<Scalars['Int']['output']>;
  minimumPaymentRate?: Maybe<Scalars['Decimal']['output']>;
  minimumPaymentStrategy?: Maybe<MinimumPaymentStrategy>;
  name: Scalars['String']['output'];
  partner: Partner;
  /** Minimum days from statement period end to payment due date across every month. */
  paymentDueDateGracePeriodDays?: Maybe<Scalars['Int']['output']>;
  paymentDueDay?: Maybe<Scalars['Int']['output']>;
  pdfTemplate?: Maybe<PdfTemplate>;
  replacementCardFeeCents?: Maybe<Scalars['Int']['output']>;
  returnedPaymentFeeCents?: Maybe<Scalars['Int']['output']>;
  returnedPaymentFeeStrategy?: Maybe<ReturnedPaymentFeeStrategy>;
  slug?: Maybe<Scalars['String']['output']>;
  statementCloseDay?: Maybe<Scalars['Int']['output']>;
  statementGenerateDay?: Maybe<Scalars['Int']['output']>;
  subsequentLateFeeAmount?: Maybe<Scalars['Int']['output']>;
  targetInterestRate?: Maybe<Scalars['String']['output']>;
  twispExposureAccountSetId?: Maybe<Scalars['ID']['output']>;
  twispIsoConfigId?: Maybe<Scalars['ID']['output']>;
  twispJournalId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReconciliationCheckStatus = {
  check: Scalars['String']['output'];
  /** Null when the night left no row — a missed run, not a clean one. */
  latestRun?: Maybe<ReconciliationRun>;
  /** The latest run's findings the previous run did not carry — the ones that paged. */
  newFindings: Scalars['Json']['output'];
  severity: ReconciliationSeverity;
};

export type ReconciliationRun = {
  asOf: Scalars['Date']['output'];
  check: Scalars['String']['output'];
  /** Set when the check could not run; findings is empty then. */
  error?: Maybe<Scalars['String']['output']>;
  examinedCount: Scalars['Int']['output'];
  /** List of {kind, loan_id, expected, actual, ids} maps — ids and cents only, no PII. */
  findings: Scalars['Json']['output'];
  finishedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export enum ReconciliationSeverity {
  /** New findings page on-call */
  Page = 'PAGE',
  /** Findings are recorded only */
  Record = 'RECORD',
}

/**
 * A recovery report or run. The plan fields (`periods`, the gap-entry grace
 * verdict) are filled by a dry run; `generatedCount` and `haltedReason` by an
 * execution.
 */
export type RecoverStatementCyclesResult = {
  /**
   * Always true, and the caveat to read the balances with: each period's open
   * and close balances are read before the walk posts anything, so every period
   * after the first will close HIGHER than shown once the walk's own trailing
   * interest lands in it. The executed statements are the truth.
   */
  balancesExcludeWalkInterest: Scalars['Boolean']['output'];
  /** Whether that grace is deemed: the pre-gap statement gave no fair chance to pay. */
  deemed?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the gap's first cycle enters under grace — deemed grace included. */
  entering?: Maybe<Scalars['Boolean']['output']>;
  executed: Scalars['Boolean']['output'];
  /** Cycles the walk wrote (a plan reports zero — it writes nothing). */
  generatedCount: Scalars['Int']['output'];
  generatedStatementIds: Array<Scalars['ID']['output']>;
  /** Why the walk stopped, when it did. Null means every planned period was written. */
  haltedReason?: Maybe<Scalars['String']['output']>;
  /**
   * Plan-only: the gap periods whose daily reports have holes. The closing
   * pipeline refuses such a period, so these are where the walk would most
   * likely halt — fix them before executing. Repairs are never listed (a
   * repair reads no daily reports), and an execute answers for the run it
   * made rather than a plan it never re-derived, so it always reports empty.
   */
  missingDailyReportPeriods: Array<PeriodBounds>;
  periods: Array<RecoveredPeriod>;
  /**
   * Statements finalized in place rather than written: a row that already
   * existed and only lacked its PDF or its member deliveries. A plan reports
   * how many it found, an execute how many it finished.
   */
  repairedCount: Scalars['Int']['output'];
};

/** One billing period a catch-up walk would generate, and the balances it spans. */
export type RecoveredPeriod = {
  closeBalanceCents: Scalars['Int']['output'];
  from: Scalars['Date']['output'];
  openBalanceCents: Scalars['Int']['output'];
  to: Scalars['Date']['output'];
};

export enum ReplaceCardType {
  Lost = 'LOST',
  Replaced = 'REPLACED',
  Stolen = 'STOLEN',
}

export enum ReplayLoanComponent {
  CardInterest = 'CARD_INTEREST',
  CreditLineInterest = 'CREDIT_LINE_INTEREST',
  LateFee = 'LATE_FEE',
}

export enum ReplayLoanDelinquencyAction {
  Mark = 'MARK',
  Redate = 'REDATE',
}

export type ReplayLoanDelinquencySummary = {
  action: ReplayLoanDelinquencyAction;
  delinquentSince?: Maybe<Scalars['Date']['output']>;
  reason: Scalars['String']['output'];
};

export type ReplayLoanDelta = {
  billingPeriodEnd: Scalars['Date']['output'];
  billingPeriodStart: Scalars['Date']['output'];
  component: ReplayLoanComponent;
  deltaCents: Scalars['Int']['output'];
  direction: ReplayLoanDeltaDirection;
  effectiveDate: Scalars['Date']['output'];
  postedToDateCents: Scalars['Int']['output'];
  recomputedCents: Scalars['Int']['output'];
  statementId: Scalars['ID']['output'];
};

export enum ReplayLoanDeltaDirection {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
}

export type ReplayLoanResult = {
  /** Corrections another path had already charged, so this run left them alone. Null on a dry run. */
  alreadyAppliedCount?: Maybe<Scalars['Int']['output']>;
  /** Corrections the ledger already carried under this run's ids — derived, but not moved by this run. Null on a dry run. */
  alreadyPostedCount?: Maybe<Scalars['Int']['output']>;
  /** At least one closed period in the window has not been judged by due-date processing, so its card pass may not have been re-derived; treat a zero card correction there as unconfirmed. */
  cardPassPending: Scalars['Boolean']['output'];
  delinquency?: Maybe<ReplayLoanDelinquencySummary>;
  deltas: Array<ReplayLoanDelta>;
  dryRun: Scalars['Boolean']['output'];
  /** The program waives grace interest and the interest pass is switched off, so deltas cover delinquency only. */
  interestPassSkipped: Scalars['Boolean']['output'];
  loanId: Scalars['ID']['output'];
  /** Corrections this run posted to the ledger. Null on a dry run. */
  postedCount?: Maybe<Scalars['Int']['output']>;
  window: ReplayLoanWindow;
};

export type ReplayLoanWindow = {
  fromDate: Scalars['Date']['output'];
  toDate: Scalars['Date']['output'];
};

export enum ReturnedPaymentFeeStrategy {
  /** min(returned_payment_fee_cents, minimum payment due immediately prior to the return) — the Reg Z §1026.52(b)(2)(i) model, mandatory for the unsecured-card family. */
  Capped = 'CAPPED',
  /** returned_payment_fee_cents charged as-is. */
  Flat = 'FLAT',
}

export type RootMutationType = {
  /** Process an ACH return (bank return or admin void). Use dry_run: true for preview. */
  achReturn?: Maybe<AchReturnResult>;
  /** Activate a card by reference id */
  activateCard?: Maybe<Card>;
  addAddress?: Maybe<User>;
  /** Add a fee transaction to the ledger */
  addFeeTransaction?: Maybe<AddFeeTransactionPayload>;
  /**
   * Adds a person who already exists to an existing loan. `joinedAt` is stamped
   * when this runs, so a membership record cannot be backdated. Returns the loan
   * with the new member on it. Use createUser first for a person starlink does not
   * hold yet.
   */
  addLoanMember?: Maybe<Loan>;
  /** Mark a loan as delinquent */
  applyLoanDelinquency?: Maybe<DelinquencyResult>;
  /** Approve one parked applicant of an account opening's review (applicantIndex; the sole pending applicant when omitted). The application boards from the stored intake once every applicant is approved; until then the result status is pending_review. A review the identity screener marked deny refuses unless overrideScreenerDeny is true — the verdict is never boarded past blind. */
  approveKycReview?: Maybe<AccountOpening>;
  /** Block or unblock a card */
  blockUnblockCard?: Maybe<Card>;
  /** Cancel an ACH request after proving nonexecution or verifying provider cancellation. */
  cancelAchRequest?: Maybe<AchRequest>;
  /**
   * Terminally retire a card. A Lithic card is closed at the processor; an
   * I2C card is blocked there — the close call is never sent — then frozen
   * at the ledger and retired in our records.
   */
  closeCard?: Maybe<Card>;
  /**
   * Close a loan on the servicer's closure trigger — the call itself is the
   * instruction to close; closure is never inferred from a balance. Only
   * paid-off closures are honored today.
   */
  closeLoan?: Maybe<Loan>;
  closeStatementCycle?: Maybe<Statement>;
  /**
   * Mark a drawdown ACH request as funded by HomeLight, releasing it to the
   * USIO ACH disbursement. Allowed only when the request is in
   * :awaiting_partner_funding. Advances status to :deposit_requested and
   * re-enqueues the AchProcessor so the standard USIO path runs.
   */
  confirmDrawdownFunding?: Maybe<AchRequest>;
  /**
   * Create an admin user (partner_admin or support_agent). Creates the Auth0
   * user inline; super_admin role is not assignable via this mutation.
   */
  createAdminUser?: Maybe<User>;
  /** Create a card activated alert */
  createCardActivatedAlert?: Maybe<Alert>;
  /** Provision a partner: row + Auth0 M2M client + partner_api identity. The clientSecret appears ONLY in this result — it is never stored and cannot be re-read. */
  createPartner?: Maybe<PartnerProvisioningResult>;
  createPrimeRate?: Maybe<PrimeRate>;
  createProgram?: Maybe<Program>;
  /** Create a shadow-ledger program (partner computes the money; no billing config). Primary programs use createProgram. */
  createShadowProgram?: Maybe<Program>;
  /** Create a statement payment due alert */
  createStatementPaymentDueAlert?: Maybe<Alert>;
  /**
   * Creates a customer who is on no loan yet, minting their identity at the
   * identity provider. Attach them to a loan afterwards with addLoanMember.
   */
  createUser?: Maybe<User>;
  /** Cure delinquency for a loan */
  cureLoanDelinquency?: Maybe<DelinquencyResult>;
  deletePrimeRate?: Maybe<PrimeRate>;
  /** Deny one applicant of an account opening that is parked for review, or that its boarding refused (openAccount's error names that intake in extensions.intakeId); applicantIndex, or the sole pending applicant when omitted. Denying any applicant rejects the whole application and releases its partner account number to a new openAccount. */
  denyKycReview?: Maybe<AccountOpening>;
  manageLoanVelocityControl?: Maybe<VelocityControl>;
  /** Mark a physical card as activated using mobile SDK (no I2C call) */
  markPhysicalCardActivated?: Maybe<Card>;
  /**
   * Opens an account on any active program, through the command the partner
   * API runs. KYC is the identity vendor's SCREEN, or the operator's ATTEST
   * (attestationReason required). The card plan is ISSUE — a Lithic card
   * minted for each applicant, refused unless the program mints on its own
   * Lithic instance, and refused with ATTEST where the bank has not signed off
   * on attested KYC (prod today) — or IMPORT: each applicant boards with the
   * card the issuer already gave them, or with none. The SSN may be omitted
   * only for an attested import. Re-submitting the same opening —
   * program, partner account number, choices, applicants, cards and terms —
   * answers the stored one and finishes what it still owes (a card that failed
   * to issue); a changed one is refused, naming the account. A denied account
   * releases its partner account number to a new opening.
   */
  openAccount?: Maybe<AccountOpening>;
  /**
   * Post a repayment that settled outside Strado's ACH rails (e.g. a Homelight wire).
   * Settles to the loan's repayment account and runs the standard allocation waterfall.
   * payment_ref is the idempotency key: a repeat with identical details is a no-op.
   */
  postExternalRepayment?: Maybe<ExternalRepaymentResult>;
  processLateFee?: Maybe<LateFeeProcessingResult>;
  processStatementDueDate?: Maybe<DueDateProcessingResult>;
  /**
   * Generates the statements a loan missed, oldest first, each on the dates it
   * would have carried on time. Dry-run by default: the report names the
   * periods with their boundary balances and the grace verdict at gap entry.
   * Execute only after reading it — the statements it writes reach real
   * members. First sweep any statement of this loan that is past due with no
   * `dueDateProcessedAt`, by running due-date processing with a backdated
   * processing date, so the anchor's deferred charges post into their own
   * historical period rather than today's. The report is advisory: its balances
   * are read at plan time, so a payment or return landing before you execute
   * changes the outcome — the execution re-derives everything. Those balances
   * are also read before the walk posts anything, so every period after the
   * first will close HIGHER than the report shows by the walk's own trailing
   * interest; the executed statements are the truth.
   */
  recoverStatementCycles?: Maybe<RecoverStatementCyclesResult>;
  removeProgram?: Maybe<Program>;
  replaceCard?: Maybe<Card>;
  /**
   * Recalculate a loan over a date window and return classified corrections.
   * Corrections derive from the ledger's own daily balances: a dry run writes nothing and a
   * commit posts exactly what it previewed.
   * Repeating a window whose facts have not changed converges to zero deltas; a re-run
   * after they changed reports its deltas as already posted, so check postedCount.
   * Windows are capped at 3 months.
   */
  replayLoan?: Maybe<ReplayLoanResult>;
  /** Resume an ACH request after verifying its stopped stage or provider outcome. */
  retryAchRequest?: Maybe<AchRequest>;
  /**
   * Set an I2C card's status. The close letter is rejected by policy —
   * terminal retirement owns closing — and a card already at a terminal
   * status refuses further changes.
   */
  setCardStatus?: Maybe<User>;
  /** Save a program cash-access choice and queue its ledger projection. Merchant and country restrictions are mandatory. */
  setProgramMerchantPolicy?: Maybe<Program>;
  updateAdminScope?: Maybe<User>;
  /** Update auto pay settings for a loan */
  updateAutoPaySettingsForLoan?: Maybe<AutoPaySettings>;
  updateLoanAprMargin?: Maybe<Loan>;
  updateLoanCreditLimit?: Maybe<Loan>;
  /** Update a user's spending-control preference on a loan on their behalf. */
  updateLoanManagedSpendingControl?: Maybe<SpendingControl>;
  /** Set where a shadow partner's programs forward to (URLs + per-surface whsec Secrets Manager references). Projected into auth-host's config artifact. */
  updatePartnerForwardConfig?: Maybe<Partner>;
  updatePrimeRate?: Maybe<PrimeRate>;
  updateProgram?: Maybe<Program>;
  updateUser?: Maybe<User>;
  /** Void an existing transaction in the ledger */
  voidTransaction?: Maybe<VoidTransactionPayload>;
};

export type RootMutationTypeAchReturnArgs = {
  achRequestId: Scalars['ID']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  returnCode?: InputMaybe<Scalars['String']['input']>;
  returnType: AchReturnType;
  returnedOn?: InputMaybe<Scalars['Date']['input']>;
};

export type RootMutationTypeActivateCardArgs = {
  referenceId: Scalars['String']['input'];
};

export type RootMutationTypeAddAddressArgs = {
  addressInput?: InputMaybe<AddressInput>;
  userId: Scalars['ID']['input'];
};

export type RootMutationTypeAddFeeTransactionArgs = {
  amountCents: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  effectiveDate: Scalars['String']['input'];
  feeType: Scalars['String']['input'];
  loanId: Scalars['ID']['input'];
};

export type RootMutationTypeAddLoanMemberArgs = {
  cardRef?: InputMaybe<Scalars['String']['input']>;
  lastFour?: InputMaybe<Scalars['String']['input']>;
  loanId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RootMutationTypeApplyLoanDelinquencyArgs = {
  loanId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type RootMutationTypeApproveKycReviewArgs = {
  applicantIndex?: InputMaybe<Scalars['Int']['input']>;
  intakeId: Scalars['ID']['input'];
  overrideScreenerDeny?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RootMutationTypeBlockUnblockCardArgs = {
  action: BlockUnblockCardAction;
  blockReason?: InputMaybe<Scalars['String']['input']>;
  cardId: Scalars['ID']['input'];
};

export type RootMutationTypeCancelAchRequestArgs = {
  achRequestId: Scalars['ID']['input'];
  evidence?: InputMaybe<Scalars['String']['input']>;
  expectedVersion: Scalars['Int']['input'];
  providerCancellationConfirmation?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type RootMutationTypeCloseCardArgs = {
  cardId: Scalars['ID']['input'];
};

export type RootMutationTypeCloseLoanArgs = {
  effectiveDate: Scalars['Date']['input'];
  loanId: Scalars['ID']['input'];
  reason: LoanClosureReason;
  requestedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type RootMutationTypeCloseStatementCycleArgs = {
  closeStatementCycleOptions?: InputMaybe<CloseStatementCycleOptions>;
  loanId: Scalars['ID']['input'];
};

export type RootMutationTypeConfirmDrawdownFundingArgs = {
  achRequestId: Scalars['ID']['input'];
};

export type RootMutationTypeCreateAdminUserArgs = {
  input: CreateAdminUserInput;
};

export type RootMutationTypeCreateCardActivatedAlertArgs = {
  userId: Scalars['ID']['input'];
};

export type RootMutationTypeCreatePartnerArgs = {
  input: CreatePartnerInput;
};

export type RootMutationTypeCreatePrimeRateArgs = {
  input: CreatePrimeRateInput;
};

export type RootMutationTypeCreateProgramArgs = {
  input: CreateProgramInput;
};

export type RootMutationTypeCreateShadowProgramArgs = {
  input: CreateShadowProgramInput;
};

export type RootMutationTypeCreateStatementPaymentDueAlertArgs = {
  userId: Scalars['ID']['input'];
};

export type RootMutationTypeCreateUserArgs = {
  user: UserInput;
};

export type RootMutationTypeCureLoanDelinquencyArgs = {
  loanId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type RootMutationTypeDeletePrimeRateArgs = {
  id: Scalars['ID']['input'];
};

export type RootMutationTypeDenyKycReviewArgs = {
  applicantIndex?: InputMaybe<Scalars['Int']['input']>;
  intakeId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type RootMutationTypeManageLoanVelocityControlArgs = {
  action: VelocityControlAction;
  loanId: Scalars['ID']['input'];
  velocityControlId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypeMarkPhysicalCardActivatedArgs = {
  referenceId: Scalars['String']['input'];
};

export type RootMutationTypeOpenAccountArgs = {
  input: AccountOpeningInput;
};

export type RootMutationTypePostExternalRepaymentArgs = {
  amountCents: Scalars['Int']['input'];
  effectiveDate: Scalars['Date']['input'];
  loanId: Scalars['ID']['input'];
  paymentRef: Scalars['String']['input'];
  statementDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RootMutationTypeProcessLateFeeArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  loanId: Scalars['ID']['input'];
};

export type RootMutationTypeProcessStatementDueDateArgs = {
  dueDateOptions?: InputMaybe<DueDateOptions>;
  loanId: Scalars['ID']['input'];
};

export type RootMutationTypeRecoverStatementCyclesArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  loanId: Scalars['ID']['input'];
};

export type RootMutationTypeRemoveProgramArgs = {
  programId: Scalars['ID']['input'];
};

export type RootMutationTypeReplaceCardArgs = {
  addressInput?: InputMaybe<AddressInput>;
  expedited?: InputMaybe<Scalars['Boolean']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  replaceCardType?: InputMaybe<ReplaceCardType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RootMutationTypeReplayLoanArgs = {
  accrualBase?: InputMaybe<AccrualBase>;
  dryRun: Scalars['Boolean']['input'];
  fromDate: Scalars['Date']['input'];
  loanId: Scalars['ID']['input'];
  skipDelinquency?: InputMaybe<Scalars['Boolean']['input']>;
  toDate: Scalars['Date']['input'];
};

export type RootMutationTypeRetryAchRequestArgs = {
  achRequestId: Scalars['ID']['input'];
  confirmation?: InputMaybe<Scalars['String']['input']>;
  expectedVersion: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

export type RootMutationTypeSetCardStatusArgs = {
  description: Scalars['String']['input'];
  referenceId: Scalars['ID']['input'];
  statusCode: Scalars['String']['input'];
};

export type RootMutationTypeSetProgramMerchantPolicyArgs = {
  cashAdvancesAllowed: Scalars['Boolean']['input'];
  programId: Scalars['ID']['input'];
};

export type RootMutationTypeUpdateAdminScopeArgs = {
  input: UpdateAdminScopeInput;
};

export type RootMutationTypeUpdateAutoPaySettingsForLoanArgs = {
  input: AutoPaySettingsInput;
  loanId: Scalars['ID']['input'];
};

export type RootMutationTypeUpdateLoanAprMarginArgs = {
  aprMargin: Scalars['Decimal']['input'];
  loanId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type RootMutationTypeUpdateLoanCreditLimitArgs = {
  creditLimit: Scalars['Int']['input'];
  loanId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type RootMutationTypeUpdateLoanManagedSpendingControlArgs = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  enabled: Scalars['Boolean']['input'];
  granularity: SpendingGranularity;
  loanId: Scalars['ID']['input'];
  type: SpendingControlType;
};

export type RootMutationTypeUpdatePartnerForwardConfigArgs = {
  input: UpdatePartnerForwardConfigInput;
};

export type RootMutationTypeUpdatePrimeRateArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePrimeRateInput;
};

export type RootMutationTypeUpdateProgramArgs = {
  input: UpdateProgramInput;
  programId: Scalars['ID']['input'];
};

export type RootMutationTypeUpdateUserArgs = {
  dob?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  ssnItin?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type RootMutationTypeVoidTransactionArgs = {
  transactionId: Scalars['ID']['input'];
};

export type RootQueryType = {
  adminActionRecordsByActor?: Maybe<ListAdminActionRecordsResult>;
  adminActionRecordsForUser?: Maybe<ListAdminActionRecordsResult>;
  card?: Maybe<Card>;
  /** Get credit utilization details for a specific loan from Twisp */
  creditUtilization?: Maybe<CreditUtilizationData>;
  /** Get the currently signed-in user */
  currentUser?: Maybe<User>;
  getCardStatus?: Maybe<Scalars['String']['output']>;
  getPrimeRateAsOf?: Maybe<PrimeRate>;
  ledgerBalances?: Maybe<LedgerBalancesData>;
  /** Get a single ledger transaction entry by Twisp entry ID */
  ledgerTransaction?: Maybe<LedgerTransactionDetail>;
  /** Get global ledger transactions, optionally scoped to a loan or ledger account */
  ledgerTransactions?: Maybe<LedgerTransactionsList>;
  listAchRequests?: Maybe<ListAchRequestsResult>;
  listAdminActionRecords?: Maybe<ListAdminActionRecordsResult>;
  listCards?: Maybe<ListCardsResult>;
  listDevices?: Maybe<ListDevicesResult>;
  listDisputes?: Maybe<ListDisputesResult>;
  listLoans?: Maybe<ListLoansResult>;
  /** All partners — the id feeds createProgram's partnerId. */
  listPartners?: Maybe<Array<Maybe<Partner>>>;
  listPrimeRates?: Maybe<Array<Maybe<PrimeRate>>>;
  listPrograms?: Maybe<ListProgramsResult>;
  /** Run history for one reconciliation check, newest first. */
  listReconciliationRuns: Array<ReconciliationRun>;
  listStatements?: Maybe<ListStatementsResult>;
  listUsers?: Maybe<ListUsersResult>;
  listVelocityControls?: Maybe<Array<Maybe<VelocityControl>>>;
  loan?: Maybe<Loan>;
  loanAchRequests?: Maybe<ListAchRequestsResult>;
  loanAutoPaySettings?: Maybe<AutoPaySettings>;
  loanDailyReports?: Maybe<Array<Maybe<DailyReport>>>;
  loanDisputes?: Maybe<ListDisputesResult>;
  /** List a loan's configured spending-control preferences (enforced on the loan's card account). */
  loanManagedSpendingControls: Array<SpendingControl>;
  loanStatements: Array<Statement>;
  /** Get a loan's transaction details from Twisp with merchant data */
  loanTransactions?: Maybe<UserTransactionsList>;
  loanVelocityControls?: Maybe<Array<Maybe<VelocityControl>>>;
  loansWithoutServicingData: Array<LoanWithoutServicingData>;
  /** An account opening's application as stored, for the reviewer: applicants (SSN as its last four), whether each is a returning customer and why the application is held, and every decision row. */
  partnerAccountIntake?: Maybe<PartnerAccountIntake>;
  /**
   * Drawdowns awaiting HomeLight to fund the USIO account, oldest first.
   * Manual-funding bridge: ops calls confirm_drawdown_funding once HL has
   * funded, which releases the USIO ACH.
   */
  pendingDrawdowns: Array<AchRequest>;
  platformBalances?: Maybe<PlatformBalancesData>;
  program?: Maybe<Program>;
  /** Every registered reconciliation check with its most recent nightly run. */
  reconciliationStatus: Array<ReconciliationCheckStatus>;
  /** Generate account state CSV for a date */
  reportAccountStateCsv?: Maybe<Scalars['String']['output']>;
  /** Get available report dates */
  reportDates?: Maybe<Array<Maybe<Scalars['Date']['output']>>>;
  /** The settlement records Lithic reported for a program's cards on a report date, as the daily pull stored them: the newest complete version of that day, a row per record */
  reportLithicSettlementCsv?: Maybe<Scalars['String']['output']>;
  /** The payments remittance CSV of a program: its settled repayments over a settlement-day range, both ends inclusive, read live from the ledger */
  reportPaymentsRemittanceCsv?: Maybe<Scalars['String']['output']>;
  /** Generate transactions CSV for a date */
  reportTransactionsCsv?: Maybe<Scalars['String']['output']>;
  statement?: Maybe<Statement>;
  /** Get user by id */
  user?: Maybe<User>;
  userAchAuthorizations?: Maybe<ListAchAuthorizationsResult>;
  usioPrefundingBalance: UsioPrefundingBalance;
};

export type RootQueryTypeAdminActionRecordsByActorArgs = {
  actorId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type RootQueryTypeAdminActionRecordsForUserArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  userId: Scalars['ID']['input'];
};

export type RootQueryTypeCardArgs = {
  cardId: Scalars['ID']['input'];
};

export type RootQueryTypeCreditUtilizationArgs = {
  loanId: Scalars['ID']['input'];
};

export type RootQueryTypeGetCardStatusArgs = {
  referenceId: Scalars['ID']['input'];
};

export type RootQueryTypeGetPrimeRateAsOfArgs = {
  asOfDate: Scalars['Date']['input'];
};

export type RootQueryTypeLedgerBalancesArgs = {
  loanId: Scalars['ID']['input'];
};

export type RootQueryTypeLedgerTransactionArgs = {
  entryId: Scalars['ID']['input'];
};

export type RootQueryTypeLedgerTransactionsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  directions?: InputMaybe<Array<InputMaybe<PaymentDirection>>>;
  entryScope?: InputMaybe<LedgerTransactionEntryScope>;
  entryTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  layers?: InputMaybe<Array<InputMaybe<LedgerEntryLayer>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  loanId?: InputMaybe<Scalars['ID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  rawTranCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  settled?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<LedgerTransactionStatus>>>;
  to?: InputMaybe<Scalars['Date']['input']>;
  viewMode?: InputMaybe<TransactionViewMode>;
};

export type RootQueryTypeListAchRequestsArgs = {
  achTypeSelections?: InputMaybe<Array<InputMaybe<AchRequestType>>>;
  achTypeSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  loanId?: InputMaybe<Scalars['ID']['input']>;
  loanIdSearch?: InputMaybe<Scalars['String']['input']>;
  loanIdSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  settled?: InputMaybe<Scalars['Boolean']['input']>;
  statusSelections?: InputMaybe<Array<InputMaybe<AchRequestStatus>>>;
  statusSortDirection?: InputMaybe<SortDirection>;
};

export type RootQueryTypeListAdminActionRecordsArgs = {
  actionSearch?: InputMaybe<Scalars['String']['input']>;
  actionSortDirection?: InputMaybe<SortDirection>;
  actorEmailSearch?: InputMaybe<Scalars['String']['input']>;
  actorFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  actorId?: InputMaybe<Scalars['ID']['input']>;
  actorLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  idSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  loanId?: InputMaybe<Scalars['ID']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
};

export type RootQueryTypeListCardsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  idSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  referenceIdSearch?: InputMaybe<Scalars['String']['input']>;
  referenceIdSortDirection?: InputMaybe<SortDirection>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  statusSelections?: InputMaybe<Array<InputMaybe<CardStatus>>>;
  statusSortDirection?: InputMaybe<SortDirection>;
  to?: InputMaybe<Scalars['Date']['input']>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userFirstNameSortDirection?: InputMaybe<SortDirection>;
  userIsFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSortDirection?: InputMaybe<SortDirection>;
};

export type RootQueryTypeListDevicesArgs = {
  deviceTypeSelections?: InputMaybe<Array<InputMaybe<DeviceType>>>;
  deviceTypeSortDirection?: InputMaybe<SortDirection>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  tokenSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userFirstNameSortDirection?: InputMaybe<SortDirection>;
  userIdSearch?: InputMaybe<Scalars['String']['input']>;
  userIdSortDirection?: InputMaybe<SortDirection>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSortDirection?: InputMaybe<SortDirection>;
};

export type RootQueryTypeListDisputesArgs = {
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  statusSelections?: InputMaybe<Array<InputMaybe<DisputeStatus>>>;
  statusSortDirection?: InputMaybe<SortDirection>;
};

export type RootQueryTypeListLoansArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  hasPromo?: InputMaybe<Scalars['Boolean']['input']>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  idSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  partnerAccountNumberSearch?: InputMaybe<Scalars['String']['input']>;
  partnerAccountNumberSortDirection?: InputMaybe<SortDirection>;
  programIdSearch?: InputMaybe<Scalars['String']['input']>;
  programIdSortDirection?: InputMaybe<SortDirection>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  statusSelections?: InputMaybe<Array<InputMaybe<LoanStatus>>>;
  statusSortDirection?: InputMaybe<SortDirection>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type RootQueryTypeListProgramsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  idSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  nameSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

export type RootQueryTypeListReconciliationRunsArgs = {
  check: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
};

export type RootQueryTypeListStatementsArgs = {
  creditLimitSortDirection?: InputMaybe<SortDirection>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  idSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  loanId?: InputMaybe<Scalars['ID']['input']>;
  loanIdSearch?: InputMaybe<Scalars['String']['input']>;
  loanIdSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type RootQueryTypeListUsersArgs = {
  adminProgramIdSearch?: InputMaybe<Scalars['String']['input']>;
  adminProgramIdSortDirection?: InputMaybe<SortDirection>;
  dobSearch?: InputMaybe<Scalars['String']['input']>;
  dobSortDirection?: InputMaybe<SortDirection>;
  firstNameSearch?: InputMaybe<Scalars['String']['input']>;
  firstNameSortDirection?: InputMaybe<SortDirection>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  idSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  isFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  lastNameSearch?: InputMaybe<Scalars['String']['input']>;
  lastNameSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  phoneSearch?: InputMaybe<Scalars['String']['input']>;
  phoneSortDirection?: InputMaybe<SortDirection>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  roleSelections?: InputMaybe<Array<InputMaybe<UserRole>>>;
  roleSortDirection?: InputMaybe<SortDirection>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type RootQueryTypeLoanArgs = {
  id: Scalars['ID']['input'];
};

export type RootQueryTypeLoanAchRequestsArgs = {
  achTypeSelections?: InputMaybe<Array<InputMaybe<AchRequestType>>>;
  achTypeSortDirection?: InputMaybe<SortDirection>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  loanId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  settled?: InputMaybe<Scalars['Boolean']['input']>;
  statusSelections?: InputMaybe<Array<InputMaybe<AchRequestStatus>>>;
  statusSortDirection?: InputMaybe<SortDirection>;
};

export type RootQueryTypeLoanAutoPaySettingsArgs = {
  loanId: Scalars['ID']['input'];
};

export type RootQueryTypeLoanDailyReportsArgs = {
  loanId: Scalars['ID']['input'];
};

export type RootQueryTypeLoanDisputesArgs = {
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  loanId: Scalars['ID']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  statusSelections?: InputMaybe<Array<InputMaybe<DisputeStatus>>>;
  statusSortDirection?: InputMaybe<SortDirection>;
};

export type RootQueryTypeLoanManagedSpendingControlsArgs = {
  loanId: Scalars['ID']['input'];
};

export type RootQueryTypeLoanStatementsArgs = {
  loanId: Scalars['ID']['input'];
};

export type RootQueryTypeLoanTransactionsArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  loanId: Scalars['ID']['input'];
  paymentDirection?: InputMaybe<PaymentDirection>;
  sortDirection?: InputMaybe<SortDirection>;
  to?: InputMaybe<Scalars['Date']['input']>;
  viewMode?: InputMaybe<TransactionViewMode>;
};

export type RootQueryTypeLoanVelocityControlsArgs = {
  loanId: Scalars['ID']['input'];
};

export type RootQueryTypeLoansWithoutServicingDataArgs = {
  programId: Scalars['ID']['input'];
};

export type RootQueryTypePartnerAccountIntakeArgs = {
  intakeId: Scalars['ID']['input'];
};

export type RootQueryTypePlatformBalancesArgs = {
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  programId: Scalars['ID']['input'];
};

export type RootQueryTypeProgramArgs = {
  programId: Scalars['ID']['input'];
};

export type RootQueryTypeReportAccountStateCsvArgs = {
  date: Scalars['Date']['input'];
};

export type RootQueryTypeReportLithicSettlementCsvArgs = {
  programId: Scalars['ID']['input'];
  reportDate: Scalars['Date']['input'];
};

export type RootQueryTypeReportPaymentsRemittanceCsvArgs = {
  from: Scalars['Date']['input'];
  programId: Scalars['ID']['input'];
  to: Scalars['Date']['input'];
};

export type RootQueryTypeReportTransactionsCsvArgs = {
  date: Scalars['Date']['input'];
};

export type RootQueryTypeStatementArgs = {
  id: Scalars['ID']['input'];
};

export type RootQueryTypeUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RootQueryTypeUserAchAuthorizationsArgs = {
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  recordTypeSelections?: InputMaybe<Array<InputMaybe<AchAuthorizationRecordType>>>;
  recordTypeSortDirection?: InputMaybe<SortDirection>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  statusSelections?: InputMaybe<Array<InputMaybe<AchAuthorizationStatus>>>;
  statusSortDirection?: InputMaybe<SortDirection>;
  userId: Scalars['ID']['input'];
};

export type RootQueryTypeUsioPrefundingBalanceArgs = {
  programId: Scalars['ID']['input'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type SpendingControl = {
  amountCents: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  granularity?: Maybe<SpendingGranularity>;
  status: SpendingControlStatus;
  type: SpendingControlType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Persisted state of a user spending control. Mutations are saga-atomic with
 * Twisp (writes happen inside an Ecto.Multi alongside the Twisp attach/detach),
 * so there is no `FAILED_TO_SYNC`-equivalent state — a Twisp failure rolls the
 * whole transaction back and the caller receives a GraphQL error on the
 * mutation. Surface sync failures from mutation errors, not from this enum.
 */
export enum SpendingControlStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
}

export enum SpendingControlType {
  SpendingLimit = 'SPENDING_LIMIT',
}

export enum SpendingGranularity {
  Day = 'DAY',
  Month = 'MONTH',
}

export type Statement = {
  autopayProcessedAt?: Maybe<Scalars['String']['output']>;
  /** Average daily balance subject to interest rate for the billing period — the base (per the program's accrual_base setting) the periodic rate was applied to, in cents. */
  averageDailyBalance?: Maybe<Scalars['Int']['output']>;
  billingPeriodEnd: Scalars['String']['output'];
  billingPeriodStart: Scalars['String']['output'];
  cashAdvance: Scalars['String']['output'];
  closingBalance?: Maybe<Scalars['String']['output']>;
  creditLimit: Scalars['String']['output'];
  creditLimitAvailable: Scalars['String']['output'];
  drawdownBalanceAtPeriodEnd?: Maybe<Scalars['Int']['output']>;
  dueDate: Scalars['String']['output'];
  dueDateProcessedAt?: Maybe<Scalars['String']['output']>;
  feeBalanceAtPeriodEnd?: Maybe<Scalars['Int']['output']>;
  feesCharged: Scalars['String']['output'];
  graceActive?: Maybe<Scalars['Boolean']['output']>;
  graceSavings?: Maybe<Scalars['Int']['output']>;
  hasPdf?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['String']['output'];
  interestApplied?: Maybe<Scalars['String']['output']>;
  interestBalanceAtPeriodEnd?: Maybe<Scalars['Int']['output']>;
  interestCharged: Scalars['String']['output'];
  lateFeeApplied?: Maybe<Scalars['String']['output']>;
  lateFeeEligibleOn?: Maybe<Scalars['String']['output']>;
  lateFeeProcessedAt?: Maybe<Scalars['String']['output']>;
  loan?: Maybe<Loan>;
  minimumPaymentDue: Scalars['String']['output'];
  newBalance: Scalars['String']['output'];
  newPurchaseBalanceAtPeriodEnd?: Maybe<Scalars['Int']['output']>;
  otherCredits: Scalars['String']['output'];
  pdfDataSnapshot?: Maybe<Scalars['Json']['output']>;
  pdfFilename?: Maybe<Scalars['String']['output']>;
  pdfGeneratedAt?: Maybe<Scalars['String']['output']>;
  previousBalance: Scalars['String']['output'];
  previousBalancePaidInFull?: Maybe<Scalars['Boolean']['output']>;
  purchaseBalanceAtPeriodEnd?: Maybe<Scalars['Int']['output']>;
  repaymentBalanceAtPeriodEnd?: Maybe<Scalars['Int']['output']>;
  statementDate?: Maybe<Scalars['String']['output']>;
  totalPayments: Scalars['String']['output'];
  totalPurchases: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  ytdFeesCharged: Scalars['String']['output'];
  ytdInterestCharged: Scalars['String']['output'];
};

export type TransactionBalance = {
  encumbrance?: Maybe<Scalars['String']['output']>;
  pending?: Maybe<Scalars['String']['output']>;
  settled?: Maybe<Scalars['String']['output']>;
};

export type TransactionDetailsSuperAdmin = {
  accountId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['String']['output']>;
  correlationId?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  entryId?: Maybe<Scalars['ID']['output']>;
  entryType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  journalId?: Maybe<Scalars['ID']['output']>;
  layer?: Maybe<Scalars['String']['output']>;
  loanId?: Maybe<Scalars['ID']['output']>;
  merchantDetails?: Maybe<MerchantDetails>;
  metadata?: Maybe<Scalars['Json']['output']>;
  rawTranCode?: Maybe<Scalars['String']['output']>;
  statementDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tranCode?: Maybe<Scalars['String']['output']>;
  transactionBalance?: Maybe<TransactionBalance>;
  transactionId?: Maybe<Scalars['ID']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  transmissionDate?: Maybe<Scalars['String']['output']>;
};

/** View mode for transaction queries */
export enum TransactionViewMode {
  /** Client view - same as mobile app (filters internal transactions) */
  Client = 'CLIENT',
  /** Ledger view - all transactions unfiltered */
  Ledger = 'LEDGER',
}

export type UpdateAdminScopeInput = {
  adminProgramId?: InputMaybe<Scalars['ID']['input']>;
  partnerId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdatePartnerForwardConfigInput = {
  forwardDecisionUrl?: InputMaybe<Scalars['String']['input']>;
  forwardDecisionWhsecRef?: InputMaybe<Scalars['String']['input']>;
  forwardDisputesUrl?: InputMaybe<Scalars['String']['input']>;
  forwardDisputesWhsecRef?: InputMaybe<Scalars['String']['input']>;
  forwardEventsUrl?: InputMaybe<Scalars['String']['input']>;
  forwardEventsWhsecRef?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['ID']['input'];
};

export type UpdatePrimeRateInput = {
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  rate?: InputMaybe<Scalars['Decimal']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgramInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The autopay payment types members may enrol in: minimum, statement, full. */
  autopayPaymentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  cashAdvanceMccs?: InputMaybe<Array<Scalars['String']['input']>>;
  chargeDrawdownFee?: InputMaybe<Scalars['Boolean']['input']>;
  firstLateFeeAmount?: InputMaybe<Scalars['Int']['input']>;
  foreignTransactionFeeRate?: InputMaybe<Scalars['Decimal']['input']>;
  /** Grace window in days after the payment due date. Late fees can first be assessed the following day (7 means day 8; 10 means day 11). Zero means no deferral. */
  lateFeeGracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  lithicCardProgramToken?: InputMaybe<Scalars['String']['input']>;
  lithicSettlementAccountId?: InputMaybe<Scalars['ID']['input']>;
  maxApr?: InputMaybe<Scalars['Decimal']['input']>;
  minApr?: InputMaybe<Scalars['Decimal']['input']>;
  minimumPaymentFloorCents?: InputMaybe<Scalars['Int']['input']>;
  minimumPaymentRate?: InputMaybe<Scalars['Decimal']['input']>;
  minimumPaymentStrategy?: InputMaybe<MinimumPaymentStrategy>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Minimum days from statement period end to payment due date across every month. */
  paymentDueDateGracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  paymentDueDay?: InputMaybe<Scalars['Int']['input']>;
  pdfTemplate?: InputMaybe<PdfTemplate>;
  replacementCardFeeCents?: InputMaybe<Scalars['Int']['input']>;
  returnedPaymentFeeCents?: InputMaybe<Scalars['Int']['input']>;
  statementGenerateDay?: InputMaybe<Scalars['Int']['input']>;
  subsequentLateFeeAmount?: InputMaybe<Scalars['Int']['input']>;
  targetInterestRate?: InputMaybe<Scalars['Decimal']['input']>;
  twispExposureAccountSetId?: InputMaybe<Scalars['ID']['input']>;
  twispIsoConfigId?: InputMaybe<Scalars['ID']['input']>;
  twispJournalId?: InputMaybe<Scalars['ID']['input']>;
};

export type User = {
  /** @deprecated user billingAddress, shippingAddress, or addresses */
  address?: Maybe<Address>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  adminProgram?: Maybe<Program>;
  adminProgramId?: Maybe<Scalars['ID']['output']>;
  alerts: Array<Alert>;
  billingAddress?: Maybe<Address>;
  cardEvents: Array<CardEvent>;
  cards?: Maybe<Array<Maybe<Card>>>;
  displayName?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  isFriendsAndFam?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lithicAccountToken?: Maybe<Scalars['String']['output']>;
  loanEvents: Array<LoanEvent>;
  loans: Array<Loan>;
  middleName?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Partner>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRole>;
  shippingAddress?: Maybe<Address>;
  unhandledAlertsCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userEvents?: Maybe<Array<Maybe<UserEvent>>>;
};

export type UserEvent = {
  actor?: Maybe<User>;
  details?: Maybe<Scalars['Json']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

/** A person on their own, with no loan attached yet. */
export type UserInput = {
  addressInput: AddressInput;
  dob?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Required: the identity provider keys the person's identity on their phone. */
  phone: Scalars['String']['input'];
};

export enum UserRole {
  Other = 'OTHER',
  PartnerAdmin = 'PARTNER_ADMIN',
  PartnerApi = 'PARTNER_API',
  SuperAdmin = 'SUPER_ADMIN',
  SupportAgent = 'SUPPORT_AGENT',
  User = 'USER',
}

export type UserTransactionsList = {
  balance?: Maybe<BalanceDetails>;
  balanceRaw?: Maybe<BalanceRawDetails>;
  transactions?: Maybe<Array<Maybe<TransactionDetailsSuperAdmin>>>;
};

export type UsioPrefundingBalance = {
  achPrefundingBalance: Scalars['Float']['output'];
  pinlessPrefundingBalance?: Maybe<Scalars['Float']['output']>;
  rtpPrefundingBalance?: Maybe<Scalars['Float']['output']>;
};

export type VelocityControl = {
  /** Twisp account this control is attached to (loan account or card-spend account). */
  accountId?: Maybe<Scalars['ID']['output']>;
  /** Which kind of user-level account this control is attached to: 'loan' or 'card_spend'. */
  accountKind?: Maybe<Scalars['String']['output']>;
  condition?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enforcementAction?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  journalId?: Maybe<Scalars['ID']['output']>;
  limits?: Maybe<Array<Maybe<VelocityLimit>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum VelocityControlAction {
  Attach = 'ATTACH',
  Detach = 'DETACH',
}

export type VelocityLimit = {
  amount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  layer?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  normalBalanceType?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type VoidTransactionPayload = {
  transactionId: Scalars['String']['output'];
};

export type BasicAddressFragmentFragment = {
  id?: string | null;
  addressFirstLine?: string | null;
  addressSecondLine?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
};

export type BasicUserFragmentFragment = {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  displayName?: string | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
  middleName?: string | null;
  phone?: string | null;
  dob?: string | null;
  isFriendsAndFam?: boolean | null;
  role?: UserRole | null;
  unhandledAlertsCount?: number | null;
};

export type BasicLoanFragmentFragment = {
  id: string;
  statementDay?: number | null;
  paymentDueDay?: number | null;
  partnerAccountNumber?: string | null;
  creditLimit?: number | null;
  initialBalance?: number | null;
  originationDate?: any | null;
  promoEndDate?: any | null;
  aprMargin?: string | null;
  initialApr?: string | null;
  isVariableApr?: boolean | null;
  status?: LoanStatus | null;
  delinquentSince?: any | null;
  daysDelinquent?: number | null;
  isDelinquent?: boolean | null;
  closedAt?: any | null;
  programId?: string | null;
  twispLoanId?: string | null;
  twispFeesId?: string | null;
  twispRepaymentId?: string | null;
  twispCardAccountSetId?: string | null;
  twispCardSpendSetId?: string | null;
  twispCardFeesId?: string | null;
  twispCardInterestId?: string | null;
  twispCreditLineAccountSetId?: string | null;
  twispCreditLineSpendId?: string | null;
  twispCreditLineFeesId?: string | null;
  twispCreditLineInterestId?: string | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
};

export type BasicCardFragmentFragment = {
  id?: string | null;
  status?: CardStatus | null;
  active?: boolean | null;
  referenceId?: string | null;
  processor?: CardProcessor | null;
  dateOpened?: any | null;
  blockedReason?: string | null;
  version?: number | null;
  lastFour?: string | null;
  expDate?: string | null;
  physicalActivatedAt?: any | null;
  insertedAt?: any | null;
};

export type BasicFeeTransactionFragmentFragment = { transactionId: string };

export type BasicStatementFragmentFragment = {
  id: string;
  billingPeriodStart: string;
  billingPeriodEnd: string;
  dueDate: string;
  previousBalance: string;
  totalPayments: string;
  otherCredits: string;
  totalPurchases: string;
  cashAdvance: string;
  interestCharged: string;
  feesCharged: string;
  newBalance: string;
  creditLimit: string;
  creditLimitAvailable: string;
  minimumPaymentDue: string;
  ytdFeesCharged: string;
  ytdInterestCharged: string;
  closingBalance?: string | null;
  interestApplied?: string | null;
  lateFeeApplied?: string | null;
  pdfFilename?: string | null;
  hasPdf?: boolean | null;
  pdfDataSnapshot?: unknown | null;
  purchaseBalanceAtPeriodEnd?: number | null;
  drawdownBalanceAtPeriodEnd?: number | null;
  interestBalanceAtPeriodEnd?: number | null;
  feeBalanceAtPeriodEnd?: number | null;
  repaymentBalanceAtPeriodEnd?: number | null;
  averageDailyBalance?: number | null;
  graceSavings?: number | null;
  newPurchaseBalanceAtPeriodEnd?: number | null;
  statementDate?: string | null;
  graceActive?: boolean | null;
  previousBalancePaidInFull?: boolean | null;
  lateFeeEligibleOn?: string | null;
  dueDateProcessedAt?: string | null;
  lateFeeProcessedAt?: string | null;
  autopayProcessedAt?: string | null;
  pdfGeneratedAt?: string | null;
  insertedAt: string;
  updatedAt: string;
  loan?: { id: string; partnerAccountNumber?: string | null } | null;
};

export type BasicPaginationFragmentFragment = { totalRecords: number; pageNumber: number; hasNextPage: boolean };

export type BasicAlertFragmentFragment = {
  id: string;
  type: string;
  details?: unknown | null;
  handled: boolean;
  insertedAt?: any | null;
  updatedAt?: any | null;
};

export type BaseBalanceRawItemFragment = { cr?: string | null; dr?: string | null; normal?: string | null };

export type BaseBalanceRawDetailsFragment = {
  available?: { cr?: string | null; dr?: string | null; normal?: string | null } | null;
  encumbrance?: { cr?: string | null; dr?: string | null; normal?: string | null } | null;
  pending?: { cr?: string | null; dr?: string | null; normal?: string | null } | null;
  settled?: { cr?: string | null; dr?: string | null; normal?: string | null } | null;
};

export type BaseBalanceDetailsFragment = {
  availableEncumbrance?: string | null;
  availablePending?: string | null;
  availableSettled?: string | null;
  pending?: string | null;
};

export type BaseMerchantDetailsFragment = {
  name?: string | null;
  city?: string | null;
  region?: string | null;
  displayName?: string | null;
};

export type BaseTransactionBalanceFragment = {
  encumbrance?: string | null;
  pending?: string | null;
  settled?: string | null;
};

export type BaseCreditUtilizationFragment = {
  limit: string;
  balance: string;
  availableAmount: string;
  spent: string;
  remaining: string;
};

export type BaseAchRequestFragment = {
  lockVersion?: number | null;
  parkedFromStatus?: string | null;
  inFlight: boolean;
  id: string;
  userId?: string | null;
  plaidAccountId?: string | null;
  achType?: string | null;
  status?: string | null;
  returnCode?: string | null;
  amountCents?: number | null;
  usioConfirmation?: string | null;
  failureReason?: string | null;
  settledAt?: any | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
  ledgerRefId?: string | null;
  recovery?: { retry: boolean; cancel: boolean; blockedReason?: string | null } | null;
  loan?: { id: string } | null;
  user?: { id?: string | null; firstName?: string | null; lastName?: string | null; email?: string | null } | null;
};

export type BaseAchEventFragment = {
  id: string;
  authCode?: string | null;
  avsCode?: string | null;
  batchNumber?: string | null;
  finalStatus?: string | null;
  errorMessage?: string | null;
  details?: unknown | null;
  achRequestId?: string | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
};

export type BaseVelocityControlFragment = {
  id?: string | null;
  name?: string | null;
  journalId?: string | null;
  description?: string | null;
  condition?: string | null;
  enforcementAction?: string | null;
  accountId?: string | null;
  accountKind?: string | null;
};

export type BaseVelocityLimitFragment = {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  currency?: string | null;
  layer?: string | null;
  amount?: string | null;
  normalBalanceType?: string | null;
  start?: string | null;
  end?: string | null;
};

export type BaseUserEventFragmentFragment = {
  id?: string | null;
  type?: string | null;
  details?: unknown | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
};

export type BaseLoanEventFragmentFragment = {
  id?: string | null;
  type?: string | null;
  details?: unknown | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
};

export type BaseCardEventFragmentFragment = {
  id?: string | null;
  type?: string | null;
  details?: unknown | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
};

export type BaseDueDateProcessingResultFragment = {
  paymentType?: string | null;
  paymentAmount?: string | null;
  interestApplied?: string | null;
  lateFeeApplied?: string | null;
  isDelinquent?: boolean | null;
  remainingBalance?: string | null;
  daysDelinquent?: number | null;
};

export type BaseDailyReportFragment = {
  id?: string | null;
  reportDate?: any | null;
  latestBalance?: number | null;
  lastPaymentAmount?: number | null;
  lastPaymentDate?: any | null;
  creditLimit?: number | null;
  loanBalance?: number | null;
  repaymentBalance?: number | null;
  feesBalance?: number | null;
  cardSetBalance?: number | null;
  cardSpendBalance?: number | null;
  cardFeesBalance?: number | null;
  cardInterestBalance?: number | null;
  creditLineSetBalance?: number | null;
  creditLineSpendBalance?: number | null;
  creditLineFeesBalance?: number | null;
  creditLineInterestBalance?: number | null;
  recalculationReason?: string | null;
  recalculationBatchId?: string | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
};

export type BaseProgramFragmentFragment = {
  id: string;
  name: string;
  targetInterestRate?: string | null;
  minApr?: string | null;
  maxApr?: string | null;
  firstLateFeeAmount?: number | null;
  subsequentLateFeeAmount?: number | null;
  lateFeeStrategy?: LateFeeStrategy | null;
  returnedPaymentFeeCents?: number | null;
  returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
  foreignTransactionFeeRate?: any | null;
  cashAdvancesAllowed?: boolean | null;
  cashAdvanceFeeRate?: any | null;
  cashAdvanceFeeMinCents?: number | null;
  replacementCardFeeCents?: number | null;
  autopayPaymentTypes?: Array<string> | null;
  paymentDueDateGracePeriodDays?: number | null;
  lateFeeGracePeriodDays?: number | null;
  paymentDueDay?: number | null;
  statementGenerateDay?: number | null;
  minimumPaymentStrategy?: MinimumPaymentStrategy | null;
  minimumPaymentRate?: any | null;
  minimumPaymentFloorCents?: number | null;
  minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
  minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
  graceStrategy?: GraceStrategy | null;
  accrualBase?: AccrualBase | null;
  interestPostingPolicy?: InterestPostingPolicy | null;
  pdfTemplate?: PdfTemplate | null;
  chargeDrawdownFee?: boolean | null;
  twispJournalId?: string | null;
  twispIsoConfigId?: string | null;
  twispExposureAccountSetId?: string | null;
  lithicCardProgramToken?: string | null;
  lithicProductId?: string | null;
  active: boolean;
  insertedAt: any;
  updatedAt: any;
  partner: { id: string; name: string; active: boolean };
};

export type BasePrimeRateFragmentFragment = {
  id: string;
  effectiveDate: any;
  rate: string;
  source?: string | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
};

export type BaseLedgerBalanceFragment = { available?: string | null; pending?: string | null };

export type BaseLateFeeProcessingResultFragment = {
  status?: string | null;
  lateFeeApplied?: number | null;
  statementId?: string | null;
  reason?: string | null;
  dryRun?: boolean | null;
  feeTier?: string | null;
  paymentStatus?: string | null;
  statementDueDate?: any | null;
  statementNewBalance?: number | null;
  minimumPaymentDue?: number | null;
};

export type BaseAchReturnAllocationFragment = { targetAccountId: string; amount: any };

export type BaseAchReturnAdjustmentFragment = {
  statementId: string;
  amountCents: number;
  type: string;
  effectiveDate: string;
};

export type BaseCardDisputeFragment = {
  id: string;
  userId?: string | null;
  disputeTransId: string;
  twispAccountId: string;
  cardRefNo?: string | null;
  status: DisputeStatus;
  originalAmountCents?: number | null;
  resolvedAmountCents?: number | null;
  creditType?: string | null;
  agentId?: string | null;
  declineReasons?: string | null;
  filedAt?: any | null;
  resolvedAt?: any | null;
  recalculationCompletedAt?: any | null;
  metadata?: unknown | null;
  insertedAt: any;
  updatedAt: any;
};

export type BaseCardDisputeEventFragment = {
  id: string;
  webhookEventId: string;
  mti?: string | null;
  de31?: string | null;
  serviceId?: string | null;
  amountCents?: number | null;
  direction?: string | null;
  de80Raw?: string | null;
  de80Parsed?: unknown | null;
  twispTransactionId?: string | null;
  insertedAt: any;
};

export type BaseAchAuthorizationFragment = {
  id: string;
  userId: string;
  recordType: AchAuthorizationRecordType;
  status: AchAuthorizationStatus;
  renderedTextSnapshot?: string | null;
  textVersion?: string | null;
  acceptedAtServer?: any | null;
  acceptedAtClient?: any | null;
  revokedAt?: any | null;
  ipAddress?: string | null;
  deviceIdentifier?: string | null;
  bankAccountLast4?: string | null;
  routingNumber?: string | null;
  plaidAccountId?: string | null;
  plaidItemId?: string | null;
  parentAuthorizationId?: string | null;
  autoPaySettingsId?: string | null;
  metadata?: unknown | null;
  insertedAt: any;
  updatedAt: any;
};

export type BaseAchReturnResultFragment = {
  dryRun: boolean;
  returnCode: string;
  returnReason: string;
  returnCategory: string;
  returnFeeWillPost: boolean;
  repaymentAmountCents: number;
  message?: string | null;
  affectedStatementIds?: Array<string | null> | null;
  returnFeeCents?: number | null;
  allocationsReversed?: number | null;
  delinquencyTriggered?: boolean | null;
  achRequest: { id: string; status?: string | null; amountCents?: number | null; returnCode?: string | null };
  allocationsToReverse?: Array<{ targetAccountId: string; amount: any } | null> | null;
  interestAdjustments?: Array<{
    statementId: string;
    amountCents: number;
    type: string;
    effectiveDate: string;
  } | null> | null;
  feeAdjustments?: Array<{
    statementId: string;
    amountCents: number;
    type: string;
    effectiveDate: string;
  } | null> | null;
};

export type BaseReconciliationRunFragmentFragment = {
  id: string;
  check: string;
  asOf: any;
  startedAt: any;
  finishedAt: any;
  examinedCount: number;
  findings: unknown;
  error?: string | null;
};

export type CardWithUserFragmentFragment = {
  id?: string | null;
  status?: CardStatus | null;
  active?: boolean | null;
  referenceId?: string | null;
  processor?: CardProcessor | null;
  dateOpened?: any | null;
  blockedReason?: string | null;
  version?: number | null;
  lastFour?: string | null;
  expDate?: string | null;
  physicalActivatedAt?: any | null;
  insertedAt?: any | null;
  user?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
    billingAddress?: {
      isPoBox?: boolean | null;
      isBilling?: boolean | null;
      isShipping?: boolean | null;
      isDebitPayment?: boolean | null;
      isConfirmed?: boolean | null;
      id?: string | null;
      addressFirstLine?: string | null;
      addressSecondLine?: string | null;
      city?: string | null;
      state?: string | null;
      zip?: string | null;
    } | null;
  } | null;
};

export type TransactionDetailsFragment = {
  id?: string | null;
  entryId?: string | null;
  correlationId?: string | null;
  amount?: string | null;
  transmissionDate?: string | null;
  effectiveDate?: string | null;
  statementDate?: string | null;
  transactionType?: string | null;
  direction?: string | null;
  status?: string | null;
  tranCode?: string | null;
  rawTranCode?: string | null;
  metadata?: unknown | null;
  accountId?: string | null;
  merchantDetails?: {
    name?: string | null;
    city?: string | null;
    region?: string | null;
    displayName?: string | null;
  } | null;
  transactionBalance?: { encumbrance?: string | null; pending?: string | null; settled?: string | null } | null;
};

export type VelocityControlFragmentFragment = {
  id?: string | null;
  name?: string | null;
  journalId?: string | null;
  description?: string | null;
  condition?: string | null;
  enforcementAction?: string | null;
  accountId?: string | null;
  accountKind?: string | null;
  limits?: Array<{
    id?: string | null;
    name?: string | null;
    description?: string | null;
    currency?: string | null;
    layer?: string | null;
    amount?: string | null;
    normalBalanceType?: string | null;
    start?: string | null;
    end?: string | null;
  } | null> | null;
};

export type AchRequestFragmentFragment = {
  lockVersion?: number | null;
  parkedFromStatus?: string | null;
  inFlight: boolean;
  id: string;
  userId?: string | null;
  plaidAccountId?: string | null;
  achType?: string | null;
  status?: string | null;
  returnCode?: string | null;
  amountCents?: number | null;
  usioConfirmation?: string | null;
  failureReason?: string | null;
  settledAt?: any | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
  ledgerRefId?: string | null;
  achEvents?: Array<{
    id: string;
    authCode?: string | null;
    avsCode?: string | null;
    batchNumber?: string | null;
    finalStatus?: string | null;
    errorMessage?: string | null;
    details?: unknown | null;
    achRequestId?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null> | null;
  recovery?: { retry: boolean; cancel: boolean; blockedReason?: string | null } | null;
  loan?: { id: string } | null;
  user?: { id?: string | null; firstName?: string | null; lastName?: string | null; email?: string | null } | null;
};

export type CardDisputeFragmentFragment = {
  id: string;
  userId?: string | null;
  disputeTransId: string;
  twispAccountId: string;
  cardRefNo?: string | null;
  status: DisputeStatus;
  originalAmountCents?: number | null;
  resolvedAmountCents?: number | null;
  creditType?: string | null;
  agentId?: string | null;
  declineReasons?: string | null;
  filedAt?: any | null;
  resolvedAt?: any | null;
  recalculationCompletedAt?: any | null;
  metadata?: unknown | null;
  insertedAt: any;
  updatedAt: any;
  events?: Array<{
    id: string;
    webhookEventId: string;
    mti?: string | null;
    de31?: string | null;
    serviceId?: string | null;
    amountCents?: number | null;
    direction?: string | null;
    de80Raw?: string | null;
    de80Parsed?: unknown | null;
    twispTransactionId?: string | null;
    insertedAt: any;
  } | null> | null;
};

export type UserEventFragmentFragment = {
  id?: string | null;
  type?: string | null;
  details?: unknown | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
  actor?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
  } | null;
};

export type LoanEventFragmentFragment = {
  id?: string | null;
  type?: string | null;
  details?: unknown | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
  actor?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
  } | null;
};

export type CardEventFragmentFragment = {
  id?: string | null;
  type?: string | null;
  details?: unknown | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
  card?: { id?: string | null; lastFour?: string | null } | null;
  actor?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
  } | null;
};

export type AdminActionRecordFragmentFragment = {
  id?: string | null;
  action?: string | null;
  description?: string | null;
  details?: unknown | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
  actor?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
  } | null;
  user?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
  } | null;
};

export type SpendingControlFragmentFragment = {
  type: SpendingControlType;
  status: SpendingControlStatus;
  enabled: boolean;
  amountCents: number;
  granularity?: SpendingGranularity | null;
  updatedAt?: any | null;
};

export type AddressFragmentFragment = {
  isPoBox?: boolean | null;
  isBilling?: boolean | null;
  isShipping?: boolean | null;
  isDebitPayment?: boolean | null;
  isConfirmed?: boolean | null;
  id?: string | null;
  addressFirstLine?: string | null;
  addressSecondLine?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
};

export type UserFragmentFragment = {
  lithicAccountToken?: string | null;
  adminProgramId?: string | null;
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  displayName?: string | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
  middleName?: string | null;
  phone?: string | null;
  dob?: string | null;
  isFriendsAndFam?: boolean | null;
  role?: UserRole | null;
  unhandledAlertsCount?: number | null;
  cards?: Array<{
    id?: string | null;
    status?: CardStatus | null;
    active?: boolean | null;
    referenceId?: string | null;
    processor?: CardProcessor | null;
    dateOpened?: any | null;
    blockedReason?: string | null;
    version?: number | null;
    lastFour?: string | null;
    expDate?: string | null;
    physicalActivatedAt?: any | null;
    insertedAt?: any | null;
  } | null> | null;
  billingAddress?: {
    isPoBox?: boolean | null;
    isBilling?: boolean | null;
    isShipping?: boolean | null;
    isDebitPayment?: boolean | null;
    isConfirmed?: boolean | null;
    id?: string | null;
    addressFirstLine?: string | null;
    addressSecondLine?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
  } | null;
  alerts: Array<{
    id: string;
    type: string;
    details?: unknown | null;
    handled: boolean;
    insertedAt?: any | null;
    updatedAt?: any | null;
  }>;
  loans: Array<{
    id: string;
    statementDay?: number | null;
    paymentDueDay?: number | null;
    partnerAccountNumber?: string | null;
    creditLimit?: number | null;
    initialBalance?: number | null;
    originationDate?: any | null;
    promoEndDate?: any | null;
    aprMargin?: string | null;
    initialApr?: string | null;
    isVariableApr?: boolean | null;
    status?: LoanStatus | null;
    delinquentSince?: any | null;
    daysDelinquent?: number | null;
    isDelinquent?: boolean | null;
    closedAt?: any | null;
    programId?: string | null;
    twispLoanId?: string | null;
    twispFeesId?: string | null;
    twispRepaymentId?: string | null;
    twispCardAccountSetId?: string | null;
    twispCardSpendSetId?: string | null;
    twispCardFeesId?: string | null;
    twispCardInterestId?: string | null;
    twispCreditLineAccountSetId?: string | null;
    twispCreditLineSpendId?: string | null;
    twispCreditLineFeesId?: string | null;
    twispCreditLineInterestId?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  }>;
  adminProgram?: {
    id: string;
    name: string;
    targetInterestRate?: string | null;
    minApr?: string | null;
    maxApr?: string | null;
    firstLateFeeAmount?: number | null;
    subsequentLateFeeAmount?: number | null;
    lateFeeStrategy?: LateFeeStrategy | null;
    returnedPaymentFeeCents?: number | null;
    returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
    foreignTransactionFeeRate?: any | null;
    cashAdvancesAllowed?: boolean | null;
    cashAdvanceFeeRate?: any | null;
    cashAdvanceFeeMinCents?: number | null;
    replacementCardFeeCents?: number | null;
    autopayPaymentTypes?: Array<string> | null;
    paymentDueDateGracePeriodDays?: number | null;
    lateFeeGracePeriodDays?: number | null;
    paymentDueDay?: number | null;
    statementGenerateDay?: number | null;
    minimumPaymentStrategy?: MinimumPaymentStrategy | null;
    minimumPaymentRate?: any | null;
    minimumPaymentFloorCents?: number | null;
    minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
    minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
    graceStrategy?: GraceStrategy | null;
    accrualBase?: AccrualBase | null;
    interestPostingPolicy?: InterestPostingPolicy | null;
    pdfTemplate?: PdfTemplate | null;
    chargeDrawdownFee?: boolean | null;
    twispJournalId?: string | null;
    twispIsoConfigId?: string | null;
    twispExposureAccountSetId?: string | null;
    lithicCardProgramToken?: string | null;
    lithicProductId?: string | null;
    active: boolean;
    insertedAt: any;
    updatedAt: any;
    partner: { id: string; name: string; active: boolean };
  } | null;
  partner?: { id: string; name: string } | null;
};

export type LoanFragmentFragment = {
  currentApr?: string | null;
  currentPrimeRate?: string | null;
  id: string;
  statementDay?: number | null;
  paymentDueDay?: number | null;
  partnerAccountNumber?: string | null;
  creditLimit?: number | null;
  initialBalance?: number | null;
  originationDate?: any | null;
  promoEndDate?: any | null;
  aprMargin?: string | null;
  initialApr?: string | null;
  isVariableApr?: boolean | null;
  status?: LoanStatus | null;
  delinquentSince?: any | null;
  daysDelinquent?: number | null;
  isDelinquent?: boolean | null;
  closedAt?: any | null;
  programId?: string | null;
  twispLoanId?: string | null;
  twispFeesId?: string | null;
  twispRepaymentId?: string | null;
  twispCardAccountSetId?: string | null;
  twispCardSpendSetId?: string | null;
  twispCardFeesId?: string | null;
  twispCardInterestId?: string | null;
  twispCreditLineAccountSetId?: string | null;
  twispCreditLineSpendId?: string | null;
  twispCreditLineFeesId?: string | null;
  twispCreditLineInterestId?: string | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
  program?: {
    id: string;
    name: string;
    targetInterestRate?: string | null;
    minApr?: string | null;
    maxApr?: string | null;
    firstLateFeeAmount?: number | null;
    subsequentLateFeeAmount?: number | null;
    lateFeeStrategy?: LateFeeStrategy | null;
    returnedPaymentFeeCents?: number | null;
    returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
    foreignTransactionFeeRate?: any | null;
    cashAdvancesAllowed?: boolean | null;
    cashAdvanceFeeRate?: any | null;
    cashAdvanceFeeMinCents?: number | null;
    replacementCardFeeCents?: number | null;
    autopayPaymentTypes?: Array<string> | null;
    paymentDueDateGracePeriodDays?: number | null;
    lateFeeGracePeriodDays?: number | null;
    paymentDueDay?: number | null;
    statementGenerateDay?: number | null;
    minimumPaymentStrategy?: MinimumPaymentStrategy | null;
    minimumPaymentRate?: any | null;
    minimumPaymentFloorCents?: number | null;
    minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
    minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
    graceStrategy?: GraceStrategy | null;
    accrualBase?: AccrualBase | null;
    interestPostingPolicy?: InterestPostingPolicy | null;
    pdfTemplate?: PdfTemplate | null;
    chargeDrawdownFee?: boolean | null;
    twispJournalId?: string | null;
    twispIsoConfigId?: string | null;
    twispExposureAccountSetId?: string | null;
    lithicCardProgramToken?: string | null;
    lithicProductId?: string | null;
    active: boolean;
    insertedAt: any;
    updatedAt: any;
    partner: { id: string; name: string; active: boolean };
  } | null;
  users: Array<{
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
  }>;
  cards: Array<{
    id?: string | null;
    status?: CardStatus | null;
    active?: boolean | null;
    referenceId?: string | null;
    processor?: CardProcessor | null;
    dateOpened?: any | null;
    blockedReason?: string | null;
    version?: number | null;
    lastFour?: string | null;
    expDate?: string | null;
    physicalActivatedAt?: any | null;
    insertedAt?: any | null;
    user?: { id?: string | null; firstName?: string | null; lastName?: string | null } | null;
  }>;
};

export type StatementFragmentFragment = {
  id: string;
  billingPeriodStart: string;
  billingPeriodEnd: string;
  dueDate: string;
  previousBalance: string;
  totalPayments: string;
  otherCredits: string;
  totalPurchases: string;
  cashAdvance: string;
  interestCharged: string;
  feesCharged: string;
  newBalance: string;
  creditLimit: string;
  creditLimitAvailable: string;
  minimumPaymentDue: string;
  ytdFeesCharged: string;
  ytdInterestCharged: string;
  closingBalance?: string | null;
  interestApplied?: string | null;
  lateFeeApplied?: string | null;
  pdfFilename?: string | null;
  hasPdf?: boolean | null;
  pdfDataSnapshot?: unknown | null;
  purchaseBalanceAtPeriodEnd?: number | null;
  drawdownBalanceAtPeriodEnd?: number | null;
  interestBalanceAtPeriodEnd?: number | null;
  feeBalanceAtPeriodEnd?: number | null;
  repaymentBalanceAtPeriodEnd?: number | null;
  averageDailyBalance?: number | null;
  graceSavings?: number | null;
  newPurchaseBalanceAtPeriodEnd?: number | null;
  statementDate?: string | null;
  graceActive?: boolean | null;
  previousBalancePaidInFull?: boolean | null;
  lateFeeEligibleOn?: string | null;
  dueDateProcessedAt?: string | null;
  lateFeeProcessedAt?: string | null;
  autopayProcessedAt?: string | null;
  pdfGeneratedAt?: string | null;
  insertedAt: string;
  updatedAt: string;
  loan?: { id: string; partnerAccountNumber?: string | null } | null;
};

export type UserWithoutCardsFragmentFragment = {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  displayName?: string | null;
  insertedAt?: any | null;
  updatedAt?: any | null;
  middleName?: string | null;
  phone?: string | null;
  dob?: string | null;
  isFriendsAndFam?: boolean | null;
  role?: UserRole | null;
  unhandledAlertsCount?: number | null;
  billingAddress?: {
    isPoBox?: boolean | null;
    isBilling?: boolean | null;
    isShipping?: boolean | null;
    isDebitPayment?: boolean | null;
    isConfirmed?: boolean | null;
    id?: string | null;
    addressFirstLine?: string | null;
    addressSecondLine?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
  } | null;
};

export type CardFragmentFragment = {
  id?: string | null;
  status?: CardStatus | null;
  active?: boolean | null;
  referenceId?: string | null;
  processor?: CardProcessor | null;
  dateOpened?: any | null;
  blockedReason?: string | null;
  version?: number | null;
  lastFour?: string | null;
  expDate?: string | null;
  physicalActivatedAt?: any | null;
  insertedAt?: any | null;
};

export type PaginationFragmentFragment = {
  resultsPerPage: number;
  totalPages: number;
  totalRecords: number;
  pageNumber: number;
  hasNextPage: boolean;
};

export type AlertFragmentFragment = {
  id: string;
  type: string;
  details?: unknown | null;
  handled: boolean;
  insertedAt?: any | null;
  updatedAt?: any | null;
};

export type AddLoanMemberMutationMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  cardRef?: InputMaybe<Scalars['String']['input']>;
  lastFour?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddLoanMemberMutationMutation = { addLoanMember?: { id: string } | null };

export type CreateCardActivatedAlertMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type CreateCardActivatedAlertMutation = {
  createCardActivatedAlert?: {
    id: string;
    type: string;
    details?: unknown | null;
    handled: boolean;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type CreateStatementPaymentDueAlertMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type CreateStatementPaymentDueAlertMutation = {
  createStatementPaymentDueAlert?: {
    id: string;
    type: string;
    details?: unknown | null;
    handled: boolean;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type CloseLoanMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  effectiveDate: Scalars['Date']['input'];
  reason: LoanClosureReason;
  requestedAt?: InputMaybe<Scalars['Date']['input']>;
}>;

export type CloseLoanMutation = {
  closeLoan?: { id: string; status?: LoanStatus | null; closedAt?: any | null } | null;
};

export type ConfirmDrawdownFundingMutationVariables = Exact<{
  achRequestId: Scalars['ID']['input'];
}>;

export type ConfirmDrawdownFundingMutation = {
  confirmDrawdownFunding?: {
    id: string;
    status?: string | null;
    amountCents?: number | null;
    userId?: string | null;
  } | null;
};

export type CreateAdminUserMutationMutationVariables = Exact<{
  input: CreateAdminUserInput;
}>;

export type CreateAdminUserMutationMutation = {
  createAdminUser?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
  } | null;
};

export type CreatePartnerMutationVariables = Exact<{
  input: CreatePartnerInput;
}>;

export type CreatePartnerMutation = {
  createPartner?: {
    clientId: string;
    clientSecret: string;
    partner: { id: string; name: string; active: boolean };
  } | null;
};

export type CreatePrimeRateMutationVariables = Exact<{
  input: CreatePrimeRateInput;
}>;

export type CreatePrimeRateMutation = {
  createPrimeRate?: {
    id: string;
    effectiveDate: any;
    rate: string;
    source?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type CreateProgramMutationVariables = Exact<{
  input: CreateProgramInput;
}>;

export type CreateProgramMutation = {
  createProgram?: {
    id: string;
    name: string;
    targetInterestRate?: string | null;
    minApr?: string | null;
    maxApr?: string | null;
    firstLateFeeAmount?: number | null;
    subsequentLateFeeAmount?: number | null;
    lateFeeStrategy?: LateFeeStrategy | null;
    returnedPaymentFeeCents?: number | null;
    returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
    foreignTransactionFeeRate?: any | null;
    cashAdvancesAllowed?: boolean | null;
    cashAdvanceFeeRate?: any | null;
    cashAdvanceFeeMinCents?: number | null;
    replacementCardFeeCents?: number | null;
    autopayPaymentTypes?: Array<string> | null;
    paymentDueDateGracePeriodDays?: number | null;
    lateFeeGracePeriodDays?: number | null;
    paymentDueDay?: number | null;
    statementGenerateDay?: number | null;
    minimumPaymentStrategy?: MinimumPaymentStrategy | null;
    minimumPaymentRate?: any | null;
    minimumPaymentFloorCents?: number | null;
    minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
    minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
    graceStrategy?: GraceStrategy | null;
    accrualBase?: AccrualBase | null;
    interestPostingPolicy?: InterestPostingPolicy | null;
    pdfTemplate?: PdfTemplate | null;
    chargeDrawdownFee?: boolean | null;
    twispJournalId?: string | null;
    twispIsoConfigId?: string | null;
    twispExposureAccountSetId?: string | null;
    lithicCardProgramToken?: string | null;
    lithicProductId?: string | null;
    active: boolean;
    insertedAt: any;
    updatedAt: any;
    partner: { id: string; name: string; active: boolean };
  } | null;
};

export type CreateUserMutationMutationVariables = Exact<{
  user: UserInput;
}>;

export type CreateUserMutationMutation = {
  createUser?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
  } | null;
};

export type DeletePrimeRateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeletePrimeRateMutation = {
  deletePrimeRate?: {
    id: string;
    effectiveDate: any;
    rate: string;
    source?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type OpenAccountMutationMutationVariables = Exact<{
  input: AccountOpeningInput;
}>;

export type OpenAccountMutationMutation = {
  openAccount?: {
    accountId: string;
    status: string;
    replayed: boolean;
    loanId?: string | null;
    pendingCards: Array<number>;
  } | null;
};

export type PreviewStatementCycleMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  closeStatementCycleOptions: CloseStatementCycleOptions;
}>;

export type PreviewStatementCycleMutation = {
  closeStatementCycle?: { billingPeriodStart: string; billingPeriodEnd: string; dueDate: string } | null;
};

export type RemoveProgramMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;

export type RemoveProgramMutation = {
  removeProgram?: {
    id: string;
    name: string;
    targetInterestRate?: string | null;
    minApr?: string | null;
    maxApr?: string | null;
    firstLateFeeAmount?: number | null;
    subsequentLateFeeAmount?: number | null;
    lateFeeStrategy?: LateFeeStrategy | null;
    returnedPaymentFeeCents?: number | null;
    returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
    foreignTransactionFeeRate?: any | null;
    cashAdvancesAllowed?: boolean | null;
    cashAdvanceFeeRate?: any | null;
    cashAdvanceFeeMinCents?: number | null;
    replacementCardFeeCents?: number | null;
    autopayPaymentTypes?: Array<string> | null;
    paymentDueDateGracePeriodDays?: number | null;
    lateFeeGracePeriodDays?: number | null;
    paymentDueDay?: number | null;
    statementGenerateDay?: number | null;
    minimumPaymentStrategy?: MinimumPaymentStrategy | null;
    minimumPaymentRate?: any | null;
    minimumPaymentFloorCents?: number | null;
    minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
    minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
    graceStrategy?: GraceStrategy | null;
    accrualBase?: AccrualBase | null;
    interestPostingPolicy?: InterestPostingPolicy | null;
    pdfTemplate?: PdfTemplate | null;
    chargeDrawdownFee?: boolean | null;
    twispJournalId?: string | null;
    twispIsoConfigId?: string | null;
    twispExposureAccountSetId?: string | null;
    lithicCardProgramToken?: string | null;
    lithicProductId?: string | null;
    active: boolean;
    insertedAt: any;
    updatedAt: any;
    partner: { id: string; name: string; active: boolean };
  } | null;
};

export type SetCardStatusMutationVariables = Exact<{
  referenceId: Scalars['ID']['input'];
  statusCode: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;

export type SetCardStatusMutation = {
  setCardStatus?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
  } | null;
};

export type SetProgramMerchantPolicyMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  cashAdvancesAllowed: Scalars['Boolean']['input'];
}>;

export type SetProgramMerchantPolicyMutation = {
  setProgramMerchantPolicy?: {
    id: string;
    name: string;
    targetInterestRate?: string | null;
    minApr?: string | null;
    maxApr?: string | null;
    firstLateFeeAmount?: number | null;
    subsequentLateFeeAmount?: number | null;
    lateFeeStrategy?: LateFeeStrategy | null;
    returnedPaymentFeeCents?: number | null;
    returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
    foreignTransactionFeeRate?: any | null;
    cashAdvancesAllowed?: boolean | null;
    cashAdvanceFeeRate?: any | null;
    cashAdvanceFeeMinCents?: number | null;
    replacementCardFeeCents?: number | null;
    autopayPaymentTypes?: Array<string> | null;
    paymentDueDateGracePeriodDays?: number | null;
    lateFeeGracePeriodDays?: number | null;
    paymentDueDay?: number | null;
    statementGenerateDay?: number | null;
    minimumPaymentStrategy?: MinimumPaymentStrategy | null;
    minimumPaymentRate?: any | null;
    minimumPaymentFloorCents?: number | null;
    minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
    minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
    graceStrategy?: GraceStrategy | null;
    accrualBase?: AccrualBase | null;
    interestPostingPolicy?: InterestPostingPolicy | null;
    pdfTemplate?: PdfTemplate | null;
    chargeDrawdownFee?: boolean | null;
    twispJournalId?: string | null;
    twispIsoConfigId?: string | null;
    twispExposureAccountSetId?: string | null;
    lithicCardProgramToken?: string | null;
    lithicProductId?: string | null;
    active: boolean;
    insertedAt: any;
    updatedAt: any;
    partner: { id: string; name: string; active: boolean };
  } | null;
};

export type UpdateAdminScopeMutationVariables = Exact<{
  input: UpdateAdminScopeInput;
}>;

export type UpdateAdminScopeMutation = {
  updateAdminScope?: {
    id?: string | null;
    adminProgramId?: string | null;
    adminProgram?: { id: string; name: string } | null;
    partner?: { id: string; name: string } | null;
  } | null;
};

export type UpdatePrimeRateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePrimeRateInput;
}>;

export type UpdatePrimeRateMutation = {
  updatePrimeRate?: {
    id: string;
    effectiveDate: any;
    rate: string;
    source?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type UpdateProgramMutationVariables = Exact<{
  programId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  targetInterestRate?: InputMaybe<Scalars['Decimal']['input']>;
  minApr?: InputMaybe<Scalars['Decimal']['input']>;
  maxApr?: InputMaybe<Scalars['Decimal']['input']>;
  firstLateFeeAmount?: InputMaybe<Scalars['Int']['input']>;
  subsequentLateFeeAmount?: InputMaybe<Scalars['Int']['input']>;
  returnedPaymentFeeCents?: InputMaybe<Scalars['Int']['input']>;
  foreignTransactionFeeRate?: InputMaybe<Scalars['Decimal']['input']>;
  replacementCardFeeCents?: InputMaybe<Scalars['Int']['input']>;
  paymentDueDateGracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  lateFeeGracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  paymentDueDay?: InputMaybe<Scalars['Int']['input']>;
  statementGenerateDay?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  minimumPaymentStrategy?: InputMaybe<MinimumPaymentStrategy>;
  minimumPaymentRate?: InputMaybe<Scalars['Decimal']['input']>;
  minimumPaymentFloorCents?: InputMaybe<Scalars['Int']['input']>;
  chargeDrawdownFee?: InputMaybe<Scalars['Boolean']['input']>;
  pdfTemplate?: InputMaybe<PdfTemplate>;
  twispJournalId?: InputMaybe<Scalars['ID']['input']>;
  twispIsoConfigId?: InputMaybe<Scalars['ID']['input']>;
  twispExposureAccountSetId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UpdateProgramMutation = {
  updateProgram?: {
    id: string;
    name: string;
    targetInterestRate?: string | null;
    minApr?: string | null;
    maxApr?: string | null;
    firstLateFeeAmount?: number | null;
    subsequentLateFeeAmount?: number | null;
    lateFeeStrategy?: LateFeeStrategy | null;
    returnedPaymentFeeCents?: number | null;
    returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
    foreignTransactionFeeRate?: any | null;
    cashAdvancesAllowed?: boolean | null;
    cashAdvanceFeeRate?: any | null;
    cashAdvanceFeeMinCents?: number | null;
    replacementCardFeeCents?: number | null;
    autopayPaymentTypes?: Array<string> | null;
    paymentDueDateGracePeriodDays?: number | null;
    lateFeeGracePeriodDays?: number | null;
    paymentDueDay?: number | null;
    statementGenerateDay?: number | null;
    minimumPaymentStrategy?: MinimumPaymentStrategy | null;
    minimumPaymentRate?: any | null;
    minimumPaymentFloorCents?: number | null;
    minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
    minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
    graceStrategy?: GraceStrategy | null;
    accrualBase?: AccrualBase | null;
    interestPostingPolicy?: InterestPostingPolicy | null;
    pdfTemplate?: PdfTemplate | null;
    chargeDrawdownFee?: boolean | null;
    twispJournalId?: string | null;
    twispIsoConfigId?: string | null;
    twispExposureAccountSetId?: string | null;
    lithicCardProgramToken?: string | null;
    lithicProductId?: string | null;
    active: boolean;
    insertedAt: any;
    updatedAt: any;
    partner: { id: string; name: string; active: boolean };
  } | null;
};

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  isFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateUserMutation = {
  updateUser?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
  } | null;
};

export type AchReturnMutationVariables = Exact<{
  achRequestId: Scalars['ID']['input'];
  returnCode?: InputMaybe<Scalars['String']['input']>;
  returnType: AchReturnType;
  returnedOn?: InputMaybe<Scalars['Date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AchReturnMutation = {
  achReturn?: {
    dryRun: boolean;
    returnCode: string;
    returnReason: string;
    returnCategory: string;
    returnFeeWillPost: boolean;
    repaymentAmountCents: number;
    message?: string | null;
    affectedStatementIds?: Array<string | null> | null;
    returnFeeCents?: number | null;
    allocationsReversed?: number | null;
    delinquencyTriggered?: boolean | null;
    achRequest: { id: string; status?: string | null; amountCents?: number | null; returnCode?: string | null };
    allocationsToReverse?: Array<{ targetAccountId: string; amount: any } | null> | null;
    interestAdjustments?: Array<{
      statementId: string;
      amountCents: number;
      type: string;
      effectiveDate: string;
    } | null> | null;
    feeAdjustments?: Array<{
      statementId: string;
      amountCents: number;
      type: string;
      effectiveDate: string;
    } | null> | null;
  } | null;
};

export type ActivateCardMutationVariables = Exact<{
  referenceId: Scalars['String']['input'];
}>;

export type ActivateCardMutation = {
  activateCard?: {
    id?: string | null;
    status?: CardStatus | null;
    active?: boolean | null;
    referenceId?: string | null;
    processor?: CardProcessor | null;
    dateOpened?: any | null;
    blockedReason?: string | null;
    version?: number | null;
    lastFour?: string | null;
    expDate?: string | null;
    physicalActivatedAt?: any | null;
    insertedAt?: any | null;
  } | null;
};

export type AddAddressMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  addressInput?: InputMaybe<AddressInput>;
}>;

export type AddAddressMutation = {
  addAddress?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
  } | null;
};

export type AddFeeTransactionMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  amountCents: Scalars['Int']['input'];
  feeType: Scalars['String']['input'];
  effectiveDate: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;

export type AddFeeTransactionMutation = { addFeeTransaction?: { transactionId: string } | null };

export type ApplyDelinquencyMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;

export type ApplyDelinquencyMutation = {
  applyLoanDelinquency?: {
    message?: string | null;
    loan?: {
      id: string;
      statementDay?: number | null;
      paymentDueDay?: number | null;
      partnerAccountNumber?: string | null;
      creditLimit?: number | null;
      initialBalance?: number | null;
      originationDate?: any | null;
      promoEndDate?: any | null;
      aprMargin?: string | null;
      initialApr?: string | null;
      isVariableApr?: boolean | null;
      status?: LoanStatus | null;
      delinquentSince?: any | null;
      daysDelinquent?: number | null;
      isDelinquent?: boolean | null;
      closedAt?: any | null;
      programId?: string | null;
      twispLoanId?: string | null;
      twispFeesId?: string | null;
      twispRepaymentId?: string | null;
      twispCardAccountSetId?: string | null;
      twispCardSpendSetId?: string | null;
      twispCardFeesId?: string | null;
      twispCardInterestId?: string | null;
      twispCreditLineAccountSetId?: string | null;
      twispCreditLineSpendId?: string | null;
      twispCreditLineFeesId?: string | null;
      twispCreditLineInterestId?: string | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
    } | null;
    affectedCards: Array<{ id?: string | null }>;
  } | null;
};

export type BlockUnblockCardMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
  action: BlockUnblockCardAction;
  blockReason?: InputMaybe<Scalars['String']['input']>;
}>;

export type BlockUnblockCardMutation = {
  blockUnblockCard?: {
    id?: string | null;
    status?: CardStatus | null;
    active?: boolean | null;
    referenceId?: string | null;
    processor?: CardProcessor | null;
    dateOpened?: any | null;
    blockedReason?: string | null;
    version?: number | null;
    lastFour?: string | null;
    expDate?: string | null;
    physicalActivatedAt?: any | null;
    insertedAt?: any | null;
  } | null;
};

export type CloseCardMutationVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;

export type CloseCardMutation = {
  closeCard?: {
    id?: string | null;
    status?: CardStatus | null;
    active?: boolean | null;
    referenceId?: string | null;
    processor?: CardProcessor | null;
    dateOpened?: any | null;
    blockedReason?: string | null;
    version?: number | null;
    lastFour?: string | null;
    expDate?: string | null;
    physicalActivatedAt?: any | null;
    insertedAt?: any | null;
  } | null;
};

export type CloseStatementCycleMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  closeStatementCycleOptions?: InputMaybe<CloseStatementCycleOptions>;
}>;

export type CloseStatementCycleMutation = {
  closeStatementCycle?: {
    id: string;
    billingPeriodStart: string;
    billingPeriodEnd: string;
    dueDate: string;
    previousBalance: string;
    totalPayments: string;
    otherCredits: string;
    totalPurchases: string;
    cashAdvance: string;
    interestCharged: string;
    feesCharged: string;
    newBalance: string;
    creditLimit: string;
    creditLimitAvailable: string;
    minimumPaymentDue: string;
    ytdFeesCharged: string;
    ytdInterestCharged: string;
    closingBalance?: string | null;
    interestApplied?: string | null;
    lateFeeApplied?: string | null;
    pdfFilename?: string | null;
    hasPdf?: boolean | null;
    pdfDataSnapshot?: unknown | null;
    purchaseBalanceAtPeriodEnd?: number | null;
    drawdownBalanceAtPeriodEnd?: number | null;
    interestBalanceAtPeriodEnd?: number | null;
    feeBalanceAtPeriodEnd?: number | null;
    repaymentBalanceAtPeriodEnd?: number | null;
    averageDailyBalance?: number | null;
    graceSavings?: number | null;
    newPurchaseBalanceAtPeriodEnd?: number | null;
    statementDate?: string | null;
    graceActive?: boolean | null;
    previousBalancePaidInFull?: boolean | null;
    lateFeeEligibleOn?: string | null;
    dueDateProcessedAt?: string | null;
    lateFeeProcessedAt?: string | null;
    autopayProcessedAt?: string | null;
    pdfGeneratedAt?: string | null;
    insertedAt: string;
    updatedAt: string;
    loan?: { id: string; partnerAccountNumber?: string | null } | null;
  } | null;
};

export type CureDelinquencyMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;

export type CureDelinquencyMutation = {
  cureLoanDelinquency?: {
    message?: string | null;
    loan?: {
      id: string;
      statementDay?: number | null;
      paymentDueDay?: number | null;
      partnerAccountNumber?: string | null;
      creditLimit?: number | null;
      initialBalance?: number | null;
      originationDate?: any | null;
      promoEndDate?: any | null;
      aprMargin?: string | null;
      initialApr?: string | null;
      isVariableApr?: boolean | null;
      status?: LoanStatus | null;
      delinquentSince?: any | null;
      daysDelinquent?: number | null;
      isDelinquent?: boolean | null;
      closedAt?: any | null;
      programId?: string | null;
      twispLoanId?: string | null;
      twispFeesId?: string | null;
      twispRepaymentId?: string | null;
      twispCardAccountSetId?: string | null;
      twispCardSpendSetId?: string | null;
      twispCardFeesId?: string | null;
      twispCardInterestId?: string | null;
      twispCreditLineAccountSetId?: string | null;
      twispCreditLineSpendId?: string | null;
      twispCreditLineFeesId?: string | null;
      twispCreditLineInterestId?: string | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
    } | null;
    affectedCards: Array<{ id?: string | null }>;
  } | null;
};

export type MarkPhysicalCardActivatedMutationVariables = Exact<{
  referenceId: Scalars['String']['input'];
}>;

export type MarkPhysicalCardActivatedMutation = {
  markPhysicalCardActivated?: {
    id?: string | null;
    status?: CardStatus | null;
    active?: boolean | null;
    referenceId?: string | null;
    processor?: CardProcessor | null;
    dateOpened?: any | null;
    blockedReason?: string | null;
    version?: number | null;
    lastFour?: string | null;
    expDate?: string | null;
    physicalActivatedAt?: any | null;
    insertedAt?: any | null;
  } | null;
};

export type PostExternalRepaymentMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  amountCents: Scalars['Int']['input'];
  paymentRef: Scalars['String']['input'];
  effectiveDate: Scalars['Date']['input'];
  statementDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}>;

export type PostExternalRepaymentMutation = {
  postExternalRepayment?: {
    status: ExternalRepaymentStatus;
    settlementTransactionId?: string | null;
    correlationId?: string | null;
    delinquencyCured: boolean;
    remainingUnallocatedCents: number;
  } | null;
};

export type ProcessLateFeeMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ProcessLateFeeMutation = {
  processLateFee?: {
    status?: string | null;
    lateFeeApplied?: number | null;
    statementId?: string | null;
    reason?: string | null;
    dryRun?: boolean | null;
    feeTier?: string | null;
    paymentStatus?: string | null;
    statementDueDate?: any | null;
    statementNewBalance?: number | null;
    minimumPaymentDue?: number | null;
  } | null;
};

export type ProcessStatementDueDateMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  dueDateOptions?: InputMaybe<DueDateOptions>;
}>;

export type ProcessStatementDueDateMutation = {
  processStatementDueDate?: {
    paymentType?: string | null;
    paymentAmount?: string | null;
    interestApplied?: string | null;
    lateFeeApplied?: string | null;
    isDelinquent?: boolean | null;
    remainingBalance?: string | null;
    daysDelinquent?: number | null;
  } | null;
};

export type RetryAchRequestMutationVariables = Exact<{
  achRequestId: Scalars['ID']['input'];
  expectedVersion: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  confirmation?: InputMaybe<Scalars['String']['input']>;
}>;

export type RetryAchRequestMutation = {
  retryAchRequest?: {
    lockVersion?: number | null;
    parkedFromStatus?: string | null;
    inFlight: boolean;
    id: string;
    userId?: string | null;
    plaidAccountId?: string | null;
    achType?: string | null;
    status?: string | null;
    returnCode?: string | null;
    amountCents?: number | null;
    usioConfirmation?: string | null;
    failureReason?: string | null;
    settledAt?: any | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    ledgerRefId?: string | null;
    achEvents?: Array<{
      id: string;
      authCode?: string | null;
      avsCode?: string | null;
      batchNumber?: string | null;
      finalStatus?: string | null;
      errorMessage?: string | null;
      details?: unknown | null;
      achRequestId?: string | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
    } | null> | null;
    recovery?: { retry: boolean; cancel: boolean; blockedReason?: string | null } | null;
    loan?: { id: string } | null;
    user?: { id?: string | null; firstName?: string | null; lastName?: string | null; email?: string | null } | null;
  } | null;
};

export type CancelAchRequestMutationVariables = Exact<{
  achRequestId: Scalars['ID']['input'];
  expectedVersion: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  providerCancellationConfirmation?: InputMaybe<Scalars['String']['input']>;
  evidence?: InputMaybe<Scalars['String']['input']>;
}>;

export type CancelAchRequestMutation = {
  cancelAchRequest?: {
    lockVersion?: number | null;
    parkedFromStatus?: string | null;
    inFlight: boolean;
    id: string;
    userId?: string | null;
    plaidAccountId?: string | null;
    achType?: string | null;
    status?: string | null;
    returnCode?: string | null;
    amountCents?: number | null;
    usioConfirmation?: string | null;
    failureReason?: string | null;
    settledAt?: any | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    ledgerRefId?: string | null;
    achEvents?: Array<{
      id: string;
      authCode?: string | null;
      avsCode?: string | null;
      batchNumber?: string | null;
      finalStatus?: string | null;
      errorMessage?: string | null;
      details?: unknown | null;
      achRequestId?: string | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
    } | null> | null;
    recovery?: { retry: boolean; cancel: boolean; blockedReason?: string | null } | null;
    loan?: { id: string } | null;
    user?: { id?: string | null; firstName?: string | null; lastName?: string | null; email?: string | null } | null;
  } | null;
};

export type ReplaceCardMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  referenceId: Scalars['String']['input'];
  replaceCardType: ReplaceCardType;
  addressInput?: InputMaybe<AddressInput>;
}>;

export type ReplaceCardMutation = {
  replaceCard?: {
    id?: string | null;
    status?: CardStatus | null;
    active?: boolean | null;
    referenceId?: string | null;
    processor?: CardProcessor | null;
    dateOpened?: any | null;
    blockedReason?: string | null;
    version?: number | null;
    lastFour?: string | null;
    expDate?: string | null;
    physicalActivatedAt?: any | null;
    insertedAt?: any | null;
  } | null;
};

export type UpdateAprMarginMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  aprMargin: Scalars['Decimal']['input'];
  reason: Scalars['String']['input'];
}>;

export type UpdateAprMarginMutation = {
  updateLoanAprMargin?: {
    id: string;
    statementDay?: number | null;
    paymentDueDay?: number | null;
    partnerAccountNumber?: string | null;
    creditLimit?: number | null;
    initialBalance?: number | null;
    originationDate?: any | null;
    promoEndDate?: any | null;
    aprMargin?: string | null;
    initialApr?: string | null;
    isVariableApr?: boolean | null;
    status?: LoanStatus | null;
    delinquentSince?: any | null;
    daysDelinquent?: number | null;
    isDelinquent?: boolean | null;
    closedAt?: any | null;
    programId?: string | null;
    twispLoanId?: string | null;
    twispFeesId?: string | null;
    twispRepaymentId?: string | null;
    twispCardAccountSetId?: string | null;
    twispCardSpendSetId?: string | null;
    twispCardFeesId?: string | null;
    twispCardInterestId?: string | null;
    twispCreditLineAccountSetId?: string | null;
    twispCreditLineSpendId?: string | null;
    twispCreditLineFeesId?: string | null;
    twispCreditLineInterestId?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type UpdateAutoPaySettingsForUserMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  input: AutoPaySettingsInput;
}>;

export type UpdateAutoPaySettingsForUserMutation = {
  updateAutoPaySettingsForLoan?: {
    id?: string | null;
    paymentType?: string | null;
    daysBeforePayment?: number | null;
    enabled?: boolean | null;
    plaidAccountId?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type UpdateCreditLimitMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  creditLimit: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
}>;

export type UpdateCreditLimitMutation = {
  updateLoanCreditLimit?: {
    id: string;
    statementDay?: number | null;
    paymentDueDay?: number | null;
    partnerAccountNumber?: string | null;
    creditLimit?: number | null;
    initialBalance?: number | null;
    originationDate?: any | null;
    promoEndDate?: any | null;
    aprMargin?: string | null;
    initialApr?: string | null;
    isVariableApr?: boolean | null;
    status?: LoanStatus | null;
    delinquentSince?: any | null;
    daysDelinquent?: number | null;
    isDelinquent?: boolean | null;
    closedAt?: any | null;
    programId?: string | null;
    twispLoanId?: string | null;
    twispFeesId?: string | null;
    twispRepaymentId?: string | null;
    twispCardAccountSetId?: string | null;
    twispCardSpendSetId?: string | null;
    twispCardFeesId?: string | null;
    twispCardInterestId?: string | null;
    twispCreditLineAccountSetId?: string | null;
    twispCreditLineSpendId?: string | null;
    twispCreditLineFeesId?: string | null;
    twispCreditLineInterestId?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type ManageVelocityControlMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  action: VelocityControlAction;
  velocityControlId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ManageVelocityControlMutation = {
  manageLoanVelocityControl?: {
    id?: string | null;
    name?: string | null;
    journalId?: string | null;
    description?: string | null;
    condition?: string | null;
    enforcementAction?: string | null;
    accountId?: string | null;
    accountKind?: string | null;
    limits?: Array<{
      id?: string | null;
      name?: string | null;
      description?: string | null;
      currency?: string | null;
      layer?: string | null;
      amount?: string | null;
      normalBalanceType?: string | null;
      start?: string | null;
      end?: string | null;
    } | null> | null;
  } | null;
};

export type UpdateLoanManagedSpendingControlMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  type: SpendingControlType;
  enabled: Scalars['Boolean']['input'];
  amountCents: Scalars['Int']['input'];
  granularity: SpendingGranularity;
}>;

export type UpdateLoanManagedSpendingControlMutation = {
  updateLoanManagedSpendingControl?: {
    type: SpendingControlType;
    status: SpendingControlStatus;
    enabled: boolean;
    amountCents: number;
    granularity?: SpendingGranularity | null;
    updatedAt?: any | null;
  } | null;
};

export type VoidTransactionMutationVariables = Exact<{
  transactionId: Scalars['ID']['input'];
}>;

export type VoidTransactionMutation = { voidTransaction?: { transactionId: string } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  currentUser?: {
    id?: string | null;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    displayName?: string | null;
    role?: UserRole | null;
  } | null;
};

export type GetAdminActionRecordsByActorQueryVariables = Exact<{
  actorId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['Date']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetAdminActionRecordsByActorQuery = {
  adminActionRecordsByActor?: {
    adminActionRecords?: Array<{
      id?: string | null;
      action?: string | null;
      description?: string | null;
      details?: unknown | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      actor?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
      user?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
    }> | null;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type GetDrawdownCustomerQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type GetDrawdownCustomerQuery = {
  user?: {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    displayName?: string | null;
  } | null;
};

export type GetUserAchAuthorizationsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  statusSortDirection?: InputMaybe<SortDirection>;
  statusSelections?: InputMaybe<Array<InputMaybe<AchAuthorizationStatus>> | InputMaybe<AchAuthorizationStatus>>;
  recordTypeSortDirection?: InputMaybe<SortDirection>;
  recordTypeSelections?: InputMaybe<
    Array<InputMaybe<AchAuthorizationRecordType>> | InputMaybe<AchAuthorizationRecordType>
  >;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetUserAchAuthorizationsQuery = {
  userAchAuthorizations?: {
    achAuthorizations?: Array<{
      id: string;
      userId: string;
      recordType: AchAuthorizationRecordType;
      status: AchAuthorizationStatus;
      renderedTextSnapshot?: string | null;
      textVersion?: string | null;
      acceptedAtServer?: any | null;
      acceptedAtClient?: any | null;
      revokedAt?: any | null;
      ipAddress?: string | null;
      deviceIdentifier?: string | null;
      bankAccountLast4?: string | null;
      routingNumber?: string | null;
      plaidAccountId?: string | null;
      plaidItemId?: string | null;
      parentAuthorizationId?: string | null;
      autoPaySettingsId?: string | null;
      metadata?: unknown | null;
      insertedAt: any;
      updatedAt: any;
    }> | null;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type GetLoanAchRequestsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  statusSortDirection?: InputMaybe<SortDirection>;
  statusSelections?: InputMaybe<Array<InputMaybe<AchRequestStatus>> | InputMaybe<AchRequestStatus>>;
  achTypeSortDirection?: InputMaybe<SortDirection>;
  achTypeSelections?: InputMaybe<Array<InputMaybe<AchRequestType>> | InputMaybe<AchRequestType>>;
  settled?: InputMaybe<Scalars['Boolean']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetLoanAchRequestsQuery = {
  loanAchRequests?: {
    achRequests?: Array<{
      lockVersion?: number | null;
      parkedFromStatus?: string | null;
      inFlight: boolean;
      id: string;
      userId?: string | null;
      plaidAccountId?: string | null;
      achType?: string | null;
      status?: string | null;
      returnCode?: string | null;
      amountCents?: number | null;
      usioConfirmation?: string | null;
      failureReason?: string | null;
      settledAt?: any | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      ledgerRefId?: string | null;
      achEvents?: Array<{
        id: string;
        authCode?: string | null;
        avsCode?: string | null;
        batchNumber?: string | null;
        finalStatus?: string | null;
        errorMessage?: string | null;
        details?: unknown | null;
        achRequestId?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
      } | null> | null;
      recovery?: { retry: boolean; cancel: boolean; blockedReason?: string | null } | null;
      loan?: { id: string } | null;
      user?: { id?: string | null; firstName?: string | null; lastName?: string | null; email?: string | null } | null;
    }> | null;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type GetUserAdminActionRecordsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['Date']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetUserAdminActionRecordsQuery = {
  adminActionRecordsForUser?: {
    adminActionRecords?: Array<{
      id?: string | null;
      action?: string | null;
      description?: string | null;
      details?: unknown | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      actor?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
      user?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
    }> | null;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type GetLoanDailyReportsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type GetLoanDailyReportsQuery = {
  loanDailyReports?: Array<{
    id?: string | null;
    reportDate?: any | null;
    latestBalance?: number | null;
    lastPaymentAmount?: number | null;
    lastPaymentDate?: any | null;
    creditLimit?: number | null;
    loanBalance?: number | null;
    repaymentBalance?: number | null;
    feesBalance?: number | null;
    cardSetBalance?: number | null;
    cardSpendBalance?: number | null;
    cardFeesBalance?: number | null;
    cardInterestBalance?: number | null;
    creditLineSetBalance?: number | null;
    creditLineSpendBalance?: number | null;
    creditLineFeesBalance?: number | null;
    creditLineInterestBalance?: number | null;
    recalculationReason?: string | null;
    recalculationBatchId?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null> | null;
};

export type GetLoanDisputesQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  statusSortDirection?: InputMaybe<SortDirection>;
  statusSelections?: InputMaybe<Array<InputMaybe<DisputeStatus>> | InputMaybe<DisputeStatus>>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetLoanDisputesQuery = {
  loanDisputes?: {
    disputes?: Array<{
      id: string;
      userId?: string | null;
      disputeTransId: string;
      twispAccountId: string;
      cardRefNo?: string | null;
      status: DisputeStatus;
      originalAmountCents?: number | null;
      resolvedAmountCents?: number | null;
      creditType?: string | null;
      agentId?: string | null;
      declineReasons?: string | null;
      filedAt?: any | null;
      resolvedAt?: any | null;
      recalculationCompletedAt?: any | null;
      metadata?: unknown | null;
      insertedAt: any;
      updatedAt: any;
      events?: Array<{
        id: string;
        webhookEventId: string;
        mti?: string | null;
        de31?: string | null;
        serviceId?: string | null;
        amountCents?: number | null;
        direction?: string | null;
        de80Raw?: string | null;
        de80Parsed?: unknown | null;
        twispTransactionId?: string | null;
        insertedAt: any;
      } | null> | null;
    }> | null;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type GetUserEventsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type GetUserEventsQuery = {
  user?: {
    id?: string | null;
    userEvents?: Array<{
      id?: string | null;
      type?: string | null;
      details?: unknown | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      actor?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetLoanStatementsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type GetLoanStatementsQuery = {
  loanStatements: Array<{
    id: string;
    billingPeriodStart: string;
    billingPeriodEnd: string;
    dueDate: string;
    previousBalance: string;
    totalPayments: string;
    otherCredits: string;
    totalPurchases: string;
    cashAdvance: string;
    interestCharged: string;
    feesCharged: string;
    newBalance: string;
    creditLimit: string;
    creditLimitAvailable: string;
    minimumPaymentDue: string;
    ytdFeesCharged: string;
    ytdInterestCharged: string;
    closingBalance?: string | null;
    interestApplied?: string | null;
    lateFeeApplied?: string | null;
    pdfFilename?: string | null;
    hasPdf?: boolean | null;
    pdfDataSnapshot?: unknown | null;
    purchaseBalanceAtPeriodEnd?: number | null;
    drawdownBalanceAtPeriodEnd?: number | null;
    interestBalanceAtPeriodEnd?: number | null;
    feeBalanceAtPeriodEnd?: number | null;
    repaymentBalanceAtPeriodEnd?: number | null;
    averageDailyBalance?: number | null;
    graceSavings?: number | null;
    newPurchaseBalanceAtPeriodEnd?: number | null;
    statementDate?: string | null;
    graceActive?: boolean | null;
    previousBalancePaidInFull?: boolean | null;
    lateFeeEligibleOn?: string | null;
    dueDateProcessedAt?: string | null;
    lateFeeProcessedAt?: string | null;
    autopayProcessedAt?: string | null;
    pdfGeneratedAt?: string | null;
    insertedAt: string;
    updatedAt: string;
    loan?: { id: string; partnerAccountNumber?: string | null } | null;
  }>;
};

export type GetLoanTransactionsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  viewMode?: InputMaybe<TransactionViewMode>;
}>;

export type GetLoanTransactionsQuery = {
  loanTransactions?: {
    transactions?: Array<{
      id?: string | null;
      entryId?: string | null;
      correlationId?: string | null;
      amount?: string | null;
      transmissionDate?: string | null;
      effectiveDate?: string | null;
      statementDate?: string | null;
      transactionType?: string | null;
      direction?: string | null;
      status?: string | null;
      tranCode?: string | null;
      rawTranCode?: string | null;
      metadata?: unknown | null;
      accountId?: string | null;
      merchantDetails?: {
        name?: string | null;
        city?: string | null;
        region?: string | null;
        displayName?: string | null;
      } | null;
      transactionBalance?: { encumbrance?: string | null; pending?: string | null; settled?: string | null } | null;
    } | null> | null;
    balance?: {
      availableEncumbrance?: string | null;
      availablePending?: string | null;
      availableSettled?: string | null;
      pending?: string | null;
    } | null;
    balanceRaw?: {
      available?: { cr?: string | null; dr?: string | null; normal?: string | null } | null;
      encumbrance?: { cr?: string | null; dr?: string | null; normal?: string | null } | null;
      pending?: { cr?: string | null; dr?: string | null; normal?: string | null } | null;
      settled?: { cr?: string | null; dr?: string | null; normal?: string | null } | null;
    } | null;
  } | null;
};

export type GetLoanVelocityControlsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type GetLoanVelocityControlsQuery = {
  loanVelocityControls?: Array<{
    id?: string | null;
    name?: string | null;
    journalId?: string | null;
    description?: string | null;
    condition?: string | null;
    enforcementAction?: string | null;
    accountId?: string | null;
    accountKind?: string | null;
    limits?: Array<{
      id?: string | null;
      name?: string | null;
      description?: string | null;
      currency?: string | null;
      layer?: string | null;
      amount?: string | null;
      normalBalanceType?: string | null;
      start?: string | null;
      end?: string | null;
    } | null> | null;
  } | null> | null;
};

export type GetLoanAutoPaySettingsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type GetLoanAutoPaySettingsQuery = {
  loanAutoPaySettings?: {
    id?: string | null;
    paymentType?: string | null;
    daysBeforePayment?: number | null;
    enabled?: boolean | null;
    plaidAccountId?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type GetCardEventsQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;

export type GetCardEventsQuery = {
  card?: {
    id?: string | null;
    lastFour?: string | null;
    cardEvents: Array<{
      id?: string | null;
      type?: string | null;
      details?: unknown | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      card?: { id?: string | null; lastFour?: string | null } | null;
      actor?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
    }>;
  } | null;
};

export type GetCardQueryVariables = Exact<{
  cardId: Scalars['ID']['input'];
}>;

export type GetCardQuery = {
  card?: {
    id?: string | null;
    status?: CardStatus | null;
    active?: boolean | null;
    referenceId?: string | null;
    processor?: CardProcessor | null;
    dateOpened?: any | null;
    blockedReason?: string | null;
    version?: number | null;
    lastFour?: string | null;
    expDate?: string | null;
    physicalActivatedAt?: any | null;
    insertedAt?: any | null;
    loan?: { id: string; partnerAccountNumber?: string | null } | null;
    user?: {
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      displayName?: string | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      middleName?: string | null;
      phone?: string | null;
      dob?: string | null;
      isFriendsAndFam?: boolean | null;
      role?: UserRole | null;
      unhandledAlertsCount?: number | null;
      billingAddress?: {
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isDebitPayment?: boolean | null;
        isConfirmed?: boolean | null;
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
      } | null;
    } | null;
  } | null;
};

export type GetCardStatusQueryVariables = Exact<{
  referenceId: Scalars['ID']['input'];
}>;

export type GetCardStatusQuery = { getCardStatus?: string | null };

export type GetLoanCreditUtilizationQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type GetLoanCreditUtilizationQuery = {
  creditUtilization?: {
    limit: string;
    balance: string;
    availableAmount: string;
    spent: string;
    remaining: string;
  } | null;
};

export type LedgerTransactionQueryVariables = Exact<{
  entryId: Scalars['ID']['input'];
}>;

export type LedgerTransactionQuery = {
  ledgerTransaction?: {
    entryId?: string | null;
    transactionId?: string | null;
    accountId?: string | null;
    journalId?: string | null;
    entryType?: string | null;
    layer?: string | null;
    amount?: string | null;
    currency?: string | null;
    direction?: string | null;
    sequence?: number | null;
    description?: string | null;
    created?: string | null;
    modified?: string | null;
    version?: number | null;
    recordId?: string | null;
    balanceRecordId?: string | null;
    balanceRecordVersion?: number | null;
    loanId?: string | null;
    rawEntry?: unknown | null;
    merchantDetails?: {
      displayName?: string | null;
      name?: string | null;
      city?: string | null;
      region?: string | null;
    } | null;
  } | null;
};

export type LedgerTransactionsQueryVariables = Exact<{
  programId?: InputMaybe<Scalars['ID']['input']>;
  loanId?: InputMaybe<Scalars['ID']['input']>;
  accountId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  layers?: InputMaybe<Array<LedgerEntryLayer> | LedgerEntryLayer>;
  statuses?: InputMaybe<Array<LedgerTransactionStatus> | LedgerTransactionStatus>;
  directions?: InputMaybe<Array<PaymentDirection> | PaymentDirection>;
  rawTranCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  entryTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  settled?: InputMaybe<Scalars['Boolean']['input']>;
  entryScope?: InputMaybe<LedgerTransactionEntryScope>;
  viewMode?: InputMaybe<TransactionViewMode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;

export type LedgerTransactionsQuery = {
  ledgerTransactions?: {
    pagination: {
      totalRecords: number;
      resultsPerPage: number;
      pageNumber: number;
      hasNextPage: boolean;
      totalPages: number;
    };
    transactions?: Array<{
      id?: string | null;
      transactionId?: string | null;
      entryId?: string | null;
      accountId?: string | null;
      journalId?: string | null;
      entryType?: string | null;
      layer?: string | null;
      amount?: string | null;
      transmissionDate?: string | null;
      effectiveDate?: string | null;
      statementDate?: string | null;
      rawTranCode?: string | null;
      metadata?: unknown | null;
      status?: string | null;
      direction?: string | null;
      loanId?: string | null;
      merchantDetails?: { displayName?: string | null; name?: string | null } | null;
    } | null> | null;
  } | null;
};

export type GetLoanEventsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type GetLoanEventsQuery = {
  loan?: {
    id: string;
    loanEvents: Array<{
      id?: string | null;
      type?: string | null;
      details?: unknown | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      actor?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
    }>;
    cardEvents: Array<{
      id?: string | null;
      type?: string | null;
      details?: unknown | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      card?: { id?: string | null; lastFour?: string | null } | null;
      actor?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
    }>;
  } | null;
};

export type GetLoanManagedSpendingControlsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type GetLoanManagedSpendingControlsQuery = {
  loanManagedSpendingControls: Array<{
    type: SpendingControlType;
    status: SpendingControlStatus;
    enabled: boolean;
    amountCents: number;
    granularity?: SpendingGranularity | null;
    updatedAt?: any | null;
  }>;
};

export type GetLoanQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetLoanQuery = {
  loan?: {
    currentApr?: string | null;
    currentPrimeRate?: string | null;
    id: string;
    statementDay?: number | null;
    paymentDueDay?: number | null;
    partnerAccountNumber?: string | null;
    creditLimit?: number | null;
    initialBalance?: number | null;
    originationDate?: any | null;
    promoEndDate?: any | null;
    aprMargin?: string | null;
    initialApr?: string | null;
    isVariableApr?: boolean | null;
    status?: LoanStatus | null;
    delinquentSince?: any | null;
    daysDelinquent?: number | null;
    isDelinquent?: boolean | null;
    closedAt?: any | null;
    programId?: string | null;
    twispLoanId?: string | null;
    twispFeesId?: string | null;
    twispRepaymentId?: string | null;
    twispCardAccountSetId?: string | null;
    twispCardSpendSetId?: string | null;
    twispCardFeesId?: string | null;
    twispCardInterestId?: string | null;
    twispCreditLineAccountSetId?: string | null;
    twispCreditLineSpendId?: string | null;
    twispCreditLineFeesId?: string | null;
    twispCreditLineInterestId?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    program?: {
      id: string;
      name: string;
      targetInterestRate?: string | null;
      minApr?: string | null;
      maxApr?: string | null;
      firstLateFeeAmount?: number | null;
      subsequentLateFeeAmount?: number | null;
      lateFeeStrategy?: LateFeeStrategy | null;
      returnedPaymentFeeCents?: number | null;
      returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
      foreignTransactionFeeRate?: any | null;
      cashAdvancesAllowed?: boolean | null;
      cashAdvanceFeeRate?: any | null;
      cashAdvanceFeeMinCents?: number | null;
      replacementCardFeeCents?: number | null;
      autopayPaymentTypes?: Array<string> | null;
      paymentDueDateGracePeriodDays?: number | null;
      lateFeeGracePeriodDays?: number | null;
      paymentDueDay?: number | null;
      statementGenerateDay?: number | null;
      minimumPaymentStrategy?: MinimumPaymentStrategy | null;
      minimumPaymentRate?: any | null;
      minimumPaymentFloorCents?: number | null;
      minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
      minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
      graceStrategy?: GraceStrategy | null;
      accrualBase?: AccrualBase | null;
      interestPostingPolicy?: InterestPostingPolicy | null;
      pdfTemplate?: PdfTemplate | null;
      chargeDrawdownFee?: boolean | null;
      twispJournalId?: string | null;
      twispIsoConfigId?: string | null;
      twispExposureAccountSetId?: string | null;
      lithicCardProgramToken?: string | null;
      lithicProductId?: string | null;
      active: boolean;
      insertedAt: any;
      updatedAt: any;
      partner: { id: string; name: string; active: boolean };
    } | null;
    users: Array<{
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      displayName?: string | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      middleName?: string | null;
      phone?: string | null;
      dob?: string | null;
      isFriendsAndFam?: boolean | null;
      role?: UserRole | null;
      unhandledAlertsCount?: number | null;
    }>;
    cards: Array<{
      id?: string | null;
      status?: CardStatus | null;
      active?: boolean | null;
      referenceId?: string | null;
      processor?: CardProcessor | null;
      dateOpened?: any | null;
      blockedReason?: string | null;
      version?: number | null;
      lastFour?: string | null;
      expDate?: string | null;
      physicalActivatedAt?: any | null;
      insertedAt?: any | null;
      user?: { id?: string | null; firstName?: string | null; lastName?: string | null } | null;
    }>;
  } | null;
};

export type GetPrimeRateAsOfQueryVariables = Exact<{
  asOfDate: Scalars['Date']['input'];
}>;

export type GetPrimeRateAsOfQuery = {
  getPrimeRateAsOf?: {
    id: string;
    effectiveDate: any;
    rate: string;
    source?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type GetStatementStudioAuthoringContextQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type GetStatementStudioAuthoringContextQuery = {
  loan?: {
    id: string;
    statementDay?: number | null;
    paymentDueDay?: number | null;
    program?: { id: string; lateFeeGracePeriodDays?: number | null } | null;
  } | null;
  loanStatements: Array<{
    id: string;
    billingPeriodStart: string;
    billingPeriodEnd: string;
    dueDate: string;
    dueDateProcessedAt?: string | null;
    lateFeeEligibleOn?: string | null;
    lateFeeProcessedAt?: string | null;
  }>;
};

export type GetStatementStudioDetailsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  loanId: Scalars['ID']['input'];
}>;

export type GetStatementStudioDetailsQuery = {
  user?: {
    lithicAccountToken?: string | null;
    adminProgramId?: string | null;
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
    userEvents?: Array<{
      id?: string | null;
      type?: string | null;
      details?: unknown | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      actor?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
    } | null> | null;
    cards?: Array<{
      id?: string | null;
      status?: CardStatus | null;
      active?: boolean | null;
      referenceId?: string | null;
      processor?: CardProcessor | null;
      dateOpened?: any | null;
      blockedReason?: string | null;
      version?: number | null;
      lastFour?: string | null;
      expDate?: string | null;
      physicalActivatedAt?: any | null;
      insertedAt?: any | null;
    } | null> | null;
    billingAddress?: {
      isPoBox?: boolean | null;
      isBilling?: boolean | null;
      isShipping?: boolean | null;
      isDebitPayment?: boolean | null;
      isConfirmed?: boolean | null;
      id?: string | null;
      addressFirstLine?: string | null;
      addressSecondLine?: string | null;
      city?: string | null;
      state?: string | null;
      zip?: string | null;
    } | null;
    alerts: Array<{
      id: string;
      type: string;
      details?: unknown | null;
      handled: boolean;
      insertedAt?: any | null;
      updatedAt?: any | null;
    }>;
    loans: Array<{
      id: string;
      statementDay?: number | null;
      paymentDueDay?: number | null;
      partnerAccountNumber?: string | null;
      creditLimit?: number | null;
      initialBalance?: number | null;
      originationDate?: any | null;
      promoEndDate?: any | null;
      aprMargin?: string | null;
      initialApr?: string | null;
      isVariableApr?: boolean | null;
      status?: LoanStatus | null;
      delinquentSince?: any | null;
      daysDelinquent?: number | null;
      isDelinquent?: boolean | null;
      closedAt?: any | null;
      programId?: string | null;
      twispLoanId?: string | null;
      twispFeesId?: string | null;
      twispRepaymentId?: string | null;
      twispCardAccountSetId?: string | null;
      twispCardSpendSetId?: string | null;
      twispCardFeesId?: string | null;
      twispCardInterestId?: string | null;
      twispCreditLineAccountSetId?: string | null;
      twispCreditLineSpendId?: string | null;
      twispCreditLineFeesId?: string | null;
      twispCreditLineInterestId?: string | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
    }>;
    adminProgram?: {
      id: string;
      name: string;
      targetInterestRate?: string | null;
      minApr?: string | null;
      maxApr?: string | null;
      firstLateFeeAmount?: number | null;
      subsequentLateFeeAmount?: number | null;
      lateFeeStrategy?: LateFeeStrategy | null;
      returnedPaymentFeeCents?: number | null;
      returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
      foreignTransactionFeeRate?: any | null;
      cashAdvancesAllowed?: boolean | null;
      cashAdvanceFeeRate?: any | null;
      cashAdvanceFeeMinCents?: number | null;
      replacementCardFeeCents?: number | null;
      autopayPaymentTypes?: Array<string> | null;
      paymentDueDateGracePeriodDays?: number | null;
      lateFeeGracePeriodDays?: number | null;
      paymentDueDay?: number | null;
      statementGenerateDay?: number | null;
      minimumPaymentStrategy?: MinimumPaymentStrategy | null;
      minimumPaymentRate?: any | null;
      minimumPaymentFloorCents?: number | null;
      minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
      minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
      graceStrategy?: GraceStrategy | null;
      accrualBase?: AccrualBase | null;
      interestPostingPolicy?: InterestPostingPolicy | null;
      pdfTemplate?: PdfTemplate | null;
      chargeDrawdownFee?: boolean | null;
      twispJournalId?: string | null;
      twispIsoConfigId?: string | null;
      twispExposureAccountSetId?: string | null;
      lithicCardProgramToken?: string | null;
      lithicProductId?: string | null;
      active: boolean;
      insertedAt: any;
      updatedAt: any;
      partner: { id: string; name: string; active: boolean };
    } | null;
    partner?: { id: string; name: string } | null;
  } | null;
  loan?: {
    id: string;
    loanEvents: Array<{
      id?: string | null;
      type?: string | null;
      details?: unknown | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      actor?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
    }>;
    cardEvents: Array<{
      id?: string | null;
      type?: string | null;
      details?: unknown | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      card?: { id?: string | null; lastFour?: string | null } | null;
      actor?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
    }>;
  } | null;
  creditUtilization?: {
    limit: string;
    balance: string;
    availableAmount: string;
    spent: string;
    remaining: string;
  } | null;
  ledgerBalances?: {
    twispLoanAccount: { available?: string | null; pending?: string | null };
    twispFeesAccount: { available?: string | null; pending?: string | null };
    twispInterestAccount: { available?: string | null; pending?: string | null };
    twispRepaymentAccount: { available?: string | null; pending?: string | null };
    twispCreditLineAccount: { available?: string | null; pending?: string | null };
    twispCreditLineFeesAccount: { available?: string | null; pending?: string | null };
    twispCreditLineInterestAccount: { available?: string | null; pending?: string | null };
    twispCardAccount: { available?: string | null; pending?: string | null };
    twispCardFeesAccount: { available?: string | null; pending?: string | null };
    twispCardInterestAccount: { available?: string | null; pending?: string | null };
  } | null;
  loanStatements: Array<{
    id: string;
    billingPeriodStart: string;
    billingPeriodEnd: string;
    dueDate: string;
    previousBalance: string;
    totalPayments: string;
    otherCredits: string;
    totalPurchases: string;
    cashAdvance: string;
    interestCharged: string;
    feesCharged: string;
    newBalance: string;
    creditLimit: string;
    creditLimitAvailable: string;
    minimumPaymentDue: string;
    ytdFeesCharged: string;
    ytdInterestCharged: string;
    closingBalance?: string | null;
    interestApplied?: string | null;
    lateFeeApplied?: string | null;
    pdfFilename?: string | null;
    hasPdf?: boolean | null;
    pdfDataSnapshot?: unknown | null;
    purchaseBalanceAtPeriodEnd?: number | null;
    drawdownBalanceAtPeriodEnd?: number | null;
    interestBalanceAtPeriodEnd?: number | null;
    feeBalanceAtPeriodEnd?: number | null;
    repaymentBalanceAtPeriodEnd?: number | null;
    averageDailyBalance?: number | null;
    graceSavings?: number | null;
    newPurchaseBalanceAtPeriodEnd?: number | null;
    statementDate?: string | null;
    graceActive?: boolean | null;
    previousBalancePaidInFull?: boolean | null;
    lateFeeEligibleOn?: string | null;
    dueDateProcessedAt?: string | null;
    lateFeeProcessedAt?: string | null;
    autopayProcessedAt?: string | null;
    pdfGeneratedAt?: string | null;
    insertedAt: string;
    updatedAt: string;
    loan?: { id: string; partnerAccountNumber?: string | null } | null;
  }>;
  loanTransactions?: {
    transactions?: Array<{
      id?: string | null;
      entryId?: string | null;
      correlationId?: string | null;
      amount?: string | null;
      transmissionDate?: string | null;
      effectiveDate?: string | null;
      statementDate?: string | null;
      transactionType?: string | null;
      direction?: string | null;
      status?: string | null;
      tranCode?: string | null;
      rawTranCode?: string | null;
      metadata?: unknown | null;
      accountId?: string | null;
      merchantDetails?: {
        name?: string | null;
        city?: string | null;
        region?: string | null;
        displayName?: string | null;
      } | null;
      transactionBalance?: { encumbrance?: string | null; pending?: string | null; settled?: string | null } | null;
    } | null> | null;
    balance?: {
      availableEncumbrance?: string | null;
      availablePending?: string | null;
      availableSettled?: string | null;
      pending?: string | null;
    } | null;
    balanceRaw?: {
      available?: { cr?: string | null; dr?: string | null; normal?: string | null } | null;
      encumbrance?: { cr?: string | null; dr?: string | null; normal?: string | null } | null;
      pending?: { cr?: string | null; dr?: string | null; normal?: string | null } | null;
      settled?: { cr?: string | null; dr?: string | null; normal?: string | null } | null;
    } | null;
  } | null;
};

export type GetUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type GetUserQuery = {
  user?: {
    lithicAccountToken?: string | null;
    adminProgramId?: string | null;
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    displayName?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
    middleName?: string | null;
    phone?: string | null;
    dob?: string | null;
    isFriendsAndFam?: boolean | null;
    role?: UserRole | null;
    unhandledAlertsCount?: number | null;
    cards?: Array<{
      id?: string | null;
      status?: CardStatus | null;
      active?: boolean | null;
      referenceId?: string | null;
      processor?: CardProcessor | null;
      dateOpened?: any | null;
      blockedReason?: string | null;
      version?: number | null;
      lastFour?: string | null;
      expDate?: string | null;
      physicalActivatedAt?: any | null;
      insertedAt?: any | null;
    } | null> | null;
    billingAddress?: {
      isPoBox?: boolean | null;
      isBilling?: boolean | null;
      isShipping?: boolean | null;
      isDebitPayment?: boolean | null;
      isConfirmed?: boolean | null;
      id?: string | null;
      addressFirstLine?: string | null;
      addressSecondLine?: string | null;
      city?: string | null;
      state?: string | null;
      zip?: string | null;
    } | null;
    alerts: Array<{
      id: string;
      type: string;
      details?: unknown | null;
      handled: boolean;
      insertedAt?: any | null;
      updatedAt?: any | null;
    }>;
    loans: Array<{
      id: string;
      statementDay?: number | null;
      paymentDueDay?: number | null;
      partnerAccountNumber?: string | null;
      creditLimit?: number | null;
      initialBalance?: number | null;
      originationDate?: any | null;
      promoEndDate?: any | null;
      aprMargin?: string | null;
      initialApr?: string | null;
      isVariableApr?: boolean | null;
      status?: LoanStatus | null;
      delinquentSince?: any | null;
      daysDelinquent?: number | null;
      isDelinquent?: boolean | null;
      closedAt?: any | null;
      programId?: string | null;
      twispLoanId?: string | null;
      twispFeesId?: string | null;
      twispRepaymentId?: string | null;
      twispCardAccountSetId?: string | null;
      twispCardSpendSetId?: string | null;
      twispCardFeesId?: string | null;
      twispCardInterestId?: string | null;
      twispCreditLineAccountSetId?: string | null;
      twispCreditLineSpendId?: string | null;
      twispCreditLineFeesId?: string | null;
      twispCreditLineInterestId?: string | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
    }>;
    adminProgram?: {
      id: string;
      name: string;
      targetInterestRate?: string | null;
      minApr?: string | null;
      maxApr?: string | null;
      firstLateFeeAmount?: number | null;
      subsequentLateFeeAmount?: number | null;
      lateFeeStrategy?: LateFeeStrategy | null;
      returnedPaymentFeeCents?: number | null;
      returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
      foreignTransactionFeeRate?: any | null;
      cashAdvancesAllowed?: boolean | null;
      cashAdvanceFeeRate?: any | null;
      cashAdvanceFeeMinCents?: number | null;
      replacementCardFeeCents?: number | null;
      autopayPaymentTypes?: Array<string> | null;
      paymentDueDateGracePeriodDays?: number | null;
      lateFeeGracePeriodDays?: number | null;
      paymentDueDay?: number | null;
      statementGenerateDay?: number | null;
      minimumPaymentStrategy?: MinimumPaymentStrategy | null;
      minimumPaymentRate?: any | null;
      minimumPaymentFloorCents?: number | null;
      minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
      minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
      graceStrategy?: GraceStrategy | null;
      accrualBase?: AccrualBase | null;
      interestPostingPolicy?: InterestPostingPolicy | null;
      pdfTemplate?: PdfTemplate | null;
      chargeDrawdownFee?: boolean | null;
      twispJournalId?: string | null;
      twispIsoConfigId?: string | null;
      twispExposureAccountSetId?: string | null;
      lithicCardProgramToken?: string | null;
      lithicProductId?: string | null;
      active: boolean;
      insertedAt: any;
      updatedAt: any;
      partner: { id: string; name: string; active: boolean };
    } | null;
    partner?: { id: string; name: string } | null;
  } | null;
};

export type GetStatementQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetStatementQuery = {
  statement?: {
    id: string;
    billingPeriodStart: string;
    billingPeriodEnd: string;
    dueDate: string;
    previousBalance: string;
    totalPayments: string;
    otherCredits: string;
    totalPurchases: string;
    cashAdvance: string;
    interestCharged: string;
    feesCharged: string;
    newBalance: string;
    creditLimit: string;
    creditLimitAvailable: string;
    minimumPaymentDue: string;
    ytdFeesCharged: string;
    ytdInterestCharged: string;
    closingBalance?: string | null;
    interestApplied?: string | null;
    lateFeeApplied?: string | null;
    pdfFilename?: string | null;
    hasPdf?: boolean | null;
    pdfDataSnapshot?: unknown | null;
    purchaseBalanceAtPeriodEnd?: number | null;
    drawdownBalanceAtPeriodEnd?: number | null;
    interestBalanceAtPeriodEnd?: number | null;
    feeBalanceAtPeriodEnd?: number | null;
    repaymentBalanceAtPeriodEnd?: number | null;
    averageDailyBalance?: number | null;
    graceSavings?: number | null;
    newPurchaseBalanceAtPeriodEnd?: number | null;
    statementDate?: string | null;
    graceActive?: boolean | null;
    previousBalancePaidInFull?: boolean | null;
    lateFeeEligibleOn?: string | null;
    dueDateProcessedAt?: string | null;
    lateFeeProcessedAt?: string | null;
    autopayProcessedAt?: string | null;
    pdfGeneratedAt?: string | null;
    insertedAt: string;
    updatedAt: string;
    loan?: { id: string; partnerAccountNumber?: string | null } | null;
  } | null;
};

export type ListAchRequestsQueryVariables = Exact<{
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  statusSortDirection?: InputMaybe<SortDirection>;
  statusSelections?: InputMaybe<Array<InputMaybe<AchRequestStatus>> | InputMaybe<AchRequestStatus>>;
  achTypeSortDirection?: InputMaybe<SortDirection>;
  achTypeSelections?: InputMaybe<Array<InputMaybe<AchRequestType>> | InputMaybe<AchRequestType>>;
  settled?: InputMaybe<Scalars['Boolean']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListAchRequestsQuery = {
  listAchRequests?: {
    achRequests?: Array<{
      lockVersion?: number | null;
      parkedFromStatus?: string | null;
      inFlight: boolean;
      id: string;
      userId?: string | null;
      plaidAccountId?: string | null;
      achType?: string | null;
      status?: string | null;
      returnCode?: string | null;
      amountCents?: number | null;
      usioConfirmation?: string | null;
      failureReason?: string | null;
      settledAt?: any | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      ledgerRefId?: string | null;
      achEvents?: Array<{
        id: string;
        authCode?: string | null;
        avsCode?: string | null;
        batchNumber?: string | null;
        finalStatus?: string | null;
        errorMessage?: string | null;
        details?: unknown | null;
        achRequestId?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
      } | null> | null;
      recovery?: { retry: boolean; cancel: boolean; blockedReason?: string | null } | null;
      loan?: { id: string } | null;
      user?: { id?: string | null; firstName?: string | null; lastName?: string | null; email?: string | null } | null;
    }> | null;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type ListAdminActionRecordsQueryVariables = Exact<{
  idSortDirection?: InputMaybe<SortDirection>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  actionSortDirection?: InputMaybe<SortDirection>;
  actionSearch?: InputMaybe<Scalars['String']['input']>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  actorId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  actorFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  actorLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  actorEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListAdminActionRecordsQuery = {
  listAdminActionRecords?: {
    adminActionRecords?: Array<{
      id?: string | null;
      action?: string | null;
      description?: string | null;
      details?: unknown | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      actor?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
      user?: {
        id?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        displayName?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
        middleName?: string | null;
        phone?: string | null;
        dob?: string | null;
        isFriendsAndFam?: boolean | null;
        role?: UserRole | null;
        unhandledAlertsCount?: number | null;
      } | null;
    }> | null;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type ListCardsQueryVariables = Exact<{
  idSortDirection?: InputMaybe<SortDirection>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  referenceIdSearch?: InputMaybe<Scalars['String']['input']>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  statusSortDirection?: InputMaybe<SortDirection>;
  statusSelections?: InputMaybe<Array<InputMaybe<CardStatus>> | InputMaybe<CardStatus>>;
  referenceIdSortDirection?: InputMaybe<SortDirection>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  userFirstNameSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSortDirection?: InputMaybe<SortDirection>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSortDirection?: InputMaybe<SortDirection>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userIsFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListCardsQuery = {
  listCards?: {
    cards?: Array<{
      id?: string | null;
      status?: CardStatus | null;
      active?: boolean | null;
      referenceId?: string | null;
      processor?: CardProcessor | null;
      dateOpened?: any | null;
      blockedReason?: string | null;
      version?: number | null;
      lastFour?: string | null;
      expDate?: string | null;
      physicalActivatedAt?: any | null;
      insertedAt?: any | null;
    }> | null;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type ListDevicesQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  deviceTypeSelections?: InputMaybe<Array<InputMaybe<DeviceType>> | InputMaybe<DeviceType>>;
  deviceTypeSortDirection?: InputMaybe<SortDirection>;
  tokenSearch?: InputMaybe<Scalars['String']['input']>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  userIdSearch?: InputMaybe<Scalars['String']['input']>;
  userIdSortDirection?: InputMaybe<SortDirection>;
  userFirstNameSearch?: InputMaybe<Scalars['String']['input']>;
  userFirstNameSortDirection?: InputMaybe<SortDirection>;
  userLastNameSearch?: InputMaybe<Scalars['String']['input']>;
  userLastNameSortDirection?: InputMaybe<SortDirection>;
  userEmailSearch?: InputMaybe<Scalars['String']['input']>;
  userEmailSortDirection?: InputMaybe<SortDirection>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListDevicesQuery = {
  listDevices?: {
    devices?: Array<{
      id?: string | null;
      token?: string | null;
      deviceType?: DeviceType | null;
      deviceId?: string | null;
      userId?: string | null;
      lastUsedAt?: any | null;
      createdAt?: any | null;
    }> | null;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type ListDisputesQueryVariables = Exact<{
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  statusSortDirection?: InputMaybe<SortDirection>;
  statusSelections?: InputMaybe<Array<InputMaybe<DisputeStatus>> | InputMaybe<DisputeStatus>>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListDisputesQuery = {
  listDisputes?: {
    disputes?: Array<{
      id: string;
      userId?: string | null;
      disputeTransId: string;
      twispAccountId: string;
      cardRefNo?: string | null;
      status: DisputeStatus;
      originalAmountCents?: number | null;
      resolvedAmountCents?: number | null;
      creditType?: string | null;
      agentId?: string | null;
      declineReasons?: string | null;
      filedAt?: any | null;
      resolvedAt?: any | null;
      recalculationCompletedAt?: any | null;
      metadata?: unknown | null;
      insertedAt: any;
      updatedAt: any;
      events?: Array<{
        id: string;
        webhookEventId: string;
        mti?: string | null;
        de31?: string | null;
        serviceId?: string | null;
        amountCents?: number | null;
        direction?: string | null;
        de80Raw?: string | null;
        de80Parsed?: unknown | null;
        twispTransactionId?: string | null;
        insertedAt: any;
      } | null> | null;
    }> | null;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type ListLoansQueryVariables = Exact<{
  idSortDirection?: InputMaybe<SortDirection>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  partnerAccountNumberSortDirection?: InputMaybe<SortDirection>;
  partnerAccountNumberSearch?: InputMaybe<Scalars['String']['input']>;
  hasPromo?: InputMaybe<Scalars['Boolean']['input']>;
  statusSortDirection?: InputMaybe<SortDirection>;
  statusSelections?: InputMaybe<Array<InputMaybe<LoanStatus>> | InputMaybe<LoanStatus>>;
  programIdSortDirection?: InputMaybe<SortDirection>;
  programIdSearch?: InputMaybe<Scalars['String']['input']>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListLoansQuery = {
  listLoans?: {
    loans: Array<{
      id: string;
      statementDay?: number | null;
      paymentDueDay?: number | null;
      partnerAccountNumber?: string | null;
      creditLimit?: number | null;
      initialBalance?: number | null;
      originationDate?: any | null;
      promoEndDate?: any | null;
      aprMargin?: string | null;
      initialApr?: string | null;
      isVariableApr?: boolean | null;
      status?: LoanStatus | null;
      delinquentSince?: any | null;
      daysDelinquent?: number | null;
      isDelinquent?: boolean | null;
      closedAt?: any | null;
      programId?: string | null;
      twispLoanId?: string | null;
      twispFeesId?: string | null;
      twispRepaymentId?: string | null;
      twispCardAccountSetId?: string | null;
      twispCardSpendSetId?: string | null;
      twispCardFeesId?: string | null;
      twispCardInterestId?: string | null;
      twispCreditLineAccountSetId?: string | null;
      twispCreditLineSpendId?: string | null;
      twispCreditLineFeesId?: string | null;
      twispCreditLineInterestId?: string | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      program?: { id: string; name: string } | null;
      users: Array<{ id?: string | null; firstName?: string | null; lastName?: string | null }>;
    }>;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type ListProgramsQueryVariables = Exact<{
  idSortDirection?: InputMaybe<SortDirection>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  nameSortDirection?: InputMaybe<SortDirection>;
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListProgramsQuery = {
  listPrograms?: {
    programs: Array<{
      id: string;
      name: string;
      targetInterestRate?: string | null;
      minApr?: string | null;
      maxApr?: string | null;
      firstLateFeeAmount?: number | null;
      subsequentLateFeeAmount?: number | null;
      lateFeeStrategy?: LateFeeStrategy | null;
      returnedPaymentFeeCents?: number | null;
      returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
      foreignTransactionFeeRate?: any | null;
      cashAdvancesAllowed?: boolean | null;
      cashAdvanceFeeRate?: any | null;
      cashAdvanceFeeMinCents?: number | null;
      replacementCardFeeCents?: number | null;
      autopayPaymentTypes?: Array<string> | null;
      paymentDueDateGracePeriodDays?: number | null;
      lateFeeGracePeriodDays?: number | null;
      paymentDueDay?: number | null;
      statementGenerateDay?: number | null;
      minimumPaymentStrategy?: MinimumPaymentStrategy | null;
      minimumPaymentRate?: any | null;
      minimumPaymentFloorCents?: number | null;
      minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
      minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
      graceStrategy?: GraceStrategy | null;
      accrualBase?: AccrualBase | null;
      interestPostingPolicy?: InterestPostingPolicy | null;
      pdfTemplate?: PdfTemplate | null;
      chargeDrawdownFee?: boolean | null;
      twispJournalId?: string | null;
      twispIsoConfigId?: string | null;
      twispExposureAccountSetId?: string | null;
      lithicCardProgramToken?: string | null;
      lithicProductId?: string | null;
      active: boolean;
      insertedAt: any;
      updatedAt: any;
      partner: { id: string; name: string; active: boolean };
    }>;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type ListStatementsQueryVariables = Exact<{
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  creditLimitSortDirection?: InputMaybe<SortDirection>;
  idSortDirection?: InputMaybe<SortDirection>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  loanIdSortDirection?: InputMaybe<SortDirection>;
  loanIdSearch?: InputMaybe<Scalars['String']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  loanId?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListStatementsQuery = {
  listStatements?: {
    statements?: Array<{
      id: string;
      billingPeriodStart: string;
      billingPeriodEnd: string;
      dueDate: string;
      previousBalance: string;
      totalPayments: string;
      otherCredits: string;
      totalPurchases: string;
      cashAdvance: string;
      interestCharged: string;
      feesCharged: string;
      newBalance: string;
      creditLimit: string;
      creditLimitAvailable: string;
      minimumPaymentDue: string;
      ytdFeesCharged: string;
      ytdInterestCharged: string;
      closingBalance?: string | null;
      interestApplied?: string | null;
      lateFeeApplied?: string | null;
      pdfFilename?: string | null;
      hasPdf?: boolean | null;
      pdfDataSnapshot?: unknown | null;
      purchaseBalanceAtPeriodEnd?: number | null;
      drawdownBalanceAtPeriodEnd?: number | null;
      interestBalanceAtPeriodEnd?: number | null;
      feeBalanceAtPeriodEnd?: number | null;
      repaymentBalanceAtPeriodEnd?: number | null;
      averageDailyBalance?: number | null;
      graceSavings?: number | null;
      newPurchaseBalanceAtPeriodEnd?: number | null;
      statementDate?: string | null;
      graceActive?: boolean | null;
      previousBalancePaidInFull?: boolean | null;
      lateFeeEligibleOn?: string | null;
      dueDateProcessedAt?: string | null;
      lateFeeProcessedAt?: string | null;
      autopayProcessedAt?: string | null;
      pdfGeneratedAt?: string | null;
      insertedAt: string;
      updatedAt: string;
      loan?: { id: string; partnerAccountNumber?: string | null } | null;
    }> | null;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type ListUsersQueryVariables = Exact<{
  idSortDirection?: InputMaybe<SortDirection>;
  idSearch?: InputMaybe<Scalars['String']['input']>;
  firstNameSortDirection?: InputMaybe<SortDirection>;
  firstNameSearch?: InputMaybe<Scalars['String']['input']>;
  lastNameSortDirection?: InputMaybe<SortDirection>;
  lastNameSearch?: InputMaybe<Scalars['String']['input']>;
  phoneSortDirection?: InputMaybe<SortDirection>;
  phoneSearch?: InputMaybe<Scalars['String']['input']>;
  dobSortDirection?: InputMaybe<SortDirection>;
  dobSearch?: InputMaybe<Scalars['String']['input']>;
  isFriendsAndFam?: InputMaybe<Scalars['Boolean']['input']>;
  insertedAtSortDirection?: InputMaybe<SortDirection>;
  roleSortDirection?: InputMaybe<SortDirection>;
  roleSelections?: InputMaybe<Array<InputMaybe<UserRole>> | InputMaybe<UserRole>>;
  adminProgramIdSortDirection?: InputMaybe<SortDirection>;
  adminProgramIdSearch?: InputMaybe<Scalars['String']['input']>;
  paginationDetailsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  fullResults?: InputMaybe<Scalars['Boolean']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListUsersQuery = {
  listUsers?: {
    users?: Array<{
      lithicAccountToken?: string | null;
      adminProgramId?: string | null;
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      displayName?: string | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      middleName?: string | null;
      phone?: string | null;
      dob?: string | null;
      isFriendsAndFam?: boolean | null;
      role?: UserRole | null;
      unhandledAlertsCount?: number | null;
      cards?: Array<{
        id?: string | null;
        status?: CardStatus | null;
        active?: boolean | null;
        referenceId?: string | null;
        processor?: CardProcessor | null;
        dateOpened?: any | null;
        blockedReason?: string | null;
        version?: number | null;
        lastFour?: string | null;
        expDate?: string | null;
        physicalActivatedAt?: any | null;
        insertedAt?: any | null;
      } | null> | null;
      billingAddress?: {
        isPoBox?: boolean | null;
        isBilling?: boolean | null;
        isShipping?: boolean | null;
        isDebitPayment?: boolean | null;
        isConfirmed?: boolean | null;
        id?: string | null;
        addressFirstLine?: string | null;
        addressSecondLine?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
      } | null;
      alerts: Array<{
        id: string;
        type: string;
        details?: unknown | null;
        handled: boolean;
        insertedAt?: any | null;
        updatedAt?: any | null;
      }>;
      loans: Array<{
        id: string;
        statementDay?: number | null;
        paymentDueDay?: number | null;
        partnerAccountNumber?: string | null;
        creditLimit?: number | null;
        initialBalance?: number | null;
        originationDate?: any | null;
        promoEndDate?: any | null;
        aprMargin?: string | null;
        initialApr?: string | null;
        isVariableApr?: boolean | null;
        status?: LoanStatus | null;
        delinquentSince?: any | null;
        daysDelinquent?: number | null;
        isDelinquent?: boolean | null;
        closedAt?: any | null;
        programId?: string | null;
        twispLoanId?: string | null;
        twispFeesId?: string | null;
        twispRepaymentId?: string | null;
        twispCardAccountSetId?: string | null;
        twispCardSpendSetId?: string | null;
        twispCardFeesId?: string | null;
        twispCardInterestId?: string | null;
        twispCreditLineAccountSetId?: string | null;
        twispCreditLineSpendId?: string | null;
        twispCreditLineFeesId?: string | null;
        twispCreditLineInterestId?: string | null;
        insertedAt?: any | null;
        updatedAt?: any | null;
      }>;
      adminProgram?: {
        id: string;
        name: string;
        targetInterestRate?: string | null;
        minApr?: string | null;
        maxApr?: string | null;
        firstLateFeeAmount?: number | null;
        subsequentLateFeeAmount?: number | null;
        lateFeeStrategy?: LateFeeStrategy | null;
        returnedPaymentFeeCents?: number | null;
        returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
        foreignTransactionFeeRate?: any | null;
        cashAdvancesAllowed?: boolean | null;
        cashAdvanceFeeRate?: any | null;
        cashAdvanceFeeMinCents?: number | null;
        replacementCardFeeCents?: number | null;
        autopayPaymentTypes?: Array<string> | null;
        paymentDueDateGracePeriodDays?: number | null;
        lateFeeGracePeriodDays?: number | null;
        paymentDueDay?: number | null;
        statementGenerateDay?: number | null;
        minimumPaymentStrategy?: MinimumPaymentStrategy | null;
        minimumPaymentRate?: any | null;
        minimumPaymentFloorCents?: number | null;
        minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
        minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
        graceStrategy?: GraceStrategy | null;
        accrualBase?: AccrualBase | null;
        interestPostingPolicy?: InterestPostingPolicy | null;
        pdfTemplate?: PdfTemplate | null;
        chargeDrawdownFee?: boolean | null;
        twispJournalId?: string | null;
        twispIsoConfigId?: string | null;
        twispExposureAccountSetId?: string | null;
        lithicCardProgramToken?: string | null;
        lithicProductId?: string | null;
        active: boolean;
        insertedAt: any;
        updatedAt: any;
        partner: { id: string; name: string; active: boolean };
      } | null;
      partner?: { id: string; name: string } | null;
    }> | null;
    pagination: {
      resultsPerPage: number;
      totalPages: number;
      totalRecords: number;
      pageNumber: number;
      hasNextPage: boolean;
    };
  } | null;
};

export type ListVelocityControlsQueryVariables = Exact<{ [key: string]: never }>;

export type ListVelocityControlsQuery = {
  listVelocityControls?: Array<{
    id?: string | null;
    name?: string | null;
    journalId?: string | null;
    description?: string | null;
    condition?: string | null;
    enforcementAction?: string | null;
    accountId?: string | null;
    accountKind?: string | null;
    limits?: Array<{
      id?: string | null;
      name?: string | null;
      description?: string | null;
      currency?: string | null;
      layer?: string | null;
      amount?: string | null;
      normalBalanceType?: string | null;
      start?: string | null;
      end?: string | null;
    } | null> | null;
  } | null> | null;
};

export type LoansWithoutServicingDataQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;

export type LoansWithoutServicingDataQuery = {
  loansWithoutServicingData: Array<{
    id: string;
    partnerAccountNumber?: string | null;
    originationDate?: any | null;
    status: string;
    members: Array<{ userId: string; firstName?: string | null; lastName?: string | null; joinedAt: any }>;
  }>;
};

export type PendingDrawdownsQueryVariables = Exact<{ [key: string]: never }>;

export type PendingDrawdownsQuery = {
  pendingDrawdowns: Array<{
    id: string;
    status?: string | null;
    userId?: string | null;
    amountCents?: number | null;
    insertedAt?: any | null;
    plaidAccountId?: string | null;
    ledgerRefId?: string | null;
    loan?: { id: string; partnerAccountNumber?: string | null; programId?: string | null } | null;
  }>;
};

export type SearchUsersQueryVariables = Exact<{
  firstNameSearch?: InputMaybe<Scalars['String']['input']>;
  lastNameSearch?: InputMaybe<Scalars['String']['input']>;
  phoneSearch?: InputMaybe<Scalars['String']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SearchUsersQuery = {
  listUsers?: {
    users?: Array<{
      id?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      email?: string | null;
      displayName?: string | null;
      insertedAt?: any | null;
      updatedAt?: any | null;
      middleName?: string | null;
      phone?: string | null;
      dob?: string | null;
      isFriendsAndFam?: boolean | null;
      role?: UserRole | null;
      unhandledAlertsCount?: number | null;
    }> | null;
  } | null;
};

export type LedgerBalancesQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;

export type LedgerBalancesQuery = {
  ledgerBalances?: {
    twispLoanAccount: { available?: string | null; pending?: string | null };
    twispFeesAccount: { available?: string | null; pending?: string | null };
    twispInterestAccount: { available?: string | null; pending?: string | null };
    twispRepaymentAccount: { available?: string | null; pending?: string | null };
    twispCreditLineAccount: { available?: string | null; pending?: string | null };
    twispCreditLineFeesAccount: { available?: string | null; pending?: string | null };
    twispCreditLineInterestAccount: { available?: string | null; pending?: string | null };
    twispCardAccount: { available?: string | null; pending?: string | null };
    twispCardFeesAccount: { available?: string | null; pending?: string | null };
    twispCardInterestAccount: { available?: string | null; pending?: string | null };
  } | null;
};

export type ListPartnersQueryVariables = Exact<{ [key: string]: never }>;

export type ListPartnersQuery = { listPartners?: Array<{ id: string; name: string; active: boolean } | null> | null };

export type ListPrimeRatesQueryVariables = Exact<{ [key: string]: never }>;

export type ListPrimeRatesQuery = {
  listPrimeRates?: Array<{
    id: string;
    effectiveDate: any;
    rate: string;
    source?: string | null;
    insertedAt?: any | null;
    updatedAt?: any | null;
  } | null> | null;
};

export type ListReconciliationRunsQueryVariables = Exact<{
  check: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;

export type ListReconciliationRunsQuery = {
  listReconciliationRuns: Array<{
    id: string;
    check: string;
    asOf: any;
    startedAt: any;
    finishedAt: any;
    examinedCount: number;
    findings: unknown;
    error?: string | null;
  }>;
};

export type PlatformBalancesQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
}>;

export type PlatformBalancesQuery = {
  platformBalances?: {
    accounts: Array<{
      key: string;
      label: string;
      kind: PlatformBalanceAccountKind;
      normalBalanceType?: string | null;
      balance: { available?: string | null; pending?: string | null };
    }>;
    exposureRollup: { available?: string | null; pending?: string | null };
  } | null;
};

export type ProgramQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;

export type ProgramQuery = {
  program?: {
    id: string;
    name: string;
    targetInterestRate?: string | null;
    minApr?: string | null;
    maxApr?: string | null;
    firstLateFeeAmount?: number | null;
    subsequentLateFeeAmount?: number | null;
    lateFeeStrategy?: LateFeeStrategy | null;
    returnedPaymentFeeCents?: number | null;
    returnedPaymentFeeStrategy?: ReturnedPaymentFeeStrategy | null;
    foreignTransactionFeeRate?: any | null;
    cashAdvancesAllowed?: boolean | null;
    cashAdvanceFeeRate?: any | null;
    cashAdvanceFeeMinCents?: number | null;
    replacementCardFeeCents?: number | null;
    autopayPaymentTypes?: Array<string> | null;
    paymentDueDateGracePeriodDays?: number | null;
    lateFeeGracePeriodDays?: number | null;
    paymentDueDay?: number | null;
    statementGenerateDay?: number | null;
    minimumPaymentStrategy?: MinimumPaymentStrategy | null;
    minimumPaymentRate?: any | null;
    minimumPaymentFloorCents?: number | null;
    minimumPaymentAllocationOrder?: MinimumPaymentAllocationOrder | null;
    minimumPaymentClassOrder?: MinimumPaymentClassOrder | null;
    graceStrategy?: GraceStrategy | null;
    accrualBase?: AccrualBase | null;
    interestPostingPolicy?: InterestPostingPolicy | null;
    pdfTemplate?: PdfTemplate | null;
    chargeDrawdownFee?: boolean | null;
    twispJournalId?: string | null;
    twispIsoConfigId?: string | null;
    twispExposureAccountSetId?: string | null;
    lithicCardProgramToken?: string | null;
    lithicProductId?: string | null;
    active: boolean;
    insertedAt: any;
    updatedAt: any;
    partner: { id: string; name: string; active: boolean };
  } | null;
};

export type ReconciliationStatusQueryVariables = Exact<{ [key: string]: never }>;

export type ReconciliationStatusQuery = {
  reconciliationStatus: Array<{
    check: string;
    severity: ReconciliationSeverity;
    newFindings: unknown;
    latestRun?: {
      id: string;
      check: string;
      asOf: any;
      startedAt: any;
      finishedAt: any;
      examinedCount: number;
      findings: unknown;
      error?: string | null;
    } | null;
  }>;
};

export type ReportAccountStateCsvQueryVariables = Exact<{
  date: Scalars['Date']['input'];
}>;

export type ReportAccountStateCsvQuery = { reportAccountStateCsv?: string | null };

export type ReportDatesQueryVariables = Exact<{ [key: string]: never }>;

export type ReportDatesQuery = { reportDates?: Array<any | null> | null };

export type ReportLithicSettlementCsvQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  reportDate: Scalars['Date']['input'];
}>;

export type ReportLithicSettlementCsvQuery = { reportLithicSettlementCsv?: string | null };

export type ReportPaymentsRemittanceCsvQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;

export type ReportPaymentsRemittanceCsvQuery = { reportPaymentsRemittanceCsv?: string | null };

export type ReportTransactionsCsvQueryVariables = Exact<{
  date: Scalars['Date']['input'];
}>;

export type ReportTransactionsCsvQuery = { reportTransactionsCsv?: string | null };

export type UsioPrefundingBalanceQueryVariables = Exact<{
  programId: Scalars['ID']['input'];
}>;

export type UsioPrefundingBalanceQuery = { usioPrefundingBalance: { achPrefundingBalance: number } };

export const BasicFeeTransactionFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicFeeTransactionFragment on AddFeeTransactionPayload {
    transactionId
  }
`;
export const BaseBalanceRawItemFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseBalanceRawItem on BalanceRawItem {
    cr
    dr
    normal
  }
`;
export const BaseBalanceRawDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseBalanceRawDetails on BalanceRawDetails {
    available {
      ...BaseBalanceRawItem
    }
    encumbrance {
      ...BaseBalanceRawItem
    }
    pending {
      ...BaseBalanceRawItem
    }
    settled {
      ...BaseBalanceRawItem
    }
  }
  ${BaseBalanceRawItemFragmentDoc}
`;
export const BaseBalanceDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseBalanceDetails on BalanceDetails {
    availableEncumbrance
    availablePending
    availableSettled
    pending
  }
`;
export const BaseCreditUtilizationFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseCreditUtilization on CreditUtilizationData {
    limit
    balance
    availableAmount
    spent
    remaining
  }
`;
export const BaseDueDateProcessingResultFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseDueDateProcessingResult on DueDateProcessingResult {
    paymentType
    paymentAmount
    interestApplied
    lateFeeApplied
    isDelinquent
    remainingBalance
    daysDelinquent
  }
`;
export const BaseDailyReportFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseDailyReport on DailyReport {
    id
    reportDate
    latestBalance
    lastPaymentAmount
    lastPaymentDate
    creditLimit
    loanBalance
    repaymentBalance
    feesBalance
    cardSetBalance
    cardSpendBalance
    cardFeesBalance
    cardInterestBalance
    creditLineSetBalance
    creditLineSpendBalance
    creditLineFeesBalance
    creditLineInterestBalance
    recalculationReason
    recalculationBatchId
    insertedAt
    updatedAt
  }
`;
export const BasePrimeRateFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BasePrimeRateFragment on PrimeRate {
    id
    effectiveDate
    rate
    source
    insertedAt
    updatedAt
  }
`;
export const BaseLedgerBalanceFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseLedgerBalance on LedgerBalance {
    available
    pending
  }
`;
export const BaseLateFeeProcessingResultFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseLateFeeProcessingResult on LateFeeProcessingResult {
    status
    lateFeeApplied
    statementId
    reason
    dryRun
    feeTier
    paymentStatus
    statementDueDate
    statementNewBalance
    minimumPaymentDue
  }
`;
export const BaseAchAuthorizationFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseAchAuthorization on AchAuthorization {
    id
    userId
    recordType
    status
    renderedTextSnapshot
    textVersion
    acceptedAtServer
    acceptedAtClient
    revokedAt
    ipAddress
    deviceIdentifier
    bankAccountLast4
    routingNumber
    plaidAccountId
    plaidItemId
    parentAuthorizationId
    autoPaySettingsId
    metadata
    insertedAt
    updatedAt
  }
`;
export const BaseAchReturnAllocationFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseAchReturnAllocation on AllocationPreview {
    targetAccountId
    amount
  }
`;
export const BaseAchReturnAdjustmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseAchReturnAdjustment on AdjustmentSummary {
    statementId
    amountCents
    type
    effectiveDate
  }
`;
export const BaseAchReturnResultFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseAchReturnResult on AchReturnResult {
    dryRun
    returnCode
    returnReason
    returnCategory
    returnFeeWillPost
    repaymentAmountCents
    message
    achRequest {
      id
      status
      amountCents
      returnCode
    }
    allocationsToReverse {
      ...BaseAchReturnAllocation
    }
    affectedStatementIds
    returnFeeCents
    allocationsReversed
    interestAdjustments {
      ...BaseAchReturnAdjustment
    }
    feeAdjustments {
      ...BaseAchReturnAdjustment
    }
    delinquencyTriggered
  }
  ${BaseAchReturnAllocationFragmentDoc}
  ${BaseAchReturnAdjustmentFragmentDoc}
`;
export const BaseReconciliationRunFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseReconciliationRunFragment on ReconciliationRun {
    id
    check
    asOf
    startedAt
    finishedAt
    examinedCount
    findings
    error
  }
`;
export const BasicCardFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicCardFragment on Card {
    id
    status
    active
    referenceId
    processor
    dateOpened
    blockedReason
    version
    lastFour
    expDate
    physicalActivatedAt
    insertedAt
  }
`;
export const CardFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment CardFragment on Card {
    ...BasicCardFragment
  }
  ${BasicCardFragmentFragmentDoc}
`;
export const BasicUserFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicUserFragment on User {
    id
    firstName
    lastName
    email
    displayName
    insertedAt
    updatedAt
    middleName
    phone
    dob
    isFriendsAndFam
    role
    unhandledAlertsCount
  }
`;
export const BasicAddressFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicAddressFragment on Address {
    id
    addressFirstLine
    addressSecondLine
    city
    state
    zip
  }
`;
export const AddressFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment AddressFragment on Address {
    ...BasicAddressFragment
    isPoBox
    isBilling
    isShipping
    isDebitPayment
    isConfirmed
  }
  ${BasicAddressFragmentFragmentDoc}
`;
export const UserWithoutCardsFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment UserWithoutCardsFragment on User {
    ...BasicUserFragment
    billingAddress {
      ...AddressFragment
    }
  }
  ${BasicUserFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
`;
export const CardWithUserFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment CardWithUserFragment on Card {
    ...CardFragment
    user {
      ...UserWithoutCardsFragment
    }
  }
  ${CardFragmentFragmentDoc}
  ${UserWithoutCardsFragmentFragmentDoc}
`;
export const BaseMerchantDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseMerchantDetails on MerchantDetails {
    name
    city
    region
    displayName
  }
`;
export const BaseTransactionBalanceFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseTransactionBalance on TransactionBalance {
    encumbrance
    pending
    settled
  }
`;
export const TransactionDetailsFragmentDoc = /*#__PURE__*/ gql`
  fragment TransactionDetails on TransactionDetailsSuperAdmin {
    id
    entryId
    correlationId
    amount
    transmissionDate
    effectiveDate
    statementDate
    transactionType
    direction
    status
    tranCode
    rawTranCode
    metadata
    accountId
    merchantDetails {
      ...BaseMerchantDetails
    }
    transactionBalance {
      ...BaseTransactionBalance
    }
  }
  ${BaseMerchantDetailsFragmentDoc}
  ${BaseTransactionBalanceFragmentDoc}
`;
export const BaseVelocityControlFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseVelocityControl on VelocityControl {
    id
    name
    journalId
    description
    condition
    enforcementAction
    accountId
    accountKind
  }
`;
export const BaseVelocityLimitFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseVelocityLimit on VelocityLimit {
    id
    name
    description
    currency
    layer
    amount
    normalBalanceType
    start
    end
  }
`;
export const VelocityControlFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment VelocityControlFragment on VelocityControl {
    ...BaseVelocityControl
    limits {
      ...BaseVelocityLimit
    }
  }
  ${BaseVelocityControlFragmentDoc}
  ${BaseVelocityLimitFragmentDoc}
`;
export const BaseAchRequestFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseAchRequest on AchRequest {
    lockVersion
    parkedFromStatus
    inFlight
    recovery {
      retry
      cancel
      blockedReason
    }
    id
    userId
    plaidAccountId
    achType
    status
    returnCode
    amountCents
    usioConfirmation
    failureReason
    settledAt
    insertedAt
    updatedAt
    ledgerRefId
    loan {
      id
    }
    user {
      id
      firstName
      lastName
      email
    }
  }
`;
export const BaseAchEventFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseAchEvent on AchEvent {
    id
    authCode
    avsCode
    batchNumber
    finalStatus
    errorMessage
    details
    achRequestId
    insertedAt
    updatedAt
  }
`;
export const AchRequestFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment AchRequestFragment on AchRequest {
    ...BaseAchRequest
    achEvents {
      ...BaseAchEvent
    }
  }
  ${BaseAchRequestFragmentDoc}
  ${BaseAchEventFragmentDoc}
`;
export const BaseCardDisputeFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseCardDispute on CardDispute {
    id
    userId
    disputeTransId
    twispAccountId
    cardRefNo
    status
    originalAmountCents
    resolvedAmountCents
    creditType
    agentId
    declineReasons
    filedAt
    resolvedAt
    recalculationCompletedAt
    metadata
    insertedAt
    updatedAt
  }
`;
export const BaseCardDisputeEventFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseCardDisputeEvent on CardDisputeEvent {
    id
    webhookEventId
    mti
    de31
    serviceId
    amountCents
    direction
    de80Raw
    de80Parsed
    twispTransactionId
    insertedAt
  }
`;
export const CardDisputeFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment CardDisputeFragment on CardDispute {
    ...BaseCardDispute
    events {
      ...BaseCardDisputeEvent
    }
  }
  ${BaseCardDisputeFragmentDoc}
  ${BaseCardDisputeEventFragmentDoc}
`;
export const BaseUserEventFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseUserEventFragment on UserEvent {
    id
    type
    details
    insertedAt
    updatedAt
  }
`;
export const UserEventFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment UserEventFragment on UserEvent {
    ...BaseUserEventFragment
    actor {
      ...BasicUserFragment
    }
  }
  ${BaseUserEventFragmentFragmentDoc}
  ${BasicUserFragmentFragmentDoc}
`;
export const BaseLoanEventFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseLoanEventFragment on LoanEvent {
    id
    type
    details
    insertedAt
    updatedAt
  }
`;
export const LoanEventFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment LoanEventFragment on LoanEvent {
    ...BaseLoanEventFragment
    actor {
      ...BasicUserFragment
    }
  }
  ${BaseLoanEventFragmentFragmentDoc}
  ${BasicUserFragmentFragmentDoc}
`;
export const BaseCardEventFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseCardEventFragment on CardEvent {
    id
    type
    details
    insertedAt
    updatedAt
  }
`;
export const CardEventFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment CardEventFragment on CardEvent {
    ...BaseCardEventFragment
    card {
      id
      lastFour
    }
    actor {
      ...BasicUserFragment
    }
  }
  ${BaseCardEventFragmentFragmentDoc}
  ${BasicUserFragmentFragmentDoc}
`;
export const AdminActionRecordFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment AdminActionRecordFragment on AdminActionRecord {
    id
    action
    description
    details
    insertedAt
    updatedAt
    actor {
      ...BasicUserFragment
    }
    user {
      ...BasicUserFragment
    }
  }
  ${BasicUserFragmentFragmentDoc}
`;
export const SpendingControlFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment SpendingControlFragment on SpendingControl {
    type
    status
    enabled
    amountCents
    granularity
    updatedAt
  }
`;
export const BasicAlertFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicAlertFragment on Alert {
    id
    type
    details
    handled
    insertedAt
    updatedAt
  }
`;
export const AlertFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment AlertFragment on Alert {
    ...BasicAlertFragment
  }
  ${BasicAlertFragmentFragmentDoc}
`;
export const BasicLoanFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicLoanFragment on Loan {
    id
    statementDay
    paymentDueDay
    partnerAccountNumber
    creditLimit
    initialBalance
    originationDate
    promoEndDate
    aprMargin
    initialApr
    isVariableApr
    status
    delinquentSince
    daysDelinquent
    isDelinquent
    closedAt
    programId
    twispLoanId
    twispFeesId
    twispRepaymentId
    twispCardAccountSetId
    twispCardSpendSetId
    twispCardFeesId
    twispCardInterestId
    twispCreditLineAccountSetId
    twispCreditLineSpendId
    twispCreditLineFeesId
    twispCreditLineInterestId
    insertedAt
    updatedAt
  }
`;
export const BaseProgramFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BaseProgramFragment on Program {
    id
    name
    partner {
      id
      name
      active
    }
    targetInterestRate
    minApr
    maxApr
    firstLateFeeAmount
    subsequentLateFeeAmount
    lateFeeStrategy
    returnedPaymentFeeCents
    returnedPaymentFeeStrategy
    foreignTransactionFeeRate
    cashAdvancesAllowed
    cashAdvanceFeeRate
    cashAdvanceFeeMinCents
    replacementCardFeeCents
    autopayPaymentTypes
    paymentDueDateGracePeriodDays
    lateFeeGracePeriodDays
    paymentDueDay
    statementGenerateDay
    minimumPaymentStrategy
    minimumPaymentRate
    minimumPaymentFloorCents
    minimumPaymentAllocationOrder
    minimumPaymentClassOrder
    graceStrategy
    accrualBase
    interestPostingPolicy
    pdfTemplate
    chargeDrawdownFee
    twispJournalId
    twispIsoConfigId
    twispExposureAccountSetId
    lithicCardProgramToken
    lithicProductId
    active
    insertedAt
    updatedAt
  }
`;
export const UserFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment UserFragment on User {
    ...BasicUserFragment
    lithicAccountToken
    cards {
      ...CardFragment
    }
    billingAddress {
      ...AddressFragment
    }
    alerts {
      ...AlertFragment
    }
    loans {
      ...BasicLoanFragment
    }
    adminProgramId
    adminProgram {
      ...BaseProgramFragment
    }
    partner {
      id
      name
    }
  }
  ${BasicUserFragmentFragmentDoc}
  ${CardFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${AlertFragmentFragmentDoc}
  ${BasicLoanFragmentFragmentDoc}
  ${BaseProgramFragmentFragmentDoc}
`;
export const LoanFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment LoanFragment on Loan {
    ...BasicLoanFragment
    currentApr
    currentPrimeRate
    program {
      ...BaseProgramFragment
    }
    users {
      ...BasicUserFragment
    }
    cards {
      ...CardFragment
      user {
        id
        firstName
        lastName
      }
    }
  }
  ${BasicLoanFragmentFragmentDoc}
  ${BaseProgramFragmentFragmentDoc}
  ${BasicUserFragmentFragmentDoc}
  ${CardFragmentFragmentDoc}
`;
export const BasicStatementFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicStatementFragment on Statement {
    id
    billingPeriodStart
    billingPeriodEnd
    dueDate
    previousBalance
    totalPayments
    otherCredits
    totalPurchases
    cashAdvance
    interestCharged
    feesCharged
    newBalance
    creditLimit
    creditLimitAvailable
    minimumPaymentDue
    ytdFeesCharged
    ytdInterestCharged
    closingBalance
    interestApplied
    lateFeeApplied
    pdfFilename
    hasPdf
    pdfDataSnapshot
    purchaseBalanceAtPeriodEnd
    drawdownBalanceAtPeriodEnd
    interestBalanceAtPeriodEnd
    feeBalanceAtPeriodEnd
    repaymentBalanceAtPeriodEnd
    averageDailyBalance
    graceSavings
    newPurchaseBalanceAtPeriodEnd
    statementDate
    graceActive
    previousBalancePaidInFull
    loan {
      id
      partnerAccountNumber
    }
    lateFeeEligibleOn
    dueDateProcessedAt
    lateFeeProcessedAt
    autopayProcessedAt
    pdfGeneratedAt
    insertedAt
    updatedAt
  }
`;
export const StatementFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment StatementFragment on Statement {
    ...BasicStatementFragment
  }
  ${BasicStatementFragmentFragmentDoc}
`;
export const BasicPaginationFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment BasicPaginationFragment on PaginationDetails {
    totalRecords
    pageNumber
    hasNextPage
  }
`;
export const PaginationFragmentFragmentDoc = /*#__PURE__*/ gql`
  fragment PaginationFragment on PaginationDetails {
    ...BasicPaginationFragment
    resultsPerPage
    totalPages
  }
  ${BasicPaginationFragmentFragmentDoc}
`;
export const AddLoanMemberMutationDocument = /*#__PURE__*/ gql`
  mutation AddLoanMemberMutation($loanId: ID!, $userId: ID!, $cardRef: String, $lastFour: String) {
    addLoanMember(loanId: $loanId, userId: $userId, cardRef: $cardRef, lastFour: $lastFour) {
      id
    }
  }
`;
export type AddLoanMemberMutationMutationFn = Apollo.MutationFunction<
  AddLoanMemberMutationMutation,
  AddLoanMemberMutationMutationVariables
>;

/**
 * __useAddLoanMemberMutationMutation__
 *
 * To run a mutation, you first call `useAddLoanMemberMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLoanMemberMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLoanMemberMutationMutation, { data, loading, error }] = useAddLoanMemberMutationMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      userId: // value for 'userId'
 *      cardRef: // value for 'cardRef'
 *      lastFour: // value for 'lastFour'
 *   },
 * });
 */
export function useAddLoanMemberMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<AddLoanMemberMutationMutation, AddLoanMemberMutationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddLoanMemberMutationMutation, AddLoanMemberMutationMutationVariables>(
    AddLoanMemberMutationDocument,
    options,
  );
}
export type AddLoanMemberMutationMutationHookResult = ReturnType<typeof useAddLoanMemberMutationMutation>;
export type AddLoanMemberMutationMutationResult = Apollo.MutationResult<AddLoanMemberMutationMutation>;
export type AddLoanMemberMutationMutationOptions = Apollo.BaseMutationOptions<
  AddLoanMemberMutationMutation,
  AddLoanMemberMutationMutationVariables
>;
export const CreateCardActivatedAlertDocument = /*#__PURE__*/ gql`
  mutation createCardActivatedAlert($userId: ID!) {
    createCardActivatedAlert(userId: $userId) {
      ...AlertFragment
    }
  }
  ${AlertFragmentFragmentDoc}
`;
export type CreateCardActivatedAlertMutationFn = Apollo.MutationFunction<
  CreateCardActivatedAlertMutation,
  CreateCardActivatedAlertMutationVariables
>;

/**
 * __useCreateCardActivatedAlertMutation__
 *
 * To run a mutation, you first call `useCreateCardActivatedAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCardActivatedAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCardActivatedAlertMutation, { data, loading, error }] = useCreateCardActivatedAlertMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateCardActivatedAlertMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCardActivatedAlertMutation, CreateCardActivatedAlertMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCardActivatedAlertMutation, CreateCardActivatedAlertMutationVariables>(
    CreateCardActivatedAlertDocument,
    options,
  );
}
export type CreateCardActivatedAlertMutationHookResult = ReturnType<typeof useCreateCardActivatedAlertMutation>;
export type CreateCardActivatedAlertMutationResult = Apollo.MutationResult<CreateCardActivatedAlertMutation>;
export type CreateCardActivatedAlertMutationOptions = Apollo.BaseMutationOptions<
  CreateCardActivatedAlertMutation,
  CreateCardActivatedAlertMutationVariables
>;
export const CreateStatementPaymentDueAlertDocument = /*#__PURE__*/ gql`
  mutation createStatementPaymentDueAlert($userId: ID!) {
    createStatementPaymentDueAlert(userId: $userId) {
      ...AlertFragment
    }
  }
  ${AlertFragmentFragmentDoc}
`;
export type CreateStatementPaymentDueAlertMutationFn = Apollo.MutationFunction<
  CreateStatementPaymentDueAlertMutation,
  CreateStatementPaymentDueAlertMutationVariables
>;

/**
 * __useCreateStatementPaymentDueAlertMutation__
 *
 * To run a mutation, you first call `useCreateStatementPaymentDueAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStatementPaymentDueAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStatementPaymentDueAlertMutation, { data, loading, error }] = useCreateStatementPaymentDueAlertMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateStatementPaymentDueAlertMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStatementPaymentDueAlertMutation,
    CreateStatementPaymentDueAlertMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateStatementPaymentDueAlertMutation, CreateStatementPaymentDueAlertMutationVariables>(
    CreateStatementPaymentDueAlertDocument,
    options,
  );
}
export type CreateStatementPaymentDueAlertMutationHookResult = ReturnType<
  typeof useCreateStatementPaymentDueAlertMutation
>;
export type CreateStatementPaymentDueAlertMutationResult =
  Apollo.MutationResult<CreateStatementPaymentDueAlertMutation>;
export type CreateStatementPaymentDueAlertMutationOptions = Apollo.BaseMutationOptions<
  CreateStatementPaymentDueAlertMutation,
  CreateStatementPaymentDueAlertMutationVariables
>;
export const CloseLoanDocument = /*#__PURE__*/ gql`
  mutation CloseLoan($loanId: ID!, $effectiveDate: Date!, $reason: LoanClosureReason!, $requestedAt: Date) {
    closeLoan(loanId: $loanId, effectiveDate: $effectiveDate, reason: $reason, requestedAt: $requestedAt) {
      id
      status
      closedAt
    }
  }
`;
export type CloseLoanMutationFn = Apollo.MutationFunction<CloseLoanMutation, CloseLoanMutationVariables>;

/**
 * __useCloseLoanMutation__
 *
 * To run a mutation, you first call `useCloseLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeLoanMutation, { data, loading, error }] = useCloseLoanMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      effectiveDate: // value for 'effectiveDate'
 *      reason: // value for 'reason'
 *      requestedAt: // value for 'requestedAt'
 *   },
 * });
 */
export function useCloseLoanMutation(
  baseOptions?: Apollo.MutationHookOptions<CloseLoanMutation, CloseLoanMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloseLoanMutation, CloseLoanMutationVariables>(CloseLoanDocument, options);
}
export type CloseLoanMutationHookResult = ReturnType<typeof useCloseLoanMutation>;
export type CloseLoanMutationResult = Apollo.MutationResult<CloseLoanMutation>;
export type CloseLoanMutationOptions = Apollo.BaseMutationOptions<CloseLoanMutation, CloseLoanMutationVariables>;
export const ConfirmDrawdownFundingDocument = /*#__PURE__*/ gql`
  mutation confirmDrawdownFunding($achRequestId: ID!) {
    confirmDrawdownFunding(achRequestId: $achRequestId) {
      id
      status
      amountCents
      userId
    }
  }
`;
export type ConfirmDrawdownFundingMutationFn = Apollo.MutationFunction<
  ConfirmDrawdownFundingMutation,
  ConfirmDrawdownFundingMutationVariables
>;

/**
 * __useConfirmDrawdownFundingMutation__
 *
 * To run a mutation, you first call `useConfirmDrawdownFundingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmDrawdownFundingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmDrawdownFundingMutation, { data, loading, error }] = useConfirmDrawdownFundingMutation({
 *   variables: {
 *      achRequestId: // value for 'achRequestId'
 *   },
 * });
 */
export function useConfirmDrawdownFundingMutation(
  baseOptions?: Apollo.MutationHookOptions<ConfirmDrawdownFundingMutation, ConfirmDrawdownFundingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmDrawdownFundingMutation, ConfirmDrawdownFundingMutationVariables>(
    ConfirmDrawdownFundingDocument,
    options,
  );
}
export type ConfirmDrawdownFundingMutationHookResult = ReturnType<typeof useConfirmDrawdownFundingMutation>;
export type ConfirmDrawdownFundingMutationResult = Apollo.MutationResult<ConfirmDrawdownFundingMutation>;
export type ConfirmDrawdownFundingMutationOptions = Apollo.BaseMutationOptions<
  ConfirmDrawdownFundingMutation,
  ConfirmDrawdownFundingMutationVariables
>;
export const CreateAdminUserMutationDocument = /*#__PURE__*/ gql`
  mutation CreateAdminUserMutation($input: CreateAdminUserInput!) {
    createAdminUser(input: $input) {
      ...BasicUserFragment
    }
  }
  ${BasicUserFragmentFragmentDoc}
`;
export type CreateAdminUserMutationMutationFn = Apollo.MutationFunction<
  CreateAdminUserMutationMutation,
  CreateAdminUserMutationMutationVariables
>;

/**
 * __useCreateAdminUserMutationMutation__
 *
 * To run a mutation, you first call `useCreateAdminUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminUserMutationMutation, { data, loading, error }] = useCreateAdminUserMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminUserMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateAdminUserMutationMutation, CreateAdminUserMutationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAdminUserMutationMutation, CreateAdminUserMutationMutationVariables>(
    CreateAdminUserMutationDocument,
    options,
  );
}
export type CreateAdminUserMutationMutationHookResult = ReturnType<typeof useCreateAdminUserMutationMutation>;
export type CreateAdminUserMutationMutationResult = Apollo.MutationResult<CreateAdminUserMutationMutation>;
export type CreateAdminUserMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateAdminUserMutationMutation,
  CreateAdminUserMutationMutationVariables
>;
export const CreatePartnerDocument = /*#__PURE__*/ gql`
  mutation createPartner($input: CreatePartnerInput!) {
    createPartner(input: $input) {
      partner {
        id
        name
        active
      }
      clientId
      clientSecret
    }
  }
`;
export type CreatePartnerMutationFn = Apollo.MutationFunction<CreatePartnerMutation, CreatePartnerMutationVariables>;

/**
 * __useCreatePartnerMutation__
 *
 * To run a mutation, you first call `useCreatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerMutation, { data, loading, error }] = useCreatePartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePartnerMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePartnerMutation, CreatePartnerMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePartnerMutation, CreatePartnerMutationVariables>(CreatePartnerDocument, options);
}
export type CreatePartnerMutationHookResult = ReturnType<typeof useCreatePartnerMutation>;
export type CreatePartnerMutationResult = Apollo.MutationResult<CreatePartnerMutation>;
export type CreatePartnerMutationOptions = Apollo.BaseMutationOptions<
  CreatePartnerMutation,
  CreatePartnerMutationVariables
>;
export const CreatePrimeRateDocument = /*#__PURE__*/ gql`
  mutation createPrimeRate($input: CreatePrimeRateInput!) {
    createPrimeRate(input: $input) {
      ...BasePrimeRateFragment
    }
  }
  ${BasePrimeRateFragmentFragmentDoc}
`;
export type CreatePrimeRateMutationFn = Apollo.MutationFunction<
  CreatePrimeRateMutation,
  CreatePrimeRateMutationVariables
>;

/**
 * __useCreatePrimeRateMutation__
 *
 * To run a mutation, you first call `useCreatePrimeRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrimeRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrimeRateMutation, { data, loading, error }] = useCreatePrimeRateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePrimeRateMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePrimeRateMutation, CreatePrimeRateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePrimeRateMutation, CreatePrimeRateMutationVariables>(
    CreatePrimeRateDocument,
    options,
  );
}
export type CreatePrimeRateMutationHookResult = ReturnType<typeof useCreatePrimeRateMutation>;
export type CreatePrimeRateMutationResult = Apollo.MutationResult<CreatePrimeRateMutation>;
export type CreatePrimeRateMutationOptions = Apollo.BaseMutationOptions<
  CreatePrimeRateMutation,
  CreatePrimeRateMutationVariables
>;
export const CreateProgramDocument = /*#__PURE__*/ gql`
  mutation createProgram($input: CreateProgramInput!) {
    createProgram(input: $input) {
      ...BaseProgramFragment
    }
  }
  ${BaseProgramFragmentFragmentDoc}
`;
export type CreateProgramMutationFn = Apollo.MutationFunction<CreateProgramMutation, CreateProgramMutationVariables>;

/**
 * __useCreateProgramMutation__
 *
 * To run a mutation, you first call `useCreateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramMutation, { data, loading, error }] = useCreateProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgramMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateProgramMutation, CreateProgramMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateProgramMutation, CreateProgramMutationVariables>(CreateProgramDocument, options);
}
export type CreateProgramMutationHookResult = ReturnType<typeof useCreateProgramMutation>;
export type CreateProgramMutationResult = Apollo.MutationResult<CreateProgramMutation>;
export type CreateProgramMutationOptions = Apollo.BaseMutationOptions<
  CreateProgramMutation,
  CreateProgramMutationVariables
>;
export const CreateUserMutationDocument = /*#__PURE__*/ gql`
  mutation CreateUserMutation($user: UserInput!) {
    createUser(user: $user) {
      ...BasicUserFragment
    }
  }
  ${BasicUserFragmentFragmentDoc}
`;
export type CreateUserMutationMutationFn = Apollo.MutationFunction<
  CreateUserMutationMutation,
  CreateUserMutationMutationVariables
>;

/**
 * __useCreateUserMutationMutation__
 *
 * To run a mutation, you first call `useCreateUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutationMutation, { data, loading, error }] = useCreateUserMutationMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateUserMutationMutation, CreateUserMutationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserMutationMutation, CreateUserMutationMutationVariables>(
    CreateUserMutationDocument,
    options,
  );
}
export type CreateUserMutationMutationHookResult = ReturnType<typeof useCreateUserMutationMutation>;
export type CreateUserMutationMutationResult = Apollo.MutationResult<CreateUserMutationMutation>;
export type CreateUserMutationMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutationMutation,
  CreateUserMutationMutationVariables
>;
export const DeletePrimeRateDocument = /*#__PURE__*/ gql`
  mutation deletePrimeRate($id: ID!) {
    deletePrimeRate(id: $id) {
      ...BasePrimeRateFragment
    }
  }
  ${BasePrimeRateFragmentFragmentDoc}
`;
export type DeletePrimeRateMutationFn = Apollo.MutationFunction<
  DeletePrimeRateMutation,
  DeletePrimeRateMutationVariables
>;

/**
 * __useDeletePrimeRateMutation__
 *
 * To run a mutation, you first call `useDeletePrimeRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePrimeRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePrimeRateMutation, { data, loading, error }] = useDeletePrimeRateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePrimeRateMutation(
  baseOptions?: Apollo.MutationHookOptions<DeletePrimeRateMutation, DeletePrimeRateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeletePrimeRateMutation, DeletePrimeRateMutationVariables>(
    DeletePrimeRateDocument,
    options,
  );
}
export type DeletePrimeRateMutationHookResult = ReturnType<typeof useDeletePrimeRateMutation>;
export type DeletePrimeRateMutationResult = Apollo.MutationResult<DeletePrimeRateMutation>;
export type DeletePrimeRateMutationOptions = Apollo.BaseMutationOptions<
  DeletePrimeRateMutation,
  DeletePrimeRateMutationVariables
>;
export const OpenAccountMutationDocument = /*#__PURE__*/ gql`
  mutation OpenAccountMutation($input: AccountOpeningInput!) {
    openAccount(input: $input) {
      accountId
      status
      replayed
      loanId
      pendingCards
    }
  }
`;
export type OpenAccountMutationMutationFn = Apollo.MutationFunction<
  OpenAccountMutationMutation,
  OpenAccountMutationMutationVariables
>;

/**
 * __useOpenAccountMutationMutation__
 *
 * To run a mutation, you first call `useOpenAccountMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenAccountMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openAccountMutationMutation, { data, loading, error }] = useOpenAccountMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenAccountMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<OpenAccountMutationMutation, OpenAccountMutationMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<OpenAccountMutationMutation, OpenAccountMutationMutationVariables>(
    OpenAccountMutationDocument,
    options,
  );
}
export type OpenAccountMutationMutationHookResult = ReturnType<typeof useOpenAccountMutationMutation>;
export type OpenAccountMutationMutationResult = Apollo.MutationResult<OpenAccountMutationMutation>;
export type OpenAccountMutationMutationOptions = Apollo.BaseMutationOptions<
  OpenAccountMutationMutation,
  OpenAccountMutationMutationVariables
>;
export const PreviewStatementCycleDocument = /*#__PURE__*/ gql`
  mutation previewStatementCycle($loanId: ID!, $closeStatementCycleOptions: CloseStatementCycleOptions!) {
    closeStatementCycle(loanId: $loanId, closeStatementCycleOptions: $closeStatementCycleOptions) {
      billingPeriodStart
      billingPeriodEnd
      dueDate
    }
  }
`;
export type PreviewStatementCycleMutationFn = Apollo.MutationFunction<
  PreviewStatementCycleMutation,
  PreviewStatementCycleMutationVariables
>;

/**
 * __usePreviewStatementCycleMutation__
 *
 * To run a mutation, you first call `usePreviewStatementCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewStatementCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewStatementCycleMutation, { data, loading, error }] = usePreviewStatementCycleMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      closeStatementCycleOptions: // value for 'closeStatementCycleOptions'
 *   },
 * });
 */
export function usePreviewStatementCycleMutation(
  baseOptions?: Apollo.MutationHookOptions<PreviewStatementCycleMutation, PreviewStatementCycleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PreviewStatementCycleMutation, PreviewStatementCycleMutationVariables>(
    PreviewStatementCycleDocument,
    options,
  );
}
export type PreviewStatementCycleMutationHookResult = ReturnType<typeof usePreviewStatementCycleMutation>;
export type PreviewStatementCycleMutationResult = Apollo.MutationResult<PreviewStatementCycleMutation>;
export type PreviewStatementCycleMutationOptions = Apollo.BaseMutationOptions<
  PreviewStatementCycleMutation,
  PreviewStatementCycleMutationVariables
>;
export const RemoveProgramDocument = /*#__PURE__*/ gql`
  mutation removeProgram($programId: ID!) {
    removeProgram(programId: $programId) {
      ...BaseProgramFragment
    }
  }
  ${BaseProgramFragmentFragmentDoc}
`;
export type RemoveProgramMutationFn = Apollo.MutationFunction<RemoveProgramMutation, RemoveProgramMutationVariables>;

/**
 * __useRemoveProgramMutation__
 *
 * To run a mutation, you first call `useRemoveProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProgramMutation, { data, loading, error }] = useRemoveProgramMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useRemoveProgramMutation(
  baseOptions?: Apollo.MutationHookOptions<RemoveProgramMutation, RemoveProgramMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveProgramMutation, RemoveProgramMutationVariables>(RemoveProgramDocument, options);
}
export type RemoveProgramMutationHookResult = ReturnType<typeof useRemoveProgramMutation>;
export type RemoveProgramMutationResult = Apollo.MutationResult<RemoveProgramMutation>;
export type RemoveProgramMutationOptions = Apollo.BaseMutationOptions<
  RemoveProgramMutation,
  RemoveProgramMutationVariables
>;
export const SetCardStatusDocument = /*#__PURE__*/ gql`
  mutation setCardStatus($referenceId: ID!, $statusCode: String!, $description: String!) {
    setCardStatus(referenceId: $referenceId, statusCode: $statusCode, description: $description) {
      ...BasicUserFragment
    }
  }
  ${BasicUserFragmentFragmentDoc}
`;
export type SetCardStatusMutationFn = Apollo.MutationFunction<SetCardStatusMutation, SetCardStatusMutationVariables>;

/**
 * __useSetCardStatusMutation__
 *
 * To run a mutation, you first call `useSetCardStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCardStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCardStatusMutation, { data, loading, error }] = useSetCardStatusMutation({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *      statusCode: // value for 'statusCode'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useSetCardStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<SetCardStatusMutation, SetCardStatusMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCardStatusMutation, SetCardStatusMutationVariables>(SetCardStatusDocument, options);
}
export type SetCardStatusMutationHookResult = ReturnType<typeof useSetCardStatusMutation>;
export type SetCardStatusMutationResult = Apollo.MutationResult<SetCardStatusMutation>;
export type SetCardStatusMutationOptions = Apollo.BaseMutationOptions<
  SetCardStatusMutation,
  SetCardStatusMutationVariables
>;
export const SetProgramMerchantPolicyDocument = /*#__PURE__*/ gql`
  mutation setProgramMerchantPolicy($programId: ID!, $cashAdvancesAllowed: Boolean!) {
    setProgramMerchantPolicy(programId: $programId, cashAdvancesAllowed: $cashAdvancesAllowed) {
      ...BaseProgramFragment
    }
  }
  ${BaseProgramFragmentFragmentDoc}
`;
export type SetProgramMerchantPolicyMutationFn = Apollo.MutationFunction<
  SetProgramMerchantPolicyMutation,
  SetProgramMerchantPolicyMutationVariables
>;

/**
 * __useSetProgramMerchantPolicyMutation__
 *
 * To run a mutation, you first call `useSetProgramMerchantPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProgramMerchantPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProgramMerchantPolicyMutation, { data, loading, error }] = useSetProgramMerchantPolicyMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      cashAdvancesAllowed: // value for 'cashAdvancesAllowed'
 *   },
 * });
 */
export function useSetProgramMerchantPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<SetProgramMerchantPolicyMutation, SetProgramMerchantPolicyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetProgramMerchantPolicyMutation, SetProgramMerchantPolicyMutationVariables>(
    SetProgramMerchantPolicyDocument,
    options,
  );
}
export type SetProgramMerchantPolicyMutationHookResult = ReturnType<typeof useSetProgramMerchantPolicyMutation>;
export type SetProgramMerchantPolicyMutationResult = Apollo.MutationResult<SetProgramMerchantPolicyMutation>;
export type SetProgramMerchantPolicyMutationOptions = Apollo.BaseMutationOptions<
  SetProgramMerchantPolicyMutation,
  SetProgramMerchantPolicyMutationVariables
>;
export const UpdateAdminScopeDocument = /*#__PURE__*/ gql`
  mutation updateAdminScope($input: UpdateAdminScopeInput!) {
    updateAdminScope(input: $input) {
      id
      adminProgramId
      adminProgram {
        id
        name
      }
      partner {
        id
        name
      }
    }
  }
`;
export type UpdateAdminScopeMutationFn = Apollo.MutationFunction<
  UpdateAdminScopeMutation,
  UpdateAdminScopeMutationVariables
>;

/**
 * __useUpdateAdminScopeMutation__
 *
 * To run a mutation, you first call `useUpdateAdminScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminScopeMutation, { data, loading, error }] = useUpdateAdminScopeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminScopeMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAdminScopeMutation, UpdateAdminScopeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAdminScopeMutation, UpdateAdminScopeMutationVariables>(
    UpdateAdminScopeDocument,
    options,
  );
}
export type UpdateAdminScopeMutationHookResult = ReturnType<typeof useUpdateAdminScopeMutation>;
export type UpdateAdminScopeMutationResult = Apollo.MutationResult<UpdateAdminScopeMutation>;
export type UpdateAdminScopeMutationOptions = Apollo.BaseMutationOptions<
  UpdateAdminScopeMutation,
  UpdateAdminScopeMutationVariables
>;
export const UpdatePrimeRateDocument = /*#__PURE__*/ gql`
  mutation updatePrimeRate($id: ID!, $input: UpdatePrimeRateInput!) {
    updatePrimeRate(id: $id, input: $input) {
      ...BasePrimeRateFragment
    }
  }
  ${BasePrimeRateFragmentFragmentDoc}
`;
export type UpdatePrimeRateMutationFn = Apollo.MutationFunction<
  UpdatePrimeRateMutation,
  UpdatePrimeRateMutationVariables
>;

/**
 * __useUpdatePrimeRateMutation__
 *
 * To run a mutation, you first call `useUpdatePrimeRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrimeRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrimeRateMutation, { data, loading, error }] = useUpdatePrimeRateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePrimeRateMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePrimeRateMutation, UpdatePrimeRateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePrimeRateMutation, UpdatePrimeRateMutationVariables>(
    UpdatePrimeRateDocument,
    options,
  );
}
export type UpdatePrimeRateMutationHookResult = ReturnType<typeof useUpdatePrimeRateMutation>;
export type UpdatePrimeRateMutationResult = Apollo.MutationResult<UpdatePrimeRateMutation>;
export type UpdatePrimeRateMutationOptions = Apollo.BaseMutationOptions<
  UpdatePrimeRateMutation,
  UpdatePrimeRateMutationVariables
>;
export const UpdateProgramDocument = /*#__PURE__*/ gql`
  mutation updateProgram(
    $programId: ID!
    $name: String
    $targetInterestRate: Decimal
    $minApr: Decimal
    $maxApr: Decimal
    $firstLateFeeAmount: Int
    $subsequentLateFeeAmount: Int
    $returnedPaymentFeeCents: Int
    $foreignTransactionFeeRate: Decimal
    $replacementCardFeeCents: Int
    $paymentDueDateGracePeriodDays: Int
    $lateFeeGracePeriodDays: Int
    $paymentDueDay: Int
    $statementGenerateDay: Int
    $active: Boolean
    $minimumPaymentStrategy: MinimumPaymentStrategy
    $minimumPaymentRate: Decimal
    $minimumPaymentFloorCents: Int
    $chargeDrawdownFee: Boolean
    $pdfTemplate: PdfTemplate
    $twispJournalId: ID
    $twispIsoConfigId: ID
    $twispExposureAccountSetId: ID
  ) {
    updateProgram(
      programId: $programId
      input: {
        name: $name
        targetInterestRate: $targetInterestRate
        minApr: $minApr
        maxApr: $maxApr
        firstLateFeeAmount: $firstLateFeeAmount
        subsequentLateFeeAmount: $subsequentLateFeeAmount
        returnedPaymentFeeCents: $returnedPaymentFeeCents
        foreignTransactionFeeRate: $foreignTransactionFeeRate
        replacementCardFeeCents: $replacementCardFeeCents
        paymentDueDateGracePeriodDays: $paymentDueDateGracePeriodDays
        lateFeeGracePeriodDays: $lateFeeGracePeriodDays
        paymentDueDay: $paymentDueDay
        statementGenerateDay: $statementGenerateDay
        active: $active
        minimumPaymentStrategy: $minimumPaymentStrategy
        minimumPaymentRate: $minimumPaymentRate
        minimumPaymentFloorCents: $minimumPaymentFloorCents
        chargeDrawdownFee: $chargeDrawdownFee
        pdfTemplate: $pdfTemplate
        twispJournalId: $twispJournalId
        twispIsoConfigId: $twispIsoConfigId
        twispExposureAccountSetId: $twispExposureAccountSetId
      }
    ) {
      ...BaseProgramFragment
    }
  }
  ${BaseProgramFragmentFragmentDoc}
`;
export type UpdateProgramMutationFn = Apollo.MutationFunction<UpdateProgramMutation, UpdateProgramMutationVariables>;

/**
 * __useUpdateProgramMutation__
 *
 * To run a mutation, you first call `useUpdateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramMutation, { data, loading, error }] = useUpdateProgramMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      name: // value for 'name'
 *      targetInterestRate: // value for 'targetInterestRate'
 *      minApr: // value for 'minApr'
 *      maxApr: // value for 'maxApr'
 *      firstLateFeeAmount: // value for 'firstLateFeeAmount'
 *      subsequentLateFeeAmount: // value for 'subsequentLateFeeAmount'
 *      returnedPaymentFeeCents: // value for 'returnedPaymentFeeCents'
 *      foreignTransactionFeeRate: // value for 'foreignTransactionFeeRate'
 *      replacementCardFeeCents: // value for 'replacementCardFeeCents'
 *      paymentDueDateGracePeriodDays: // value for 'paymentDueDateGracePeriodDays'
 *      lateFeeGracePeriodDays: // value for 'lateFeeGracePeriodDays'
 *      paymentDueDay: // value for 'paymentDueDay'
 *      statementGenerateDay: // value for 'statementGenerateDay'
 *      active: // value for 'active'
 *      minimumPaymentStrategy: // value for 'minimumPaymentStrategy'
 *      minimumPaymentRate: // value for 'minimumPaymentRate'
 *      minimumPaymentFloorCents: // value for 'minimumPaymentFloorCents'
 *      chargeDrawdownFee: // value for 'chargeDrawdownFee'
 *      pdfTemplate: // value for 'pdfTemplate'
 *      twispJournalId: // value for 'twispJournalId'
 *      twispIsoConfigId: // value for 'twispIsoConfigId'
 *      twispExposureAccountSetId: // value for 'twispExposureAccountSetId'
 *   },
 * });
 */
export function useUpdateProgramMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateProgramMutation, UpdateProgramMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateProgramMutation, UpdateProgramMutationVariables>(UpdateProgramDocument, options);
}
export type UpdateProgramMutationHookResult = ReturnType<typeof useUpdateProgramMutation>;
export type UpdateProgramMutationResult = Apollo.MutationResult<UpdateProgramMutation>;
export type UpdateProgramMutationOptions = Apollo.BaseMutationOptions<
  UpdateProgramMutation,
  UpdateProgramMutationVariables
>;
export const UpdateUserDocument = /*#__PURE__*/ gql`
  mutation updateUser(
    $userId: ID!
    $firstName: String
    $middleName: String
    $lastName: String
    $phone: String
    $isFriendsAndFam: Boolean
    $dob: String
  ) {
    updateUser(
      userId: $userId
      firstName: $firstName
      middleName: $middleName
      lastName: $lastName
      phone: $phone
      isFriendsAndFam: $isFriendsAndFam
      dob: $dob
    ) {
      ...BasicUserFragment
    }
  }
  ${BasicUserFragmentFragmentDoc}
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      middleName: // value for 'middleName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      isFriendsAndFam: // value for 'isFriendsAndFam'
 *      dob: // value for 'dob'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const AchReturnDocument = /*#__PURE__*/ gql`
  mutation AchReturn(
    $achRequestId: ID!
    $returnCode: String
    $returnType: AchReturnType!
    $returnedOn: Date
    $notes: String
    $dryRun: Boolean
  ) {
    achReturn(
      achRequestId: $achRequestId
      returnCode: $returnCode
      returnType: $returnType
      returnedOn: $returnedOn
      notes: $notes
      dryRun: $dryRun
    ) {
      ...BaseAchReturnResult
    }
  }
  ${BaseAchReturnResultFragmentDoc}
`;
export type AchReturnMutationFn = Apollo.MutationFunction<AchReturnMutation, AchReturnMutationVariables>;

/**
 * __useAchReturnMutation__
 *
 * To run a mutation, you first call `useAchReturnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAchReturnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [achReturnMutation, { data, loading, error }] = useAchReturnMutation({
 *   variables: {
 *      achRequestId: // value for 'achRequestId'
 *      returnCode: // value for 'returnCode'
 *      returnType: // value for 'returnType'
 *      returnedOn: // value for 'returnedOn'
 *      notes: // value for 'notes'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useAchReturnMutation(
  baseOptions?: Apollo.MutationHookOptions<AchReturnMutation, AchReturnMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AchReturnMutation, AchReturnMutationVariables>(AchReturnDocument, options);
}
export type AchReturnMutationHookResult = ReturnType<typeof useAchReturnMutation>;
export type AchReturnMutationResult = Apollo.MutationResult<AchReturnMutation>;
export type AchReturnMutationOptions = Apollo.BaseMutationOptions<AchReturnMutation, AchReturnMutationVariables>;
export const ActivateCardDocument = /*#__PURE__*/ gql`
  mutation ActivateCard($referenceId: String!) {
    activateCard(referenceId: $referenceId) {
      ...CardFragment
    }
  }
  ${CardFragmentFragmentDoc}
`;
export type ActivateCardMutationFn = Apollo.MutationFunction<ActivateCardMutation, ActivateCardMutationVariables>;

/**
 * __useActivateCardMutation__
 *
 * To run a mutation, you first call `useActivateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateCardMutation, { data, loading, error }] = useActivateCardMutation({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useActivateCardMutation(
  baseOptions?: Apollo.MutationHookOptions<ActivateCardMutation, ActivateCardMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ActivateCardMutation, ActivateCardMutationVariables>(ActivateCardDocument, options);
}
export type ActivateCardMutationHookResult = ReturnType<typeof useActivateCardMutation>;
export type ActivateCardMutationResult = Apollo.MutationResult<ActivateCardMutation>;
export type ActivateCardMutationOptions = Apollo.BaseMutationOptions<
  ActivateCardMutation,
  ActivateCardMutationVariables
>;
export const AddAddressDocument = /*#__PURE__*/ gql`
  mutation addAddress($userId: ID!, $addressInput: AddressInput) {
    addAddress(userId: $userId, addressInput: $addressInput) {
      ...BasicUserFragment
    }
  }
  ${BasicUserFragmentFragmentDoc}
`;
export type AddAddressMutationFn = Apollo.MutationFunction<AddAddressMutation, AddAddressMutationVariables>;

/**
 * __useAddAddressMutation__
 *
 * To run a mutation, you first call `useAddAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAddressMutation, { data, loading, error }] = useAddAddressMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      addressInput: // value for 'addressInput'
 *   },
 * });
 */
export function useAddAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<AddAddressMutation, AddAddressMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddAddressMutation, AddAddressMutationVariables>(AddAddressDocument, options);
}
export type AddAddressMutationHookResult = ReturnType<typeof useAddAddressMutation>;
export type AddAddressMutationResult = Apollo.MutationResult<AddAddressMutation>;
export type AddAddressMutationOptions = Apollo.BaseMutationOptions<AddAddressMutation, AddAddressMutationVariables>;
export const AddFeeTransactionDocument = /*#__PURE__*/ gql`
  mutation AddFeeTransaction(
    $loanId: ID!
    $amountCents: Int!
    $feeType: String!
    $effectiveDate: String!
    $description: String!
  ) {
    addFeeTransaction(
      loanId: $loanId
      amountCents: $amountCents
      feeType: $feeType
      effectiveDate: $effectiveDate
      description: $description
    ) {
      ...BasicFeeTransactionFragment
    }
  }
  ${BasicFeeTransactionFragmentFragmentDoc}
`;
export type AddFeeTransactionMutationFn = Apollo.MutationFunction<
  AddFeeTransactionMutation,
  AddFeeTransactionMutationVariables
>;

/**
 * __useAddFeeTransactionMutation__
 *
 * To run a mutation, you first call `useAddFeeTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeeTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeeTransactionMutation, { data, loading, error }] = useAddFeeTransactionMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      amountCents: // value for 'amountCents'
 *      feeType: // value for 'feeType'
 *      effectiveDate: // value for 'effectiveDate'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAddFeeTransactionMutation(
  baseOptions?: Apollo.MutationHookOptions<AddFeeTransactionMutation, AddFeeTransactionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddFeeTransactionMutation, AddFeeTransactionMutationVariables>(
    AddFeeTransactionDocument,
    options,
  );
}
export type AddFeeTransactionMutationHookResult = ReturnType<typeof useAddFeeTransactionMutation>;
export type AddFeeTransactionMutationResult = Apollo.MutationResult<AddFeeTransactionMutation>;
export type AddFeeTransactionMutationOptions = Apollo.BaseMutationOptions<
  AddFeeTransactionMutation,
  AddFeeTransactionMutationVariables
>;
export const ApplyDelinquencyDocument = /*#__PURE__*/ gql`
  mutation ApplyDelinquency($loanId: ID!, $reason: String!) {
    applyLoanDelinquency(loanId: $loanId, reason: $reason) {
      message
      loan {
        ...BasicLoanFragment
      }
      affectedCards {
        id
      }
    }
  }
  ${BasicLoanFragmentFragmentDoc}
`;
export type ApplyDelinquencyMutationFn = Apollo.MutationFunction<
  ApplyDelinquencyMutation,
  ApplyDelinquencyMutationVariables
>;

/**
 * __useApplyDelinquencyMutation__
 *
 * To run a mutation, you first call `useApplyDelinquencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyDelinquencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyDelinquencyMutation, { data, loading, error }] = useApplyDelinquencyMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useApplyDelinquencyMutation(
  baseOptions?: Apollo.MutationHookOptions<ApplyDelinquencyMutation, ApplyDelinquencyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ApplyDelinquencyMutation, ApplyDelinquencyMutationVariables>(
    ApplyDelinquencyDocument,
    options,
  );
}
export type ApplyDelinquencyMutationHookResult = ReturnType<typeof useApplyDelinquencyMutation>;
export type ApplyDelinquencyMutationResult = Apollo.MutationResult<ApplyDelinquencyMutation>;
export type ApplyDelinquencyMutationOptions = Apollo.BaseMutationOptions<
  ApplyDelinquencyMutation,
  ApplyDelinquencyMutationVariables
>;
export const BlockUnblockCardDocument = /*#__PURE__*/ gql`
  mutation BlockUnblockCard($cardId: ID!, $action: BlockUnblockCardAction!, $blockReason: String) {
    blockUnblockCard(cardId: $cardId, action: $action, blockReason: $blockReason) {
      ...CardFragment
    }
  }
  ${CardFragmentFragmentDoc}
`;
export type BlockUnblockCardMutationFn = Apollo.MutationFunction<
  BlockUnblockCardMutation,
  BlockUnblockCardMutationVariables
>;

/**
 * __useBlockUnblockCardMutation__
 *
 * To run a mutation, you first call `useBlockUnblockCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUnblockCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUnblockCardMutation, { data, loading, error }] = useBlockUnblockCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      action: // value for 'action'
 *      blockReason: // value for 'blockReason'
 *   },
 * });
 */
export function useBlockUnblockCardMutation(
  baseOptions?: Apollo.MutationHookOptions<BlockUnblockCardMutation, BlockUnblockCardMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BlockUnblockCardMutation, BlockUnblockCardMutationVariables>(
    BlockUnblockCardDocument,
    options,
  );
}
export type BlockUnblockCardMutationHookResult = ReturnType<typeof useBlockUnblockCardMutation>;
export type BlockUnblockCardMutationResult = Apollo.MutationResult<BlockUnblockCardMutation>;
export type BlockUnblockCardMutationOptions = Apollo.BaseMutationOptions<
  BlockUnblockCardMutation,
  BlockUnblockCardMutationVariables
>;
export const CloseCardDocument = /*#__PURE__*/ gql`
  mutation CloseCard($cardId: ID!) {
    closeCard(cardId: $cardId) {
      ...CardFragment
    }
  }
  ${CardFragmentFragmentDoc}
`;
export type CloseCardMutationFn = Apollo.MutationFunction<CloseCardMutation, CloseCardMutationVariables>;

/**
 * __useCloseCardMutation__
 *
 * To run a mutation, you first call `useCloseCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeCardMutation, { data, loading, error }] = useCloseCardMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useCloseCardMutation(
  baseOptions?: Apollo.MutationHookOptions<CloseCardMutation, CloseCardMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloseCardMutation, CloseCardMutationVariables>(CloseCardDocument, options);
}
export type CloseCardMutationHookResult = ReturnType<typeof useCloseCardMutation>;
export type CloseCardMutationResult = Apollo.MutationResult<CloseCardMutation>;
export type CloseCardMutationOptions = Apollo.BaseMutationOptions<CloseCardMutation, CloseCardMutationVariables>;
export const CloseStatementCycleDocument = /*#__PURE__*/ gql`
  mutation closeStatementCycle($loanId: ID!, $closeStatementCycleOptions: CloseStatementCycleOptions) {
    closeStatementCycle(loanId: $loanId, closeStatementCycleOptions: $closeStatementCycleOptions) {
      ...StatementFragment
    }
  }
  ${StatementFragmentFragmentDoc}
`;
export type CloseStatementCycleMutationFn = Apollo.MutationFunction<
  CloseStatementCycleMutation,
  CloseStatementCycleMutationVariables
>;

/**
 * __useCloseStatementCycleMutation__
 *
 * To run a mutation, you first call `useCloseStatementCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseStatementCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeStatementCycleMutation, { data, loading, error }] = useCloseStatementCycleMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      closeStatementCycleOptions: // value for 'closeStatementCycleOptions'
 *   },
 * });
 */
export function useCloseStatementCycleMutation(
  baseOptions?: Apollo.MutationHookOptions<CloseStatementCycleMutation, CloseStatementCycleMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloseStatementCycleMutation, CloseStatementCycleMutationVariables>(
    CloseStatementCycleDocument,
    options,
  );
}
export type CloseStatementCycleMutationHookResult = ReturnType<typeof useCloseStatementCycleMutation>;
export type CloseStatementCycleMutationResult = Apollo.MutationResult<CloseStatementCycleMutation>;
export type CloseStatementCycleMutationOptions = Apollo.BaseMutationOptions<
  CloseStatementCycleMutation,
  CloseStatementCycleMutationVariables
>;
export const CureDelinquencyDocument = /*#__PURE__*/ gql`
  mutation CureDelinquency($loanId: ID!, $reason: String!) {
    cureLoanDelinquency(loanId: $loanId, reason: $reason) {
      message
      loan {
        ...BasicLoanFragment
      }
      affectedCards {
        id
      }
    }
  }
  ${BasicLoanFragmentFragmentDoc}
`;
export type CureDelinquencyMutationFn = Apollo.MutationFunction<
  CureDelinquencyMutation,
  CureDelinquencyMutationVariables
>;

/**
 * __useCureDelinquencyMutation__
 *
 * To run a mutation, you first call `useCureDelinquencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCureDelinquencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cureDelinquencyMutation, { data, loading, error }] = useCureDelinquencyMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCureDelinquencyMutation(
  baseOptions?: Apollo.MutationHookOptions<CureDelinquencyMutation, CureDelinquencyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CureDelinquencyMutation, CureDelinquencyMutationVariables>(
    CureDelinquencyDocument,
    options,
  );
}
export type CureDelinquencyMutationHookResult = ReturnType<typeof useCureDelinquencyMutation>;
export type CureDelinquencyMutationResult = Apollo.MutationResult<CureDelinquencyMutation>;
export type CureDelinquencyMutationOptions = Apollo.BaseMutationOptions<
  CureDelinquencyMutation,
  CureDelinquencyMutationVariables
>;
export const MarkPhysicalCardActivatedDocument = /*#__PURE__*/ gql`
  mutation MarkPhysicalCardActivated($referenceId: String!) {
    markPhysicalCardActivated(referenceId: $referenceId) {
      ...CardFragment
    }
  }
  ${CardFragmentFragmentDoc}
`;
export type MarkPhysicalCardActivatedMutationFn = Apollo.MutationFunction<
  MarkPhysicalCardActivatedMutation,
  MarkPhysicalCardActivatedMutationVariables
>;

/**
 * __useMarkPhysicalCardActivatedMutation__
 *
 * To run a mutation, you first call `useMarkPhysicalCardActivatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPhysicalCardActivatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPhysicalCardActivatedMutation, { data, loading, error }] = useMarkPhysicalCardActivatedMutation({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useMarkPhysicalCardActivatedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkPhysicalCardActivatedMutation,
    MarkPhysicalCardActivatedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkPhysicalCardActivatedMutation, MarkPhysicalCardActivatedMutationVariables>(
    MarkPhysicalCardActivatedDocument,
    options,
  );
}
export type MarkPhysicalCardActivatedMutationHookResult = ReturnType<typeof useMarkPhysicalCardActivatedMutation>;
export type MarkPhysicalCardActivatedMutationResult = Apollo.MutationResult<MarkPhysicalCardActivatedMutation>;
export type MarkPhysicalCardActivatedMutationOptions = Apollo.BaseMutationOptions<
  MarkPhysicalCardActivatedMutation,
  MarkPhysicalCardActivatedMutationVariables
>;
export const PostExternalRepaymentDocument = /*#__PURE__*/ gql`
  mutation PostExternalRepayment(
    $loanId: ID!
    $amountCents: Int!
    $paymentRef: String!
    $effectiveDate: Date!
    $statementDate: Date
    $title: String
  ) {
    postExternalRepayment(
      loanId: $loanId
      amountCents: $amountCents
      paymentRef: $paymentRef
      effectiveDate: $effectiveDate
      statementDate: $statementDate
      title: $title
    ) {
      status
      settlementTransactionId
      correlationId
      delinquencyCured
      remainingUnallocatedCents
    }
  }
`;
export type PostExternalRepaymentMutationFn = Apollo.MutationFunction<
  PostExternalRepaymentMutation,
  PostExternalRepaymentMutationVariables
>;

/**
 * __usePostExternalRepaymentMutation__
 *
 * To run a mutation, you first call `usePostExternalRepaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostExternalRepaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postExternalRepaymentMutation, { data, loading, error }] = usePostExternalRepaymentMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      amountCents: // value for 'amountCents'
 *      paymentRef: // value for 'paymentRef'
 *      effectiveDate: // value for 'effectiveDate'
 *      statementDate: // value for 'statementDate'
 *      title: // value for 'title'
 *   },
 * });
 */
export function usePostExternalRepaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<PostExternalRepaymentMutation, PostExternalRepaymentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PostExternalRepaymentMutation, PostExternalRepaymentMutationVariables>(
    PostExternalRepaymentDocument,
    options,
  );
}
export type PostExternalRepaymentMutationHookResult = ReturnType<typeof usePostExternalRepaymentMutation>;
export type PostExternalRepaymentMutationResult = Apollo.MutationResult<PostExternalRepaymentMutation>;
export type PostExternalRepaymentMutationOptions = Apollo.BaseMutationOptions<
  PostExternalRepaymentMutation,
  PostExternalRepaymentMutationVariables
>;
export const ProcessLateFeeDocument = /*#__PURE__*/ gql`
  mutation ProcessLateFee($loanId: ID!, $dryRun: Boolean) {
    processLateFee(loanId: $loanId, dryRun: $dryRun) {
      ...BaseLateFeeProcessingResult
    }
  }
  ${BaseLateFeeProcessingResultFragmentDoc}
`;
export type ProcessLateFeeMutationFn = Apollo.MutationFunction<ProcessLateFeeMutation, ProcessLateFeeMutationVariables>;

/**
 * __useProcessLateFeeMutation__
 *
 * To run a mutation, you first call `useProcessLateFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessLateFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processLateFeeMutation, { data, loading, error }] = useProcessLateFeeMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      dryRun: // value for 'dryRun'
 *   },
 * });
 */
export function useProcessLateFeeMutation(
  baseOptions?: Apollo.MutationHookOptions<ProcessLateFeeMutation, ProcessLateFeeMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ProcessLateFeeMutation, ProcessLateFeeMutationVariables>(ProcessLateFeeDocument, options);
}
export type ProcessLateFeeMutationHookResult = ReturnType<typeof useProcessLateFeeMutation>;
export type ProcessLateFeeMutationResult = Apollo.MutationResult<ProcessLateFeeMutation>;
export type ProcessLateFeeMutationOptions = Apollo.BaseMutationOptions<
  ProcessLateFeeMutation,
  ProcessLateFeeMutationVariables
>;
export const ProcessStatementDueDateDocument = /*#__PURE__*/ gql`
  mutation ProcessStatementDueDate($loanId: ID!, $dueDateOptions: DueDateOptions) {
    processStatementDueDate(loanId: $loanId, dueDateOptions: $dueDateOptions) {
      ...BaseDueDateProcessingResult
    }
  }
  ${BaseDueDateProcessingResultFragmentDoc}
`;
export type ProcessStatementDueDateMutationFn = Apollo.MutationFunction<
  ProcessStatementDueDateMutation,
  ProcessStatementDueDateMutationVariables
>;

/**
 * __useProcessStatementDueDateMutation__
 *
 * To run a mutation, you first call `useProcessStatementDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessStatementDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processStatementDueDateMutation, { data, loading, error }] = useProcessStatementDueDateMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      dueDateOptions: // value for 'dueDateOptions'
 *   },
 * });
 */
export function useProcessStatementDueDateMutation(
  baseOptions?: Apollo.MutationHookOptions<ProcessStatementDueDateMutation, ProcessStatementDueDateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ProcessStatementDueDateMutation, ProcessStatementDueDateMutationVariables>(
    ProcessStatementDueDateDocument,
    options,
  );
}
export type ProcessStatementDueDateMutationHookResult = ReturnType<typeof useProcessStatementDueDateMutation>;
export type ProcessStatementDueDateMutationResult = Apollo.MutationResult<ProcessStatementDueDateMutation>;
export type ProcessStatementDueDateMutationOptions = Apollo.BaseMutationOptions<
  ProcessStatementDueDateMutation,
  ProcessStatementDueDateMutationVariables
>;
export const RetryAchRequestDocument = /*#__PURE__*/ gql`
  mutation retryAchRequest($achRequestId: ID!, $expectedVersion: Int!, $reason: String!, $confirmation: String) {
    retryAchRequest(
      achRequestId: $achRequestId
      expectedVersion: $expectedVersion
      reason: $reason
      confirmation: $confirmation
    ) {
      ...AchRequestFragment
    }
  }
  ${AchRequestFragmentFragmentDoc}
`;
export type RetryAchRequestMutationFn = Apollo.MutationFunction<
  RetryAchRequestMutation,
  RetryAchRequestMutationVariables
>;

/**
 * __useRetryAchRequestMutation__
 *
 * To run a mutation, you first call `useRetryAchRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryAchRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryAchRequestMutation, { data, loading, error }] = useRetryAchRequestMutation({
 *   variables: {
 *      achRequestId: // value for 'achRequestId'
 *      expectedVersion: // value for 'expectedVersion'
 *      reason: // value for 'reason'
 *      confirmation: // value for 'confirmation'
 *   },
 * });
 */
export function useRetryAchRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<RetryAchRequestMutation, RetryAchRequestMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RetryAchRequestMutation, RetryAchRequestMutationVariables>(
    RetryAchRequestDocument,
    options,
  );
}
export type RetryAchRequestMutationHookResult = ReturnType<typeof useRetryAchRequestMutation>;
export type RetryAchRequestMutationResult = Apollo.MutationResult<RetryAchRequestMutation>;
export type RetryAchRequestMutationOptions = Apollo.BaseMutationOptions<
  RetryAchRequestMutation,
  RetryAchRequestMutationVariables
>;
export const CancelAchRequestDocument = /*#__PURE__*/ gql`
  mutation cancelAchRequest(
    $achRequestId: ID!
    $expectedVersion: Int!
    $reason: String!
    $providerCancellationConfirmation: String
    $evidence: String
  ) {
    cancelAchRequest(
      achRequestId: $achRequestId
      expectedVersion: $expectedVersion
      reason: $reason
      providerCancellationConfirmation: $providerCancellationConfirmation
      evidence: $evidence
    ) {
      ...AchRequestFragment
    }
  }
  ${AchRequestFragmentFragmentDoc}
`;
export type CancelAchRequestMutationFn = Apollo.MutationFunction<
  CancelAchRequestMutation,
  CancelAchRequestMutationVariables
>;

/**
 * __useCancelAchRequestMutation__
 *
 * To run a mutation, you first call `useCancelAchRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAchRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAchRequestMutation, { data, loading, error }] = useCancelAchRequestMutation({
 *   variables: {
 *      achRequestId: // value for 'achRequestId'
 *      expectedVersion: // value for 'expectedVersion'
 *      reason: // value for 'reason'
 *      providerCancellationConfirmation: // value for 'providerCancellationConfirmation'
 *      evidence: // value for 'evidence'
 *   },
 * });
 */
export function useCancelAchRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<CancelAchRequestMutation, CancelAchRequestMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelAchRequestMutation, CancelAchRequestMutationVariables>(
    CancelAchRequestDocument,
    options,
  );
}
export type CancelAchRequestMutationHookResult = ReturnType<typeof useCancelAchRequestMutation>;
export type CancelAchRequestMutationResult = Apollo.MutationResult<CancelAchRequestMutation>;
export type CancelAchRequestMutationOptions = Apollo.BaseMutationOptions<
  CancelAchRequestMutation,
  CancelAchRequestMutationVariables
>;
export const ReplaceCardDocument = /*#__PURE__*/ gql`
  mutation replaceCard(
    $userId: ID!
    $referenceId: String!
    $replaceCardType: ReplaceCardType!
    $addressInput: AddressInput
  ) {
    replaceCard(
      userId: $userId
      referenceId: $referenceId
      replaceCardType: $replaceCardType
      addressInput: $addressInput
    ) {
      ...CardFragment
    }
  }
  ${CardFragmentFragmentDoc}
`;
export type ReplaceCardMutationFn = Apollo.MutationFunction<ReplaceCardMutation, ReplaceCardMutationVariables>;

/**
 * __useReplaceCardMutation__
 *
 * To run a mutation, you first call `useReplaceCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceCardMutation, { data, loading, error }] = useReplaceCardMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      referenceId: // value for 'referenceId'
 *      replaceCardType: // value for 'replaceCardType'
 *      addressInput: // value for 'addressInput'
 *   },
 * });
 */
export function useReplaceCardMutation(
  baseOptions?: Apollo.MutationHookOptions<ReplaceCardMutation, ReplaceCardMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReplaceCardMutation, ReplaceCardMutationVariables>(ReplaceCardDocument, options);
}
export type ReplaceCardMutationHookResult = ReturnType<typeof useReplaceCardMutation>;
export type ReplaceCardMutationResult = Apollo.MutationResult<ReplaceCardMutation>;
export type ReplaceCardMutationOptions = Apollo.BaseMutationOptions<ReplaceCardMutation, ReplaceCardMutationVariables>;
export const UpdateAprMarginDocument = /*#__PURE__*/ gql`
  mutation UpdateAprMargin($loanId: ID!, $aprMargin: Decimal!, $reason: String!) {
    updateLoanAprMargin(loanId: $loanId, aprMargin: $aprMargin, reason: $reason) {
      ...BasicLoanFragment
    }
  }
  ${BasicLoanFragmentFragmentDoc}
`;
export type UpdateAprMarginMutationFn = Apollo.MutationFunction<
  UpdateAprMarginMutation,
  UpdateAprMarginMutationVariables
>;

/**
 * __useUpdateAprMarginMutation__
 *
 * To run a mutation, you first call `useUpdateAprMarginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAprMarginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAprMarginMutation, { data, loading, error }] = useUpdateAprMarginMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      aprMargin: // value for 'aprMargin'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdateAprMarginMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAprMarginMutation, UpdateAprMarginMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAprMarginMutation, UpdateAprMarginMutationVariables>(
    UpdateAprMarginDocument,
    options,
  );
}
export type UpdateAprMarginMutationHookResult = ReturnType<typeof useUpdateAprMarginMutation>;
export type UpdateAprMarginMutationResult = Apollo.MutationResult<UpdateAprMarginMutation>;
export type UpdateAprMarginMutationOptions = Apollo.BaseMutationOptions<
  UpdateAprMarginMutation,
  UpdateAprMarginMutationVariables
>;
export const UpdateAutoPaySettingsForUserDocument = /*#__PURE__*/ gql`
  mutation updateAutoPaySettingsForUser($loanId: ID!, $input: AutoPaySettingsInput!) {
    updateAutoPaySettingsForLoan(loanId: $loanId, input: $input) {
      id
      paymentType
      daysBeforePayment
      enabled
      plaidAccountId
      insertedAt
      updatedAt
    }
  }
`;
export type UpdateAutoPaySettingsForUserMutationFn = Apollo.MutationFunction<
  UpdateAutoPaySettingsForUserMutation,
  UpdateAutoPaySettingsForUserMutationVariables
>;

/**
 * __useUpdateAutoPaySettingsForUserMutation__
 *
 * To run a mutation, you first call `useUpdateAutoPaySettingsForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoPaySettingsForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutoPaySettingsForUserMutation, { data, loading, error }] = useUpdateAutoPaySettingsForUserMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAutoPaySettingsForUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAutoPaySettingsForUserMutation,
    UpdateAutoPaySettingsForUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAutoPaySettingsForUserMutation, UpdateAutoPaySettingsForUserMutationVariables>(
    UpdateAutoPaySettingsForUserDocument,
    options,
  );
}
export type UpdateAutoPaySettingsForUserMutationHookResult = ReturnType<typeof useUpdateAutoPaySettingsForUserMutation>;
export type UpdateAutoPaySettingsForUserMutationResult = Apollo.MutationResult<UpdateAutoPaySettingsForUserMutation>;
export type UpdateAutoPaySettingsForUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateAutoPaySettingsForUserMutation,
  UpdateAutoPaySettingsForUserMutationVariables
>;
export const UpdateCreditLimitDocument = /*#__PURE__*/ gql`
  mutation UpdateCreditLimit($loanId: ID!, $creditLimit: Int!, $reason: String!) {
    updateLoanCreditLimit(loanId: $loanId, creditLimit: $creditLimit, reason: $reason) {
      ...BasicLoanFragment
    }
  }
  ${BasicLoanFragmentFragmentDoc}
`;
export type UpdateCreditLimitMutationFn = Apollo.MutationFunction<
  UpdateCreditLimitMutation,
  UpdateCreditLimitMutationVariables
>;

/**
 * __useUpdateCreditLimitMutation__
 *
 * To run a mutation, you first call `useUpdateCreditLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditLimitMutation, { data, loading, error }] = useUpdateCreditLimitMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      creditLimit: // value for 'creditLimit'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdateCreditLimitMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCreditLimitMutation, UpdateCreditLimitMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCreditLimitMutation, UpdateCreditLimitMutationVariables>(
    UpdateCreditLimitDocument,
    options,
  );
}
export type UpdateCreditLimitMutationHookResult = ReturnType<typeof useUpdateCreditLimitMutation>;
export type UpdateCreditLimitMutationResult = Apollo.MutationResult<UpdateCreditLimitMutation>;
export type UpdateCreditLimitMutationOptions = Apollo.BaseMutationOptions<
  UpdateCreditLimitMutation,
  UpdateCreditLimitMutationVariables
>;
export const ManageVelocityControlDocument = /*#__PURE__*/ gql`
  mutation ManageVelocityControl($loanId: ID!, $action: VelocityControlAction!, $velocityControlId: ID) {
    manageLoanVelocityControl(loanId: $loanId, action: $action, velocityControlId: $velocityControlId) {
      ...VelocityControlFragment
    }
  }
  ${VelocityControlFragmentFragmentDoc}
`;
export type ManageVelocityControlMutationFn = Apollo.MutationFunction<
  ManageVelocityControlMutation,
  ManageVelocityControlMutationVariables
>;

/**
 * __useManageVelocityControlMutation__
 *
 * To run a mutation, you first call `useManageVelocityControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageVelocityControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageVelocityControlMutation, { data, loading, error }] = useManageVelocityControlMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      action: // value for 'action'
 *      velocityControlId: // value for 'velocityControlId'
 *   },
 * });
 */
export function useManageVelocityControlMutation(
  baseOptions?: Apollo.MutationHookOptions<ManageVelocityControlMutation, ManageVelocityControlMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ManageVelocityControlMutation, ManageVelocityControlMutationVariables>(
    ManageVelocityControlDocument,
    options,
  );
}
export type ManageVelocityControlMutationHookResult = ReturnType<typeof useManageVelocityControlMutation>;
export type ManageVelocityControlMutationResult = Apollo.MutationResult<ManageVelocityControlMutation>;
export type ManageVelocityControlMutationOptions = Apollo.BaseMutationOptions<
  ManageVelocityControlMutation,
  ManageVelocityControlMutationVariables
>;
export const UpdateLoanManagedSpendingControlDocument = /*#__PURE__*/ gql`
  mutation UpdateLoanManagedSpendingControl(
    $loanId: ID!
    $type: SpendingControlType!
    $enabled: Boolean!
    $amountCents: Int!
    $granularity: SpendingGranularity!
  ) {
    updateLoanManagedSpendingControl(
      loanId: $loanId
      type: $type
      enabled: $enabled
      amountCents: $amountCents
      granularity: $granularity
    ) {
      ...SpendingControlFragment
    }
  }
  ${SpendingControlFragmentFragmentDoc}
`;
export type UpdateLoanManagedSpendingControlMutationFn = Apollo.MutationFunction<
  UpdateLoanManagedSpendingControlMutation,
  UpdateLoanManagedSpendingControlMutationVariables
>;

/**
 * __useUpdateLoanManagedSpendingControlMutation__
 *
 * To run a mutation, you first call `useUpdateLoanManagedSpendingControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoanManagedSpendingControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoanManagedSpendingControlMutation, { data, loading, error }] = useUpdateLoanManagedSpendingControlMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      type: // value for 'type'
 *      enabled: // value for 'enabled'
 *      amountCents: // value for 'amountCents'
 *      granularity: // value for 'granularity'
 *   },
 * });
 */
export function useUpdateLoanManagedSpendingControlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLoanManagedSpendingControlMutation,
    UpdateLoanManagedSpendingControlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLoanManagedSpendingControlMutation,
    UpdateLoanManagedSpendingControlMutationVariables
  >(UpdateLoanManagedSpendingControlDocument, options);
}
export type UpdateLoanManagedSpendingControlMutationHookResult = ReturnType<
  typeof useUpdateLoanManagedSpendingControlMutation
>;
export type UpdateLoanManagedSpendingControlMutationResult =
  Apollo.MutationResult<UpdateLoanManagedSpendingControlMutation>;
export type UpdateLoanManagedSpendingControlMutationOptions = Apollo.BaseMutationOptions<
  UpdateLoanManagedSpendingControlMutation,
  UpdateLoanManagedSpendingControlMutationVariables
>;
export const VoidTransactionDocument = /*#__PURE__*/ gql`
  mutation voidTransaction($transactionId: ID!) {
    voidTransaction(transactionId: $transactionId) {
      transactionId
    }
  }
`;
export type VoidTransactionMutationFn = Apollo.MutationFunction<
  VoidTransactionMutation,
  VoidTransactionMutationVariables
>;

/**
 * __useVoidTransactionMutation__
 *
 * To run a mutation, you first call `useVoidTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidTransactionMutation, { data, loading, error }] = useVoidTransactionMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useVoidTransactionMutation(
  baseOptions?: Apollo.MutationHookOptions<VoidTransactionMutation, VoidTransactionMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VoidTransactionMutation, VoidTransactionMutationVariables>(
    VoidTransactionDocument,
    options,
  );
}
export type VoidTransactionMutationHookResult = ReturnType<typeof useVoidTransactionMutation>;
export type VoidTransactionMutationResult = Apollo.MutationResult<VoidTransactionMutation>;
export type VoidTransactionMutationOptions = Apollo.BaseMutationOptions<
  VoidTransactionMutation,
  VoidTransactionMutationVariables
>;
export const CurrentUserDocument = /*#__PURE__*/ gql`
  query currentUser {
    currentUser {
      id
      email
      firstName
      lastName
      displayName
      role
    }
  }
`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
export function useCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
// @ts-ignore
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
): Apollo.UseSuspenseQueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
): Apollo.UseSuspenseQueryResult<CurrentUserQuery | undefined, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const GetAdminActionRecordsByActorDocument = /*#__PURE__*/ gql`
  query getAdminActionRecordsByActor(
    $actorId: ID!
    $to: Date
    $from: Date
    $fullResults: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    adminActionRecordsByActor(
      actorId: $actorId
      to: $to
      from: $from
      fullResults: $fullResults
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      adminActionRecords {
        ...AdminActionRecordFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${AdminActionRecordFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useGetAdminActionRecordsByActorQuery__
 *
 * To run a query within a React component, call `useGetAdminActionRecordsByActorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminActionRecordsByActorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminActionRecordsByActorQuery({
 *   variables: {
 *      actorId: // value for 'actorId'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      fullResults: // value for 'fullResults'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useGetAdminActionRecordsByActorQuery(
  baseOptions: Apollo.QueryHookOptions<GetAdminActionRecordsByActorQuery, GetAdminActionRecordsByActorQueryVariables> &
    ({ variables: GetAdminActionRecordsByActorQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAdminActionRecordsByActorQuery, GetAdminActionRecordsByActorQueryVariables>(
    GetAdminActionRecordsByActorDocument,
    options,
  );
}
export function useGetAdminActionRecordsByActorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdminActionRecordsByActorQuery,
    GetAdminActionRecordsByActorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAdminActionRecordsByActorQuery, GetAdminActionRecordsByActorQueryVariables>(
    GetAdminActionRecordsByActorDocument,
    options,
  );
}
// @ts-ignore
export function useGetAdminActionRecordsByActorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAdminActionRecordsByActorQuery,
    GetAdminActionRecordsByActorQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetAdminActionRecordsByActorQuery, GetAdminActionRecordsByActorQueryVariables>;
export function useGetAdminActionRecordsByActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAdminActionRecordsByActorQuery, GetAdminActionRecordsByActorQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetAdminActionRecordsByActorQuery | undefined,
  GetAdminActionRecordsByActorQueryVariables
>;
export function useGetAdminActionRecordsByActorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetAdminActionRecordsByActorQuery, GetAdminActionRecordsByActorQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAdminActionRecordsByActorQuery, GetAdminActionRecordsByActorQueryVariables>(
    GetAdminActionRecordsByActorDocument,
    options,
  );
}
export type GetAdminActionRecordsByActorQueryHookResult = ReturnType<typeof useGetAdminActionRecordsByActorQuery>;
export type GetAdminActionRecordsByActorLazyQueryHookResult = ReturnType<
  typeof useGetAdminActionRecordsByActorLazyQuery
>;
export type GetAdminActionRecordsByActorSuspenseQueryHookResult = ReturnType<
  typeof useGetAdminActionRecordsByActorSuspenseQuery
>;
export type GetAdminActionRecordsByActorQueryResult = Apollo.QueryResult<
  GetAdminActionRecordsByActorQuery,
  GetAdminActionRecordsByActorQueryVariables
>;
export const GetDrawdownCustomerDocument = /*#__PURE__*/ gql`
  query getDrawdownCustomer($userId: ID!) {
    user(id: $userId) {
      id
      firstName
      lastName
      displayName
    }
  }
`;

/**
 * __useGetDrawdownCustomerQuery__
 *
 * To run a query within a React component, call `useGetDrawdownCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrawdownCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrawdownCustomerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetDrawdownCustomerQuery(
  baseOptions: Apollo.QueryHookOptions<GetDrawdownCustomerQuery, GetDrawdownCustomerQueryVariables> &
    ({ variables: GetDrawdownCustomerQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDrawdownCustomerQuery, GetDrawdownCustomerQueryVariables>(
    GetDrawdownCustomerDocument,
    options,
  );
}
export function useGetDrawdownCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDrawdownCustomerQuery, GetDrawdownCustomerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDrawdownCustomerQuery, GetDrawdownCustomerQueryVariables>(
    GetDrawdownCustomerDocument,
    options,
  );
}
// @ts-ignore
export function useGetDrawdownCustomerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetDrawdownCustomerQuery, GetDrawdownCustomerQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDrawdownCustomerQuery, GetDrawdownCustomerQueryVariables>;
export function useGetDrawdownCustomerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDrawdownCustomerQuery, GetDrawdownCustomerQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetDrawdownCustomerQuery | undefined, GetDrawdownCustomerQueryVariables>;
export function useGetDrawdownCustomerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetDrawdownCustomerQuery, GetDrawdownCustomerQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDrawdownCustomerQuery, GetDrawdownCustomerQueryVariables>(
    GetDrawdownCustomerDocument,
    options,
  );
}
export type GetDrawdownCustomerQueryHookResult = ReturnType<typeof useGetDrawdownCustomerQuery>;
export type GetDrawdownCustomerLazyQueryHookResult = ReturnType<typeof useGetDrawdownCustomerLazyQuery>;
export type GetDrawdownCustomerSuspenseQueryHookResult = ReturnType<typeof useGetDrawdownCustomerSuspenseQuery>;
export type GetDrawdownCustomerQueryResult = Apollo.QueryResult<
  GetDrawdownCustomerQuery,
  GetDrawdownCustomerQueryVariables
>;
export const GetUserAchAuthorizationsDocument = /*#__PURE__*/ gql`
  query getUserAchAuthorizations(
    $userId: ID!
    $insertedAtSortDirection: SortDirection
    $statusSortDirection: SortDirection
    $statusSelections: [AchAuthorizationStatus]
    $recordTypeSortDirection: SortDirection
    $recordTypeSelections: [AchAuthorizationRecordType]
    $paginationDetailsOnly: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    userAchAuthorizations(
      userId: $userId
      insertedAtSortDirection: $insertedAtSortDirection
      statusSortDirection: $statusSortDirection
      statusSelections: $statusSelections
      recordTypeSortDirection: $recordTypeSortDirection
      recordTypeSelections: $recordTypeSelections
      paginationDetailsOnly: $paginationDetailsOnly
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      achAuthorizations {
        ...BaseAchAuthorization
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${BaseAchAuthorizationFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useGetUserAchAuthorizationsQuery__
 *
 * To run a query within a React component, call `useGetUserAchAuthorizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAchAuthorizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAchAuthorizationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      statusSortDirection: // value for 'statusSortDirection'
 *      statusSelections: // value for 'statusSelections'
 *      recordTypeSortDirection: // value for 'recordTypeSortDirection'
 *      recordTypeSelections: // value for 'recordTypeSelections'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useGetUserAchAuthorizationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserAchAuthorizationsQuery, GetUserAchAuthorizationsQueryVariables> &
    ({ variables: GetUserAchAuthorizationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserAchAuthorizationsQuery, GetUserAchAuthorizationsQueryVariables>(
    GetUserAchAuthorizationsDocument,
    options,
  );
}
export function useGetUserAchAuthorizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserAchAuthorizationsQuery, GetUserAchAuthorizationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserAchAuthorizationsQuery, GetUserAchAuthorizationsQueryVariables>(
    GetUserAchAuthorizationsDocument,
    options,
  );
}
// @ts-ignore
export function useGetUserAchAuthorizationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserAchAuthorizationsQuery, GetUserAchAuthorizationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserAchAuthorizationsQuery, GetUserAchAuthorizationsQueryVariables>;
export function useGetUserAchAuthorizationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserAchAuthorizationsQuery, GetUserAchAuthorizationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserAchAuthorizationsQuery | undefined, GetUserAchAuthorizationsQueryVariables>;
export function useGetUserAchAuthorizationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserAchAuthorizationsQuery, GetUserAchAuthorizationsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserAchAuthorizationsQuery, GetUserAchAuthorizationsQueryVariables>(
    GetUserAchAuthorizationsDocument,
    options,
  );
}
export type GetUserAchAuthorizationsQueryHookResult = ReturnType<typeof useGetUserAchAuthorizationsQuery>;
export type GetUserAchAuthorizationsLazyQueryHookResult = ReturnType<typeof useGetUserAchAuthorizationsLazyQuery>;
export type GetUserAchAuthorizationsSuspenseQueryHookResult = ReturnType<
  typeof useGetUserAchAuthorizationsSuspenseQuery
>;
export type GetUserAchAuthorizationsQueryResult = Apollo.QueryResult<
  GetUserAchAuthorizationsQuery,
  GetUserAchAuthorizationsQueryVariables
>;
export const GetLoanAchRequestsDocument = /*#__PURE__*/ gql`
  query getLoanAchRequests(
    $loanId: ID!
    $insertedAtSortDirection: SortDirection
    $statusSortDirection: SortDirection
    $statusSelections: [AchRequestStatus]
    $achTypeSortDirection: SortDirection
    $achTypeSelections: [AchRequestType]
    $settled: Boolean
    $paginationDetailsOnly: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    loanAchRequests(
      loanId: $loanId
      insertedAtSortDirection: $insertedAtSortDirection
      statusSortDirection: $statusSortDirection
      statusSelections: $statusSelections
      achTypeSortDirection: $achTypeSortDirection
      achTypeSelections: $achTypeSelections
      settled: $settled
      paginationDetailsOnly: $paginationDetailsOnly
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      achRequests {
        ...AchRequestFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${AchRequestFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useGetLoanAchRequestsQuery__
 *
 * To run a query within a React component, call `useGetLoanAchRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanAchRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanAchRequestsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      statusSortDirection: // value for 'statusSortDirection'
 *      statusSelections: // value for 'statusSelections'
 *      achTypeSortDirection: // value for 'achTypeSortDirection'
 *      achTypeSelections: // value for 'achTypeSelections'
 *      settled: // value for 'settled'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useGetLoanAchRequestsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables> &
    ({ variables: GetLoanAchRequestsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>(
    GetLoanAchRequestsDocument,
    options,
  );
}
export function useGetLoanAchRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>(
    GetLoanAchRequestsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLoanAchRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>;
export function useGetLoanAchRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanAchRequestsQuery | undefined, GetLoanAchRequestsQueryVariables>;
export function useGetLoanAchRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanAchRequestsQuery, GetLoanAchRequestsQueryVariables>(
    GetLoanAchRequestsDocument,
    options,
  );
}
export type GetLoanAchRequestsQueryHookResult = ReturnType<typeof useGetLoanAchRequestsQuery>;
export type GetLoanAchRequestsLazyQueryHookResult = ReturnType<typeof useGetLoanAchRequestsLazyQuery>;
export type GetLoanAchRequestsSuspenseQueryHookResult = ReturnType<typeof useGetLoanAchRequestsSuspenseQuery>;
export type GetLoanAchRequestsQueryResult = Apollo.QueryResult<
  GetLoanAchRequestsQuery,
  GetLoanAchRequestsQueryVariables
>;
export const GetUserAdminActionRecordsDocument = /*#__PURE__*/ gql`
  query getUserAdminActionRecords(
    $userId: ID!
    $to: Date
    $from: Date
    $fullResults: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    adminActionRecordsForUser(
      userId: $userId
      to: $to
      from: $from
      fullResults: $fullResults
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      adminActionRecords {
        ...AdminActionRecordFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${AdminActionRecordFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useGetUserAdminActionRecordsQuery__
 *
 * To run a query within a React component, call `useGetUserAdminActionRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAdminActionRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAdminActionRecordsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      fullResults: // value for 'fullResults'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useGetUserAdminActionRecordsQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserAdminActionRecordsQuery, GetUserAdminActionRecordsQueryVariables> &
    ({ variables: GetUserAdminActionRecordsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserAdminActionRecordsQuery, GetUserAdminActionRecordsQueryVariables>(
    GetUserAdminActionRecordsDocument,
    options,
  );
}
export function useGetUserAdminActionRecordsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserAdminActionRecordsQuery, GetUserAdminActionRecordsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserAdminActionRecordsQuery, GetUserAdminActionRecordsQueryVariables>(
    GetUserAdminActionRecordsDocument,
    options,
  );
}
// @ts-ignore
export function useGetUserAdminActionRecordsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserAdminActionRecordsQuery,
    GetUserAdminActionRecordsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetUserAdminActionRecordsQuery, GetUserAdminActionRecordsQueryVariables>;
export function useGetUserAdminActionRecordsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserAdminActionRecordsQuery, GetUserAdminActionRecordsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserAdminActionRecordsQuery | undefined, GetUserAdminActionRecordsQueryVariables>;
export function useGetUserAdminActionRecordsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUserAdminActionRecordsQuery, GetUserAdminActionRecordsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserAdminActionRecordsQuery, GetUserAdminActionRecordsQueryVariables>(
    GetUserAdminActionRecordsDocument,
    options,
  );
}
export type GetUserAdminActionRecordsQueryHookResult = ReturnType<typeof useGetUserAdminActionRecordsQuery>;
export type GetUserAdminActionRecordsLazyQueryHookResult = ReturnType<typeof useGetUserAdminActionRecordsLazyQuery>;
export type GetUserAdminActionRecordsSuspenseQueryHookResult = ReturnType<
  typeof useGetUserAdminActionRecordsSuspenseQuery
>;
export type GetUserAdminActionRecordsQueryResult = Apollo.QueryResult<
  GetUserAdminActionRecordsQuery,
  GetUserAdminActionRecordsQueryVariables
>;
export const GetLoanDailyReportsDocument = /*#__PURE__*/ gql`
  query getLoanDailyReports($loanId: ID!) {
    loanDailyReports(loanId: $loanId) {
      ...BaseDailyReport
    }
  }
  ${BaseDailyReportFragmentDoc}
`;

/**
 * __useGetLoanDailyReportsQuery__
 *
 * To run a query within a React component, call `useGetLoanDailyReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanDailyReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanDailyReportsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetLoanDailyReportsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanDailyReportsQuery, GetLoanDailyReportsQueryVariables> &
    ({ variables: GetLoanDailyReportsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanDailyReportsQuery, GetLoanDailyReportsQueryVariables>(
    GetLoanDailyReportsDocument,
    options,
  );
}
export function useGetLoanDailyReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanDailyReportsQuery, GetLoanDailyReportsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanDailyReportsQuery, GetLoanDailyReportsQueryVariables>(
    GetLoanDailyReportsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLoanDailyReportsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanDailyReportsQuery, GetLoanDailyReportsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanDailyReportsQuery, GetLoanDailyReportsQueryVariables>;
export function useGetLoanDailyReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanDailyReportsQuery, GetLoanDailyReportsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanDailyReportsQuery | undefined, GetLoanDailyReportsQueryVariables>;
export function useGetLoanDailyReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanDailyReportsQuery, GetLoanDailyReportsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanDailyReportsQuery, GetLoanDailyReportsQueryVariables>(
    GetLoanDailyReportsDocument,
    options,
  );
}
export type GetLoanDailyReportsQueryHookResult = ReturnType<typeof useGetLoanDailyReportsQuery>;
export type GetLoanDailyReportsLazyQueryHookResult = ReturnType<typeof useGetLoanDailyReportsLazyQuery>;
export type GetLoanDailyReportsSuspenseQueryHookResult = ReturnType<typeof useGetLoanDailyReportsSuspenseQuery>;
export type GetLoanDailyReportsQueryResult = Apollo.QueryResult<
  GetLoanDailyReportsQuery,
  GetLoanDailyReportsQueryVariables
>;
export const GetLoanDisputesDocument = /*#__PURE__*/ gql`
  query getLoanDisputes(
    $loanId: ID!
    $insertedAtSortDirection: SortDirection
    $statusSortDirection: SortDirection
    $statusSelections: [DisputeStatus]
    $paginationDetailsOnly: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    loanDisputes(
      loanId: $loanId
      insertedAtSortDirection: $insertedAtSortDirection
      statusSortDirection: $statusSortDirection
      statusSelections: $statusSelections
      paginationDetailsOnly: $paginationDetailsOnly
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      disputes {
        ...CardDisputeFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${CardDisputeFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useGetLoanDisputesQuery__
 *
 * To run a query within a React component, call `useGetLoanDisputesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanDisputesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanDisputesQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      statusSortDirection: // value for 'statusSortDirection'
 *      statusSelections: // value for 'statusSelections'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useGetLoanDisputesQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanDisputesQuery, GetLoanDisputesQueryVariables> &
    ({ variables: GetLoanDisputesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanDisputesQuery, GetLoanDisputesQueryVariables>(GetLoanDisputesDocument, options);
}
export function useGetLoanDisputesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanDisputesQuery, GetLoanDisputesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanDisputesQuery, GetLoanDisputesQueryVariables>(GetLoanDisputesDocument, options);
}
// @ts-ignore
export function useGetLoanDisputesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanDisputesQuery, GetLoanDisputesQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanDisputesQuery, GetLoanDisputesQueryVariables>;
export function useGetLoanDisputesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoanDisputesQuery, GetLoanDisputesQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanDisputesQuery | undefined, GetLoanDisputesQueryVariables>;
export function useGetLoanDisputesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoanDisputesQuery, GetLoanDisputesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanDisputesQuery, GetLoanDisputesQueryVariables>(GetLoanDisputesDocument, options);
}
export type GetLoanDisputesQueryHookResult = ReturnType<typeof useGetLoanDisputesQuery>;
export type GetLoanDisputesLazyQueryHookResult = ReturnType<typeof useGetLoanDisputesLazyQuery>;
export type GetLoanDisputesSuspenseQueryHookResult = ReturnType<typeof useGetLoanDisputesSuspenseQuery>;
export type GetLoanDisputesQueryResult = Apollo.QueryResult<GetLoanDisputesQuery, GetLoanDisputesQueryVariables>;
export const GetUserEventsDocument = /*#__PURE__*/ gql`
  query GetUserEvents($userId: ID!) {
    user(id: $userId) {
      id
      userEvents {
        ...UserEventFragment
      }
    }
  }
  ${UserEventFragmentFragmentDoc}
`;

/**
 * __useGetUserEventsQuery__
 *
 * To run a query within a React component, call `useGetUserEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserEventsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserEventsQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserEventsQuery, GetUserEventsQueryVariables> &
    ({ variables: GetUserEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserEventsQuery, GetUserEventsQueryVariables>(GetUserEventsDocument, options);
}
export function useGetUserEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserEventsQuery, GetUserEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserEventsQuery, GetUserEventsQueryVariables>(GetUserEventsDocument, options);
}
// @ts-ignore
export function useGetUserEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserEventsQuery, GetUserEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserEventsQuery, GetUserEventsQueryVariables>;
export function useGetUserEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserEventsQuery, GetUserEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserEventsQuery | undefined, GetUserEventsQueryVariables>;
export function useGetUserEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserEventsQuery, GetUserEventsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserEventsQuery, GetUserEventsQueryVariables>(GetUserEventsDocument, options);
}
export type GetUserEventsQueryHookResult = ReturnType<typeof useGetUserEventsQuery>;
export type GetUserEventsLazyQueryHookResult = ReturnType<typeof useGetUserEventsLazyQuery>;
export type GetUserEventsSuspenseQueryHookResult = ReturnType<typeof useGetUserEventsSuspenseQuery>;
export type GetUserEventsQueryResult = Apollo.QueryResult<GetUserEventsQuery, GetUserEventsQueryVariables>;
export const GetLoanStatementsDocument = /*#__PURE__*/ gql`
  query getLoanStatements($loanId: ID!) {
    loanStatements(loanId: $loanId) {
      ...StatementFragment
    }
  }
  ${StatementFragmentFragmentDoc}
`;

/**
 * __useGetLoanStatementsQuery__
 *
 * To run a query within a React component, call `useGetLoanStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanStatementsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetLoanStatementsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanStatementsQuery, GetLoanStatementsQueryVariables> &
    ({ variables: GetLoanStatementsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>(GetLoanStatementsDocument, options);
}
export function useGetLoanStatementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>(
    GetLoanStatementsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLoanStatementsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>;
export function useGetLoanStatementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanStatementsQuery | undefined, GetLoanStatementsQueryVariables>;
export function useGetLoanStatementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>(
    GetLoanStatementsDocument,
    options,
  );
}
export type GetLoanStatementsQueryHookResult = ReturnType<typeof useGetLoanStatementsQuery>;
export type GetLoanStatementsLazyQueryHookResult = ReturnType<typeof useGetLoanStatementsLazyQuery>;
export type GetLoanStatementsSuspenseQueryHookResult = ReturnType<typeof useGetLoanStatementsSuspenseQuery>;
export type GetLoanStatementsQueryResult = Apollo.QueryResult<GetLoanStatementsQuery, GetLoanStatementsQueryVariables>;
export const GetLoanTransactionsDocument = /*#__PURE__*/ gql`
  query getLoanTransactions($loanId: ID!, $from: Date, $to: Date, $viewMode: TransactionViewMode) {
    loanTransactions(loanId: $loanId, from: $from, to: $to, viewMode: $viewMode) {
      transactions {
        ...TransactionDetails
      }
      balance {
        ...BaseBalanceDetails
      }
      balanceRaw {
        ...BaseBalanceRawDetails
      }
    }
  }
  ${TransactionDetailsFragmentDoc}
  ${BaseBalanceDetailsFragmentDoc}
  ${BaseBalanceRawDetailsFragmentDoc}
`;

/**
 * __useGetLoanTransactionsQuery__
 *
 * To run a query within a React component, call `useGetLoanTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanTransactionsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      viewMode: // value for 'viewMode'
 *   },
 * });
 */
export function useGetLoanTransactionsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables> &
    ({ variables: GetLoanTransactionsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>(
    GetLoanTransactionsDocument,
    options,
  );
}
export function useGetLoanTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>(
    GetLoanTransactionsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLoanTransactionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>;
export function useGetLoanTransactionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanTransactionsQuery | undefined, GetLoanTransactionsQueryVariables>;
export function useGetLoanTransactionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanTransactionsQuery, GetLoanTransactionsQueryVariables>(
    GetLoanTransactionsDocument,
    options,
  );
}
export type GetLoanTransactionsQueryHookResult = ReturnType<typeof useGetLoanTransactionsQuery>;
export type GetLoanTransactionsLazyQueryHookResult = ReturnType<typeof useGetLoanTransactionsLazyQuery>;
export type GetLoanTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetLoanTransactionsSuspenseQuery>;
export type GetLoanTransactionsQueryResult = Apollo.QueryResult<
  GetLoanTransactionsQuery,
  GetLoanTransactionsQueryVariables
>;
export const GetLoanVelocityControlsDocument = /*#__PURE__*/ gql`
  query getLoanVelocityControls($loanId: ID!) {
    loanVelocityControls(loanId: $loanId) {
      ...VelocityControlFragment
    }
  }
  ${VelocityControlFragmentFragmentDoc}
`;

/**
 * __useGetLoanVelocityControlsQuery__
 *
 * To run a query within a React component, call `useGetLoanVelocityControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanVelocityControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanVelocityControlsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetLoanVelocityControlsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanVelocityControlsQuery, GetLoanVelocityControlsQueryVariables> &
    ({ variables: GetLoanVelocityControlsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanVelocityControlsQuery, GetLoanVelocityControlsQueryVariables>(
    GetLoanVelocityControlsDocument,
    options,
  );
}
export function useGetLoanVelocityControlsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanVelocityControlsQuery, GetLoanVelocityControlsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanVelocityControlsQuery, GetLoanVelocityControlsQueryVariables>(
    GetLoanVelocityControlsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLoanVelocityControlsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanVelocityControlsQuery, GetLoanVelocityControlsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanVelocityControlsQuery, GetLoanVelocityControlsQueryVariables>;
export function useGetLoanVelocityControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanVelocityControlsQuery, GetLoanVelocityControlsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanVelocityControlsQuery | undefined, GetLoanVelocityControlsQueryVariables>;
export function useGetLoanVelocityControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanVelocityControlsQuery, GetLoanVelocityControlsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanVelocityControlsQuery, GetLoanVelocityControlsQueryVariables>(
    GetLoanVelocityControlsDocument,
    options,
  );
}
export type GetLoanVelocityControlsQueryHookResult = ReturnType<typeof useGetLoanVelocityControlsQuery>;
export type GetLoanVelocityControlsLazyQueryHookResult = ReturnType<typeof useGetLoanVelocityControlsLazyQuery>;
export type GetLoanVelocityControlsSuspenseQueryHookResult = ReturnType<typeof useGetLoanVelocityControlsSuspenseQuery>;
export type GetLoanVelocityControlsQueryResult = Apollo.QueryResult<
  GetLoanVelocityControlsQuery,
  GetLoanVelocityControlsQueryVariables
>;
export const GetLoanAutoPaySettingsDocument = /*#__PURE__*/ gql`
  query getLoanAutoPaySettings($loanId: ID!) {
    loanAutoPaySettings(loanId: $loanId) {
      id
      paymentType
      daysBeforePayment
      enabled
      plaidAccountId
      insertedAt
      updatedAt
    }
  }
`;

/**
 * __useGetLoanAutoPaySettingsQuery__
 *
 * To run a query within a React component, call `useGetLoanAutoPaySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanAutoPaySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanAutoPaySettingsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetLoanAutoPaySettingsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables> &
    ({ variables: GetLoanAutoPaySettingsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>(
    GetLoanAutoPaySettingsDocument,
    options,
  );
}
export function useGetLoanAutoPaySettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>(
    GetLoanAutoPaySettingsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLoanAutoPaySettingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>;
export function useGetLoanAutoPaySettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanAutoPaySettingsQuery | undefined, GetLoanAutoPaySettingsQueryVariables>;
export function useGetLoanAutoPaySettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanAutoPaySettingsQuery, GetLoanAutoPaySettingsQueryVariables>(
    GetLoanAutoPaySettingsDocument,
    options,
  );
}
export type GetLoanAutoPaySettingsQueryHookResult = ReturnType<typeof useGetLoanAutoPaySettingsQuery>;
export type GetLoanAutoPaySettingsLazyQueryHookResult = ReturnType<typeof useGetLoanAutoPaySettingsLazyQuery>;
export type GetLoanAutoPaySettingsSuspenseQueryHookResult = ReturnType<typeof useGetLoanAutoPaySettingsSuspenseQuery>;
export type GetLoanAutoPaySettingsQueryResult = Apollo.QueryResult<
  GetLoanAutoPaySettingsQuery,
  GetLoanAutoPaySettingsQueryVariables
>;
export const GetCardEventsDocument = /*#__PURE__*/ gql`
  query GetCardEvents($cardId: ID!) {
    card(cardId: $cardId) {
      id
      lastFour
      cardEvents {
        ...CardEventFragment
      }
    }
  }
  ${CardEventFragmentFragmentDoc}
`;

/**
 * __useGetCardEventsQuery__
 *
 * To run a query within a React component, call `useGetCardEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardEventsQuery({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useGetCardEventsQuery(
  baseOptions: Apollo.QueryHookOptions<GetCardEventsQuery, GetCardEventsQueryVariables> &
    ({ variables: GetCardEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCardEventsQuery, GetCardEventsQueryVariables>(GetCardEventsDocument, options);
}
export function useGetCardEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCardEventsQuery, GetCardEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCardEventsQuery, GetCardEventsQueryVariables>(GetCardEventsDocument, options);
}
// @ts-ignore
export function useGetCardEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardEventsQuery, GetCardEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCardEventsQuery, GetCardEventsQueryVariables>;
export function useGetCardEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardEventsQuery, GetCardEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCardEventsQuery | undefined, GetCardEventsQueryVariables>;
export function useGetCardEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardEventsQuery, GetCardEventsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCardEventsQuery, GetCardEventsQueryVariables>(GetCardEventsDocument, options);
}
export type GetCardEventsQueryHookResult = ReturnType<typeof useGetCardEventsQuery>;
export type GetCardEventsLazyQueryHookResult = ReturnType<typeof useGetCardEventsLazyQuery>;
export type GetCardEventsSuspenseQueryHookResult = ReturnType<typeof useGetCardEventsSuspenseQuery>;
export type GetCardEventsQueryResult = Apollo.QueryResult<GetCardEventsQuery, GetCardEventsQueryVariables>;
export const GetCardDocument = /*#__PURE__*/ gql`
  query getCard($cardId: ID!) {
    card(cardId: $cardId) {
      ...CardWithUserFragment
      loan {
        id
        partnerAccountNumber
      }
    }
  }
  ${CardWithUserFragmentFragmentDoc}
`;

/**
 * __useGetCardQuery__
 *
 * To run a query within a React component, call `useGetCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardQuery({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useGetCardQuery(
  baseOptions: Apollo.QueryHookOptions<GetCardQuery, GetCardQueryVariables> &
    ({ variables: GetCardQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCardQuery, GetCardQueryVariables>(GetCardDocument, options);
}
export function useGetCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardQuery, GetCardQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCardQuery, GetCardQueryVariables>(GetCardDocument, options);
}
// @ts-ignore
export function useGetCardSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardQuery, GetCardQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCardQuery, GetCardQueryVariables>;
export function useGetCardSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardQuery, GetCardQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCardQuery | undefined, GetCardQueryVariables>;
export function useGetCardSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardQuery, GetCardQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCardQuery, GetCardQueryVariables>(GetCardDocument, options);
}
export type GetCardQueryHookResult = ReturnType<typeof useGetCardQuery>;
export type GetCardLazyQueryHookResult = ReturnType<typeof useGetCardLazyQuery>;
export type GetCardSuspenseQueryHookResult = ReturnType<typeof useGetCardSuspenseQuery>;
export type GetCardQueryResult = Apollo.QueryResult<GetCardQuery, GetCardQueryVariables>;
export const GetCardStatusDocument = /*#__PURE__*/ gql`
  query getCardStatus($referenceId: ID!) {
    getCardStatus(referenceId: $referenceId)
  }
`;

/**
 * __useGetCardStatusQuery__
 *
 * To run a query within a React component, call `useGetCardStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardStatusQuery({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useGetCardStatusQuery(
  baseOptions: Apollo.QueryHookOptions<GetCardStatusQuery, GetCardStatusQueryVariables> &
    ({ variables: GetCardStatusQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCardStatusQuery, GetCardStatusQueryVariables>(GetCardStatusDocument, options);
}
export function useGetCardStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCardStatusQuery, GetCardStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCardStatusQuery, GetCardStatusQueryVariables>(GetCardStatusDocument, options);
}
// @ts-ignore
export function useGetCardStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCardStatusQuery, GetCardStatusQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCardStatusQuery, GetCardStatusQueryVariables>;
export function useGetCardStatusSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardStatusQuery, GetCardStatusQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetCardStatusQuery | undefined, GetCardStatusQueryVariables>;
export function useGetCardStatusSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardStatusQuery, GetCardStatusQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCardStatusQuery, GetCardStatusQueryVariables>(GetCardStatusDocument, options);
}
export type GetCardStatusQueryHookResult = ReturnType<typeof useGetCardStatusQuery>;
export type GetCardStatusLazyQueryHookResult = ReturnType<typeof useGetCardStatusLazyQuery>;
export type GetCardStatusSuspenseQueryHookResult = ReturnType<typeof useGetCardStatusSuspenseQuery>;
export type GetCardStatusQueryResult = Apollo.QueryResult<GetCardStatusQuery, GetCardStatusQueryVariables>;
export const GetLoanCreditUtilizationDocument = /*#__PURE__*/ gql`
  query getLoanCreditUtilization($loanId: ID!) {
    creditUtilization(loanId: $loanId) {
      ...BaseCreditUtilization
    }
  }
  ${BaseCreditUtilizationFragmentDoc}
`;

/**
 * __useGetLoanCreditUtilizationQuery__
 *
 * To run a query within a React component, call `useGetLoanCreditUtilizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanCreditUtilizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanCreditUtilizationQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetLoanCreditUtilizationQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanCreditUtilizationQuery, GetLoanCreditUtilizationQueryVariables> &
    ({ variables: GetLoanCreditUtilizationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanCreditUtilizationQuery, GetLoanCreditUtilizationQueryVariables>(
    GetLoanCreditUtilizationDocument,
    options,
  );
}
export function useGetLoanCreditUtilizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanCreditUtilizationQuery, GetLoanCreditUtilizationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanCreditUtilizationQuery, GetLoanCreditUtilizationQueryVariables>(
    GetLoanCreditUtilizationDocument,
    options,
  );
}
// @ts-ignore
export function useGetLoanCreditUtilizationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanCreditUtilizationQuery, GetLoanCreditUtilizationQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanCreditUtilizationQuery, GetLoanCreditUtilizationQueryVariables>;
export function useGetLoanCreditUtilizationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanCreditUtilizationQuery, GetLoanCreditUtilizationQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanCreditUtilizationQuery | undefined, GetLoanCreditUtilizationQueryVariables>;
export function useGetLoanCreditUtilizationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLoanCreditUtilizationQuery, GetLoanCreditUtilizationQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanCreditUtilizationQuery, GetLoanCreditUtilizationQueryVariables>(
    GetLoanCreditUtilizationDocument,
    options,
  );
}
export type GetLoanCreditUtilizationQueryHookResult = ReturnType<typeof useGetLoanCreditUtilizationQuery>;
export type GetLoanCreditUtilizationLazyQueryHookResult = ReturnType<typeof useGetLoanCreditUtilizationLazyQuery>;
export type GetLoanCreditUtilizationSuspenseQueryHookResult = ReturnType<
  typeof useGetLoanCreditUtilizationSuspenseQuery
>;
export type GetLoanCreditUtilizationQueryResult = Apollo.QueryResult<
  GetLoanCreditUtilizationQuery,
  GetLoanCreditUtilizationQueryVariables
>;
export const LedgerTransactionDocument = /*#__PURE__*/ gql`
  query ledgerTransaction($entryId: ID!) {
    ledgerTransaction(entryId: $entryId) {
      entryId
      transactionId
      accountId
      journalId
      entryType
      layer
      amount
      currency
      direction
      sequence
      description
      created
      modified
      version
      recordId
      balanceRecordId
      balanceRecordVersion
      loanId
      merchantDetails {
        displayName
        name
        city
        region
      }
      rawEntry
    }
  }
`;

/**
 * __useLedgerTransactionQuery__
 *
 * To run a query within a React component, call `useLedgerTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerTransactionQuery({
 *   variables: {
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useLedgerTransactionQuery(
  baseOptions: Apollo.QueryHookOptions<LedgerTransactionQuery, LedgerTransactionQueryVariables> &
    ({ variables: LedgerTransactionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LedgerTransactionQuery, LedgerTransactionQueryVariables>(LedgerTransactionDocument, options);
}
export function useLedgerTransactionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LedgerTransactionQuery, LedgerTransactionQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LedgerTransactionQuery, LedgerTransactionQueryVariables>(
    LedgerTransactionDocument,
    options,
  );
}
// @ts-ignore
export function useLedgerTransactionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<LedgerTransactionQuery, LedgerTransactionQueryVariables>,
): Apollo.UseSuspenseQueryResult<LedgerTransactionQuery, LedgerTransactionQueryVariables>;
export function useLedgerTransactionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LedgerTransactionQuery, LedgerTransactionQueryVariables>,
): Apollo.UseSuspenseQueryResult<LedgerTransactionQuery | undefined, LedgerTransactionQueryVariables>;
export function useLedgerTransactionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LedgerTransactionQuery, LedgerTransactionQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LedgerTransactionQuery, LedgerTransactionQueryVariables>(
    LedgerTransactionDocument,
    options,
  );
}
export type LedgerTransactionQueryHookResult = ReturnType<typeof useLedgerTransactionQuery>;
export type LedgerTransactionLazyQueryHookResult = ReturnType<typeof useLedgerTransactionLazyQuery>;
export type LedgerTransactionSuspenseQueryHookResult = ReturnType<typeof useLedgerTransactionSuspenseQuery>;
export type LedgerTransactionQueryResult = Apollo.QueryResult<LedgerTransactionQuery, LedgerTransactionQueryVariables>;
export const LedgerTransactionsDocument = /*#__PURE__*/ gql`
  query ledgerTransactions(
    $programId: ID
    $loanId: ID
    $accountId: ID
    $from: Date
    $to: Date
    $layers: [LedgerEntryLayer!]
    $statuses: [LedgerTransactionStatus!]
    $directions: [PaymentDirection!]
    $rawTranCodes: [String!]
    $entryTypes: [String!]
    $settled: Boolean
    $entryScope: LedgerTransactionEntryScope
    $viewMode: TransactionViewMode
    $limit: Int
    $pageNumber: Int
    $resultsPerPage: Int
  ) {
    ledgerTransactions(
      programId: $programId
      loanId: $loanId
      accountId: $accountId
      from: $from
      to: $to
      layers: $layers
      statuses: $statuses
      directions: $directions
      rawTranCodes: $rawTranCodes
      entryTypes: $entryTypes
      settled: $settled
      entryScope: $entryScope
      viewMode: $viewMode
      limit: $limit
      pageNumber: $pageNumber
      resultsPerPage: $resultsPerPage
    ) {
      pagination {
        totalRecords
        resultsPerPage
        pageNumber
        hasNextPage
        totalPages
      }
      transactions {
        id
        transactionId
        entryId
        accountId
        journalId
        entryType
        layer
        amount
        transmissionDate
        effectiveDate
        statementDate
        rawTranCode
        metadata
        status
        direction
        loanId
        merchantDetails {
          displayName
          name
        }
      }
    }
  }
`;

/**
 * __useLedgerTransactionsQuery__
 *
 * To run a query within a React component, call `useLedgerTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerTransactionsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      loanId: // value for 'loanId'
 *      accountId: // value for 'accountId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      layers: // value for 'layers'
 *      statuses: // value for 'statuses'
 *      directions: // value for 'directions'
 *      rawTranCodes: // value for 'rawTranCodes'
 *      entryTypes: // value for 'entryTypes'
 *      settled: // value for 'settled'
 *      entryScope: // value for 'entryScope'
 *      viewMode: // value for 'viewMode'
 *      limit: // value for 'limit'
 *      pageNumber: // value for 'pageNumber'
 *      resultsPerPage: // value for 'resultsPerPage'
 *   },
 * });
 */
export function useLedgerTransactionsQuery(
  baseOptions?: Apollo.QueryHookOptions<LedgerTransactionsQuery, LedgerTransactionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LedgerTransactionsQuery, LedgerTransactionsQueryVariables>(
    LedgerTransactionsDocument,
    options,
  );
}
export function useLedgerTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LedgerTransactionsQuery, LedgerTransactionsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LedgerTransactionsQuery, LedgerTransactionsQueryVariables>(
    LedgerTransactionsDocument,
    options,
  );
}
// @ts-ignore
export function useLedgerTransactionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<LedgerTransactionsQuery, LedgerTransactionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<LedgerTransactionsQuery, LedgerTransactionsQueryVariables>;
export function useLedgerTransactionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LedgerTransactionsQuery, LedgerTransactionsQueryVariables>,
): Apollo.UseSuspenseQueryResult<LedgerTransactionsQuery | undefined, LedgerTransactionsQueryVariables>;
export function useLedgerTransactionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LedgerTransactionsQuery, LedgerTransactionsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LedgerTransactionsQuery, LedgerTransactionsQueryVariables>(
    LedgerTransactionsDocument,
    options,
  );
}
export type LedgerTransactionsQueryHookResult = ReturnType<typeof useLedgerTransactionsQuery>;
export type LedgerTransactionsLazyQueryHookResult = ReturnType<typeof useLedgerTransactionsLazyQuery>;
export type LedgerTransactionsSuspenseQueryHookResult = ReturnType<typeof useLedgerTransactionsSuspenseQuery>;
export type LedgerTransactionsQueryResult = Apollo.QueryResult<
  LedgerTransactionsQuery,
  LedgerTransactionsQueryVariables
>;
export const GetLoanEventsDocument = /*#__PURE__*/ gql`
  query GetLoanEvents($loanId: ID!) {
    loan(id: $loanId) {
      id
      loanEvents {
        ...LoanEventFragment
      }
      cardEvents {
        ...CardEventFragment
      }
    }
  }
  ${LoanEventFragmentFragmentDoc}
  ${CardEventFragmentFragmentDoc}
`;

/**
 * __useGetLoanEventsQuery__
 *
 * To run a query within a React component, call `useGetLoanEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanEventsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetLoanEventsQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanEventsQuery, GetLoanEventsQueryVariables> &
    ({ variables: GetLoanEventsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanEventsQuery, GetLoanEventsQueryVariables>(GetLoanEventsDocument, options);
}
export function useGetLoanEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLoanEventsQuery, GetLoanEventsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanEventsQuery, GetLoanEventsQueryVariables>(GetLoanEventsDocument, options);
}
// @ts-ignore
export function useGetLoanEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanEventsQuery, GetLoanEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanEventsQuery, GetLoanEventsQueryVariables>;
export function useGetLoanEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoanEventsQuery, GetLoanEventsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanEventsQuery | undefined, GetLoanEventsQueryVariables>;
export function useGetLoanEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoanEventsQuery, GetLoanEventsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanEventsQuery, GetLoanEventsQueryVariables>(GetLoanEventsDocument, options);
}
export type GetLoanEventsQueryHookResult = ReturnType<typeof useGetLoanEventsQuery>;
export type GetLoanEventsLazyQueryHookResult = ReturnType<typeof useGetLoanEventsLazyQuery>;
export type GetLoanEventsSuspenseQueryHookResult = ReturnType<typeof useGetLoanEventsSuspenseQuery>;
export type GetLoanEventsQueryResult = Apollo.QueryResult<GetLoanEventsQuery, GetLoanEventsQueryVariables>;
export const GetLoanManagedSpendingControlsDocument = /*#__PURE__*/ gql`
  query getLoanManagedSpendingControls($loanId: ID!) {
    loanManagedSpendingControls(loanId: $loanId) {
      ...SpendingControlFragment
    }
  }
  ${SpendingControlFragmentFragmentDoc}
`;

/**
 * __useGetLoanManagedSpendingControlsQuery__
 *
 * To run a query within a React component, call `useGetLoanManagedSpendingControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanManagedSpendingControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanManagedSpendingControlsQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetLoanManagedSpendingControlsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLoanManagedSpendingControlsQuery,
    GetLoanManagedSpendingControlsQueryVariables
  > &
    ({ variables: GetLoanManagedSpendingControlsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanManagedSpendingControlsQuery, GetLoanManagedSpendingControlsQueryVariables>(
    GetLoanManagedSpendingControlsDocument,
    options,
  );
}
export function useGetLoanManagedSpendingControlsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLoanManagedSpendingControlsQuery,
    GetLoanManagedSpendingControlsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanManagedSpendingControlsQuery, GetLoanManagedSpendingControlsQueryVariables>(
    GetLoanManagedSpendingControlsDocument,
    options,
  );
}
// @ts-ignore
export function useGetLoanManagedSpendingControlsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetLoanManagedSpendingControlsQuery,
    GetLoanManagedSpendingControlsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetLoanManagedSpendingControlsQuery, GetLoanManagedSpendingControlsQueryVariables>;
export function useGetLoanManagedSpendingControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLoanManagedSpendingControlsQuery,
        GetLoanManagedSpendingControlsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetLoanManagedSpendingControlsQuery | undefined,
  GetLoanManagedSpendingControlsQueryVariables
>;
export function useGetLoanManagedSpendingControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetLoanManagedSpendingControlsQuery,
        GetLoanManagedSpendingControlsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanManagedSpendingControlsQuery, GetLoanManagedSpendingControlsQueryVariables>(
    GetLoanManagedSpendingControlsDocument,
    options,
  );
}
export type GetLoanManagedSpendingControlsQueryHookResult = ReturnType<typeof useGetLoanManagedSpendingControlsQuery>;
export type GetLoanManagedSpendingControlsLazyQueryHookResult = ReturnType<
  typeof useGetLoanManagedSpendingControlsLazyQuery
>;
export type GetLoanManagedSpendingControlsSuspenseQueryHookResult = ReturnType<
  typeof useGetLoanManagedSpendingControlsSuspenseQuery
>;
export type GetLoanManagedSpendingControlsQueryResult = Apollo.QueryResult<
  GetLoanManagedSpendingControlsQuery,
  GetLoanManagedSpendingControlsQueryVariables
>;
export const GetLoanDocument = /*#__PURE__*/ gql`
  query getLoan($id: ID!) {
    loan(id: $id) {
      ...LoanFragment
    }
  }
  ${LoanFragmentFragmentDoc}
`;

/**
 * __useGetLoanQuery__
 *
 * To run a query within a React component, call `useGetLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLoanQuery(
  baseOptions: Apollo.QueryHookOptions<GetLoanQuery, GetLoanQueryVariables> &
    ({ variables: GetLoanQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLoanQuery, GetLoanQueryVariables>(GetLoanDocument, options);
}
export function useGetLoanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanQuery, GetLoanQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLoanQuery, GetLoanQueryVariables>(GetLoanDocument, options);
}
// @ts-ignore
export function useGetLoanSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLoanQuery, GetLoanQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanQuery, GetLoanQueryVariables>;
export function useGetLoanSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoanQuery, GetLoanQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetLoanQuery | undefined, GetLoanQueryVariables>;
export function useGetLoanSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoanQuery, GetLoanQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLoanQuery, GetLoanQueryVariables>(GetLoanDocument, options);
}
export type GetLoanQueryHookResult = ReturnType<typeof useGetLoanQuery>;
export type GetLoanLazyQueryHookResult = ReturnType<typeof useGetLoanLazyQuery>;
export type GetLoanSuspenseQueryHookResult = ReturnType<typeof useGetLoanSuspenseQuery>;
export type GetLoanQueryResult = Apollo.QueryResult<GetLoanQuery, GetLoanQueryVariables>;
export const GetPrimeRateAsOfDocument = /*#__PURE__*/ gql`
  query getPrimeRateAsOf($asOfDate: Date!) {
    getPrimeRateAsOf(asOfDate: $asOfDate) {
      ...BasePrimeRateFragment
    }
  }
  ${BasePrimeRateFragmentFragmentDoc}
`;

/**
 * __useGetPrimeRateAsOfQuery__
 *
 * To run a query within a React component, call `useGetPrimeRateAsOfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrimeRateAsOfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrimeRateAsOfQuery({
 *   variables: {
 *      asOfDate: // value for 'asOfDate'
 *   },
 * });
 */
export function useGetPrimeRateAsOfQuery(
  baseOptions: Apollo.QueryHookOptions<GetPrimeRateAsOfQuery, GetPrimeRateAsOfQueryVariables> &
    ({ variables: GetPrimeRateAsOfQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPrimeRateAsOfQuery, GetPrimeRateAsOfQueryVariables>(GetPrimeRateAsOfDocument, options);
}
export function useGetPrimeRateAsOfLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPrimeRateAsOfQuery, GetPrimeRateAsOfQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPrimeRateAsOfQuery, GetPrimeRateAsOfQueryVariables>(GetPrimeRateAsOfDocument, options);
}
// @ts-ignore
export function useGetPrimeRateAsOfSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetPrimeRateAsOfQuery, GetPrimeRateAsOfQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPrimeRateAsOfQuery, GetPrimeRateAsOfQueryVariables>;
export function useGetPrimeRateAsOfSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPrimeRateAsOfQuery, GetPrimeRateAsOfQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetPrimeRateAsOfQuery | undefined, GetPrimeRateAsOfQueryVariables>;
export function useGetPrimeRateAsOfSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPrimeRateAsOfQuery, GetPrimeRateAsOfQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPrimeRateAsOfQuery, GetPrimeRateAsOfQueryVariables>(
    GetPrimeRateAsOfDocument,
    options,
  );
}
export type GetPrimeRateAsOfQueryHookResult = ReturnType<typeof useGetPrimeRateAsOfQuery>;
export type GetPrimeRateAsOfLazyQueryHookResult = ReturnType<typeof useGetPrimeRateAsOfLazyQuery>;
export type GetPrimeRateAsOfSuspenseQueryHookResult = ReturnType<typeof useGetPrimeRateAsOfSuspenseQuery>;
export type GetPrimeRateAsOfQueryResult = Apollo.QueryResult<GetPrimeRateAsOfQuery, GetPrimeRateAsOfQueryVariables>;
export const GetStatementStudioAuthoringContextDocument = /*#__PURE__*/ gql`
  query getStatementStudioAuthoringContext($loanId: ID!) {
    loan(id: $loanId) {
      id
      statementDay
      paymentDueDay
      program {
        id
        lateFeeGracePeriodDays
      }
    }
    loanStatements(loanId: $loanId) {
      id
      billingPeriodStart
      billingPeriodEnd
      dueDate
      dueDateProcessedAt
      lateFeeEligibleOn
      lateFeeProcessedAt
    }
  }
`;

/**
 * __useGetStatementStudioAuthoringContextQuery__
 *
 * To run a query within a React component, call `useGetStatementStudioAuthoringContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatementStudioAuthoringContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatementStudioAuthoringContextQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetStatementStudioAuthoringContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStatementStudioAuthoringContextQuery,
    GetStatementStudioAuthoringContextQueryVariables
  > &
    ({ variables: GetStatementStudioAuthoringContextQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStatementStudioAuthoringContextQuery, GetStatementStudioAuthoringContextQueryVariables>(
    GetStatementStudioAuthoringContextDocument,
    options,
  );
}
export function useGetStatementStudioAuthoringContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStatementStudioAuthoringContextQuery,
    GetStatementStudioAuthoringContextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetStatementStudioAuthoringContextQuery, GetStatementStudioAuthoringContextQueryVariables>(
    GetStatementStudioAuthoringContextDocument,
    options,
  );
}
// @ts-ignore
export function useGetStatementStudioAuthoringContextSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetStatementStudioAuthoringContextQuery,
    GetStatementStudioAuthoringContextQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetStatementStudioAuthoringContextQuery,
  GetStatementStudioAuthoringContextQueryVariables
>;
export function useGetStatementStudioAuthoringContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetStatementStudioAuthoringContextQuery,
        GetStatementStudioAuthoringContextQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetStatementStudioAuthoringContextQuery | undefined,
  GetStatementStudioAuthoringContextQueryVariables
>;
export function useGetStatementStudioAuthoringContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetStatementStudioAuthoringContextQuery,
        GetStatementStudioAuthoringContextQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetStatementStudioAuthoringContextQuery,
    GetStatementStudioAuthoringContextQueryVariables
  >(GetStatementStudioAuthoringContextDocument, options);
}
export type GetStatementStudioAuthoringContextQueryHookResult = ReturnType<
  typeof useGetStatementStudioAuthoringContextQuery
>;
export type GetStatementStudioAuthoringContextLazyQueryHookResult = ReturnType<
  typeof useGetStatementStudioAuthoringContextLazyQuery
>;
export type GetStatementStudioAuthoringContextSuspenseQueryHookResult = ReturnType<
  typeof useGetStatementStudioAuthoringContextSuspenseQuery
>;
export type GetStatementStudioAuthoringContextQueryResult = Apollo.QueryResult<
  GetStatementStudioAuthoringContextQuery,
  GetStatementStudioAuthoringContextQueryVariables
>;
export const GetStatementStudioDetailsDocument = /*#__PURE__*/ gql`
  query getStatementStudioDetails($userId: ID!, $loanId: ID!) {
    user(id: $userId) {
      ...UserFragment
      userEvents {
        ...UserEventFragment
      }
    }
    loan(id: $loanId) {
      id
      loanEvents {
        ...LoanEventFragment
      }
      cardEvents {
        ...CardEventFragment
      }
    }
    creditUtilization(loanId: $loanId) {
      ...BaseCreditUtilization
    }
    ledgerBalances(loanId: $loanId) {
      twispLoanAccount {
        ...BaseLedgerBalance
      }
      twispFeesAccount {
        ...BaseLedgerBalance
      }
      twispInterestAccount {
        ...BaseLedgerBalance
      }
      twispRepaymentAccount {
        ...BaseLedgerBalance
      }
      twispCreditLineAccount {
        ...BaseLedgerBalance
      }
      twispCreditLineFeesAccount {
        ...BaseLedgerBalance
      }
      twispCreditLineInterestAccount {
        ...BaseLedgerBalance
      }
      twispCardAccount {
        ...BaseLedgerBalance
      }
      twispCardFeesAccount {
        ...BaseLedgerBalance
      }
      twispCardInterestAccount {
        ...BaseLedgerBalance
      }
    }
    loanStatements(loanId: $loanId) {
      ...StatementFragment
    }
    loanTransactions(loanId: $loanId) {
      transactions {
        ...TransactionDetails
      }
      balance {
        ...BaseBalanceDetails
      }
      balanceRaw {
        ...BaseBalanceRawDetails
      }
    }
  }
  ${UserFragmentFragmentDoc}
  ${UserEventFragmentFragmentDoc}
  ${LoanEventFragmentFragmentDoc}
  ${CardEventFragmentFragmentDoc}
  ${BaseCreditUtilizationFragmentDoc}
  ${BaseLedgerBalanceFragmentDoc}
  ${StatementFragmentFragmentDoc}
  ${TransactionDetailsFragmentDoc}
  ${BaseBalanceDetailsFragmentDoc}
  ${BaseBalanceRawDetailsFragmentDoc}
`;

/**
 * __useGetStatementStudioDetailsQuery__
 *
 * To run a query within a React component, call `useGetStatementStudioDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatementStudioDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatementStudioDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetStatementStudioDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<GetStatementStudioDetailsQuery, GetStatementStudioDetailsQueryVariables> &
    ({ variables: GetStatementStudioDetailsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStatementStudioDetailsQuery, GetStatementStudioDetailsQueryVariables>(
    GetStatementStudioDetailsDocument,
    options,
  );
}
export function useGetStatementStudioDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetStatementStudioDetailsQuery, GetStatementStudioDetailsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetStatementStudioDetailsQuery, GetStatementStudioDetailsQueryVariables>(
    GetStatementStudioDetailsDocument,
    options,
  );
}
// @ts-ignore
export function useGetStatementStudioDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetStatementStudioDetailsQuery,
    GetStatementStudioDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetStatementStudioDetailsQuery, GetStatementStudioDetailsQueryVariables>;
export function useGetStatementStudioDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetStatementStudioDetailsQuery, GetStatementStudioDetailsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetStatementStudioDetailsQuery | undefined, GetStatementStudioDetailsQueryVariables>;
export function useGetStatementStudioDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetStatementStudioDetailsQuery, GetStatementStudioDetailsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetStatementStudioDetailsQuery, GetStatementStudioDetailsQueryVariables>(
    GetStatementStudioDetailsDocument,
    options,
  );
}
export type GetStatementStudioDetailsQueryHookResult = ReturnType<typeof useGetStatementStudioDetailsQuery>;
export type GetStatementStudioDetailsLazyQueryHookResult = ReturnType<typeof useGetStatementStudioDetailsLazyQuery>;
export type GetStatementStudioDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetStatementStudioDetailsSuspenseQuery
>;
export type GetStatementStudioDetailsQueryResult = Apollo.QueryResult<
  GetStatementStudioDetailsQuery,
  GetStatementStudioDetailsQueryVariables
>;
export const GetUserDocument = /*#__PURE__*/ gql`
  query getUser($userId: ID!) {
    user(id: $userId) {
      ...UserFragment
    }
  }
  ${UserFragmentFragmentDoc}
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> &
    ({ variables: GetUserQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
// @ts-ignore
export function useGetUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserQuery, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUserQuery | undefined, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetStatementDocument = /*#__PURE__*/ gql`
  query getStatement($id: ID!) {
    statement(id: $id) {
      ...StatementFragment
    }
  }
  ${StatementFragmentFragmentDoc}
`;

/**
 * __useGetStatementQuery__
 *
 * To run a query within a React component, call `useGetStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStatementQuery(
  baseOptions: Apollo.QueryHookOptions<GetStatementQuery, GetStatementQueryVariables> &
    ({ variables: GetStatementQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStatementQuery, GetStatementQueryVariables>(GetStatementDocument, options);
}
export function useGetStatementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetStatementQuery, GetStatementQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetStatementQuery, GetStatementQueryVariables>(GetStatementDocument, options);
}
// @ts-ignore
export function useGetStatementSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetStatementQuery, GetStatementQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetStatementQuery, GetStatementQueryVariables>;
export function useGetStatementSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatementQuery, GetStatementQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetStatementQuery | undefined, GetStatementQueryVariables>;
export function useGetStatementSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStatementQuery, GetStatementQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetStatementQuery, GetStatementQueryVariables>(GetStatementDocument, options);
}
export type GetStatementQueryHookResult = ReturnType<typeof useGetStatementQuery>;
export type GetStatementLazyQueryHookResult = ReturnType<typeof useGetStatementLazyQuery>;
export type GetStatementSuspenseQueryHookResult = ReturnType<typeof useGetStatementSuspenseQuery>;
export type GetStatementQueryResult = Apollo.QueryResult<GetStatementQuery, GetStatementQueryVariables>;
export const ListAchRequestsDocument = /*#__PURE__*/ gql`
  query listAchRequests(
    $insertedAtSortDirection: SortDirection
    $statusSortDirection: SortDirection
    $statusSelections: [AchRequestStatus]
    $achTypeSortDirection: SortDirection
    $achTypeSelections: [AchRequestType]
    $settled: Boolean
    $paginationDetailsOnly: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    listAchRequests(
      insertedAtSortDirection: $insertedAtSortDirection
      statusSortDirection: $statusSortDirection
      statusSelections: $statusSelections
      achTypeSortDirection: $achTypeSortDirection
      achTypeSelections: $achTypeSelections
      settled: $settled
      paginationDetailsOnly: $paginationDetailsOnly
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      achRequests {
        ...AchRequestFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${AchRequestFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useListAchRequestsQuery__
 *
 * To run a query within a React component, call `useListAchRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAchRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAchRequestsQuery({
 *   variables: {
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      statusSortDirection: // value for 'statusSortDirection'
 *      statusSelections: // value for 'statusSelections'
 *      achTypeSortDirection: // value for 'achTypeSortDirection'
 *      achTypeSelections: // value for 'achTypeSelections'
 *      settled: // value for 'settled'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useListAchRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListAchRequestsQuery, ListAchRequestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAchRequestsQuery, ListAchRequestsQueryVariables>(ListAchRequestsDocument, options);
}
export function useListAchRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListAchRequestsQuery, ListAchRequestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListAchRequestsQuery, ListAchRequestsQueryVariables>(ListAchRequestsDocument, options);
}
// @ts-ignore
export function useListAchRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListAchRequestsQuery, ListAchRequestsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListAchRequestsQuery, ListAchRequestsQueryVariables>;
export function useListAchRequestsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAchRequestsQuery, ListAchRequestsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListAchRequestsQuery | undefined, ListAchRequestsQueryVariables>;
export function useListAchRequestsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAchRequestsQuery, ListAchRequestsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListAchRequestsQuery, ListAchRequestsQueryVariables>(ListAchRequestsDocument, options);
}
export type ListAchRequestsQueryHookResult = ReturnType<typeof useListAchRequestsQuery>;
export type ListAchRequestsLazyQueryHookResult = ReturnType<typeof useListAchRequestsLazyQuery>;
export type ListAchRequestsSuspenseQueryHookResult = ReturnType<typeof useListAchRequestsSuspenseQuery>;
export type ListAchRequestsQueryResult = Apollo.QueryResult<ListAchRequestsQuery, ListAchRequestsQueryVariables>;
export const ListAdminActionRecordsDocument = /*#__PURE__*/ gql`
  query listAdminActionRecords(
    $idSortDirection: SortDirection
    $idSearch: String
    $actionSortDirection: SortDirection
    $actionSearch: String
    $insertedAtSortDirection: SortDirection
    $paginationDetailsOnly: Boolean
    $actorId: ID
    $userId: ID
    $actorFirstNameSearch: String
    $actorLastNameSearch: String
    $actorEmailSearch: String
    $userFirstNameSearch: String
    $userLastNameSearch: String
    $userEmailSearch: String
    $to: Date
    $from: Date
    $fullResults: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    listAdminActionRecords(
      idSortDirection: $idSortDirection
      idSearch: $idSearch
      actionSortDirection: $actionSortDirection
      actionSearch: $actionSearch
      insertedAtSortDirection: $insertedAtSortDirection
      paginationDetailsOnly: $paginationDetailsOnly
      actorId: $actorId
      userId: $userId
      actorFirstNameSearch: $actorFirstNameSearch
      actorLastNameSearch: $actorLastNameSearch
      actorEmailSearch: $actorEmailSearch
      userFirstNameSearch: $userFirstNameSearch
      userLastNameSearch: $userLastNameSearch
      userEmailSearch: $userEmailSearch
      to: $to
      from: $from
      fullResults: $fullResults
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      adminActionRecords {
        ...AdminActionRecordFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${AdminActionRecordFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useListAdminActionRecordsQuery__
 *
 * To run a query within a React component, call `useListAdminActionRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminActionRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminActionRecordsQuery({
 *   variables: {
 *      idSortDirection: // value for 'idSortDirection'
 *      idSearch: // value for 'idSearch'
 *      actionSortDirection: // value for 'actionSortDirection'
 *      actionSearch: // value for 'actionSearch'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      actorId: // value for 'actorId'
 *      userId: // value for 'userId'
 *      actorFirstNameSearch: // value for 'actorFirstNameSearch'
 *      actorLastNameSearch: // value for 'actorLastNameSearch'
 *      actorEmailSearch: // value for 'actorEmailSearch'
 *      userFirstNameSearch: // value for 'userFirstNameSearch'
 *      userLastNameSearch: // value for 'userLastNameSearch'
 *      userEmailSearch: // value for 'userEmailSearch'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      fullResults: // value for 'fullResults'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useListAdminActionRecordsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListAdminActionRecordsQuery, ListAdminActionRecordsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAdminActionRecordsQuery, ListAdminActionRecordsQueryVariables>(
    ListAdminActionRecordsDocument,
    options,
  );
}
export function useListAdminActionRecordsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListAdminActionRecordsQuery, ListAdminActionRecordsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListAdminActionRecordsQuery, ListAdminActionRecordsQueryVariables>(
    ListAdminActionRecordsDocument,
    options,
  );
}
// @ts-ignore
export function useListAdminActionRecordsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListAdminActionRecordsQuery, ListAdminActionRecordsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListAdminActionRecordsQuery, ListAdminActionRecordsQueryVariables>;
export function useListAdminActionRecordsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListAdminActionRecordsQuery, ListAdminActionRecordsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListAdminActionRecordsQuery | undefined, ListAdminActionRecordsQueryVariables>;
export function useListAdminActionRecordsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListAdminActionRecordsQuery, ListAdminActionRecordsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListAdminActionRecordsQuery, ListAdminActionRecordsQueryVariables>(
    ListAdminActionRecordsDocument,
    options,
  );
}
export type ListAdminActionRecordsQueryHookResult = ReturnType<typeof useListAdminActionRecordsQuery>;
export type ListAdminActionRecordsLazyQueryHookResult = ReturnType<typeof useListAdminActionRecordsLazyQuery>;
export type ListAdminActionRecordsSuspenseQueryHookResult = ReturnType<typeof useListAdminActionRecordsSuspenseQuery>;
export type ListAdminActionRecordsQueryResult = Apollo.QueryResult<
  ListAdminActionRecordsQuery,
  ListAdminActionRecordsQueryVariables
>;
export const ListCardsDocument = /*#__PURE__*/ gql`
  query listCards(
    $idSortDirection: SortDirection
    $idSearch: String
    $referenceIdSearch: String
    $insertedAtSortDirection: SortDirection
    $statusSortDirection: SortDirection
    $statusSelections: [CardStatus]
    $referenceIdSortDirection: SortDirection
    $active: Boolean
    $userFirstNameSortDirection: SortDirection
    $userFirstNameSearch: String
    $userLastNameSortDirection: SortDirection
    $userLastNameSearch: String
    $userEmailSortDirection: SortDirection
    $userEmailSearch: String
    $userIsFriendsAndFam: Boolean
    $paginationDetailsOnly: Boolean
    $to: Date
    $from: Date
    $fullResults: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    listCards(
      idSortDirection: $idSortDirection
      idSearch: $idSearch
      referenceIdSearch: $referenceIdSearch
      insertedAtSortDirection: $insertedAtSortDirection
      statusSortDirection: $statusSortDirection
      statusSelections: $statusSelections
      referenceIdSortDirection: $referenceIdSortDirection
      active: $active
      userFirstNameSortDirection: $userFirstNameSortDirection
      userFirstNameSearch: $userFirstNameSearch
      userLastNameSortDirection: $userLastNameSortDirection
      userLastNameSearch: $userLastNameSearch
      userEmailSortDirection: $userEmailSortDirection
      userEmailSearch: $userEmailSearch
      userIsFriendsAndFam: $userIsFriendsAndFam
      paginationDetailsOnly: $paginationDetailsOnly
      to: $to
      from: $from
      fullResults: $fullResults
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      cards {
        ...CardFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${CardFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useListCardsQuery__
 *
 * To run a query within a React component, call `useListCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCardsQuery({
 *   variables: {
 *      idSortDirection: // value for 'idSortDirection'
 *      idSearch: // value for 'idSearch'
 *      referenceIdSearch: // value for 'referenceIdSearch'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      statusSortDirection: // value for 'statusSortDirection'
 *      statusSelections: // value for 'statusSelections'
 *      referenceIdSortDirection: // value for 'referenceIdSortDirection'
 *      active: // value for 'active'
 *      userFirstNameSortDirection: // value for 'userFirstNameSortDirection'
 *      userFirstNameSearch: // value for 'userFirstNameSearch'
 *      userLastNameSortDirection: // value for 'userLastNameSortDirection'
 *      userLastNameSearch: // value for 'userLastNameSearch'
 *      userEmailSortDirection: // value for 'userEmailSortDirection'
 *      userEmailSearch: // value for 'userEmailSearch'
 *      userIsFriendsAndFam: // value for 'userIsFriendsAndFam'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      fullResults: // value for 'fullResults'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useListCardsQuery(baseOptions?: Apollo.QueryHookOptions<ListCardsQuery, ListCardsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCardsQuery, ListCardsQueryVariables>(ListCardsDocument, options);
}
export function useListCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCardsQuery, ListCardsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCardsQuery, ListCardsQueryVariables>(ListCardsDocument, options);
}
// @ts-ignore
export function useListCardsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListCardsQuery, ListCardsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListCardsQuery, ListCardsQueryVariables>;
export function useListCardsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCardsQuery, ListCardsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListCardsQuery | undefined, ListCardsQueryVariables>;
export function useListCardsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCardsQuery, ListCardsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListCardsQuery, ListCardsQueryVariables>(ListCardsDocument, options);
}
export type ListCardsQueryHookResult = ReturnType<typeof useListCardsQuery>;
export type ListCardsLazyQueryHookResult = ReturnType<typeof useListCardsLazyQuery>;
export type ListCardsSuspenseQueryHookResult = ReturnType<typeof useListCardsSuspenseQuery>;
export type ListCardsQueryResult = Apollo.QueryResult<ListCardsQuery, ListCardsQueryVariables>;
export const ListDevicesDocument = /*#__PURE__*/ gql`
  query listDevices(
    $pageNumber: Int
    $resultsPerPage: Int
    $fullResults: Boolean
    $deviceTypeSelections: [DeviceType]
    $deviceTypeSortDirection: SortDirection
    $tokenSearch: String
    $insertedAtSortDirection: SortDirection
    $userIdSearch: String
    $userIdSortDirection: SortDirection
    $userFirstNameSearch: String
    $userFirstNameSortDirection: SortDirection
    $userLastNameSearch: String
    $userLastNameSortDirection: SortDirection
    $userEmailSearch: String
    $userEmailSortDirection: SortDirection
    $paginationDetailsOnly: Boolean
  ) {
    listDevices(
      pageNumber: $pageNumber
      resultsPerPage: $resultsPerPage
      fullResults: $fullResults
      deviceTypeSelections: $deviceTypeSelections
      deviceTypeSortDirection: $deviceTypeSortDirection
      tokenSearch: $tokenSearch
      insertedAtSortDirection: $insertedAtSortDirection
      userIdSearch: $userIdSearch
      userIdSortDirection: $userIdSortDirection
      userFirstNameSearch: $userFirstNameSearch
      userFirstNameSortDirection: $userFirstNameSortDirection
      userLastNameSearch: $userLastNameSearch
      userLastNameSortDirection: $userLastNameSortDirection
      userEmailSearch: $userEmailSearch
      userEmailSortDirection: $userEmailSortDirection
      paginationDetailsOnly: $paginationDetailsOnly
    ) {
      devices {
        id
        token
        deviceType
        deviceId
        userId
        lastUsedAt
        createdAt
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useListDevicesQuery__
 *
 * To run a query within a React component, call `useListDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDevicesQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      fullResults: // value for 'fullResults'
 *      deviceTypeSelections: // value for 'deviceTypeSelections'
 *      deviceTypeSortDirection: // value for 'deviceTypeSortDirection'
 *      tokenSearch: // value for 'tokenSearch'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      userIdSearch: // value for 'userIdSearch'
 *      userIdSortDirection: // value for 'userIdSortDirection'
 *      userFirstNameSearch: // value for 'userFirstNameSearch'
 *      userFirstNameSortDirection: // value for 'userFirstNameSortDirection'
 *      userLastNameSearch: // value for 'userLastNameSearch'
 *      userLastNameSortDirection: // value for 'userLastNameSortDirection'
 *      userEmailSearch: // value for 'userEmailSearch'
 *      userEmailSortDirection: // value for 'userEmailSortDirection'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *   },
 * });
 */
export function useListDevicesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListDevicesQuery, ListDevicesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDevicesQuery, ListDevicesQueryVariables>(ListDevicesDocument, options);
}
export function useListDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListDevicesQuery, ListDevicesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDevicesQuery, ListDevicesQueryVariables>(ListDevicesDocument, options);
}
// @ts-ignore
export function useListDevicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListDevicesQuery, ListDevicesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDevicesQuery, ListDevicesQueryVariables>;
export function useListDevicesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDevicesQuery, ListDevicesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDevicesQuery | undefined, ListDevicesQueryVariables>;
export function useListDevicesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDevicesQuery, ListDevicesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListDevicesQuery, ListDevicesQueryVariables>(ListDevicesDocument, options);
}
export type ListDevicesQueryHookResult = ReturnType<typeof useListDevicesQuery>;
export type ListDevicesLazyQueryHookResult = ReturnType<typeof useListDevicesLazyQuery>;
export type ListDevicesSuspenseQueryHookResult = ReturnType<typeof useListDevicesSuspenseQuery>;
export type ListDevicesQueryResult = Apollo.QueryResult<ListDevicesQuery, ListDevicesQueryVariables>;
export const ListDisputesDocument = /*#__PURE__*/ gql`
  query listDisputes(
    $insertedAtSortDirection: SortDirection
    $statusSortDirection: SortDirection
    $statusSelections: [DisputeStatus]
    $paginationDetailsOnly: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    listDisputes(
      insertedAtSortDirection: $insertedAtSortDirection
      statusSortDirection: $statusSortDirection
      statusSelections: $statusSelections
      paginationDetailsOnly: $paginationDetailsOnly
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      disputes {
        ...CardDisputeFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${CardDisputeFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useListDisputesQuery__
 *
 * To run a query within a React component, call `useListDisputesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDisputesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDisputesQuery({
 *   variables: {
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      statusSortDirection: // value for 'statusSortDirection'
 *      statusSelections: // value for 'statusSelections'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useListDisputesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListDisputesQuery, ListDisputesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDisputesQuery, ListDisputesQueryVariables>(ListDisputesDocument, options);
}
export function useListDisputesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListDisputesQuery, ListDisputesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDisputesQuery, ListDisputesQueryVariables>(ListDisputesDocument, options);
}
// @ts-ignore
export function useListDisputesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListDisputesQuery, ListDisputesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDisputesQuery, ListDisputesQueryVariables>;
export function useListDisputesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDisputesQuery, ListDisputesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDisputesQuery | undefined, ListDisputesQueryVariables>;
export function useListDisputesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDisputesQuery, ListDisputesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListDisputesQuery, ListDisputesQueryVariables>(ListDisputesDocument, options);
}
export type ListDisputesQueryHookResult = ReturnType<typeof useListDisputesQuery>;
export type ListDisputesLazyQueryHookResult = ReturnType<typeof useListDisputesLazyQuery>;
export type ListDisputesSuspenseQueryHookResult = ReturnType<typeof useListDisputesSuspenseQuery>;
export type ListDisputesQueryResult = Apollo.QueryResult<ListDisputesQuery, ListDisputesQueryVariables>;
export const ListLoansDocument = /*#__PURE__*/ gql`
  query listLoans(
    $idSortDirection: SortDirection
    $idSearch: String
    $partnerAccountNumberSortDirection: SortDirection
    $partnerAccountNumberSearch: String
    $hasPromo: Boolean
    $statusSortDirection: SortDirection
    $statusSelections: [LoanStatus]
    $programIdSortDirection: SortDirection
    $programIdSearch: String
    $insertedAtSortDirection: SortDirection
    $paginationDetailsOnly: Boolean
    $from: Date
    $to: Date
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    listLoans(
      idSortDirection: $idSortDirection
      idSearch: $idSearch
      partnerAccountNumberSortDirection: $partnerAccountNumberSortDirection
      partnerAccountNumberSearch: $partnerAccountNumberSearch
      hasPromo: $hasPromo
      statusSortDirection: $statusSortDirection
      statusSelections: $statusSelections
      programIdSortDirection: $programIdSortDirection
      programIdSearch: $programIdSearch
      insertedAtSortDirection: $insertedAtSortDirection
      paginationDetailsOnly: $paginationDetailsOnly
      from: $from
      to: $to
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      loans {
        ...BasicLoanFragment
        program {
          id
          name
        }
        users {
          id
          firstName
          lastName
        }
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${BasicLoanFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useListLoansQuery__
 *
 * To run a query within a React component, call `useListLoansQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLoansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLoansQuery({
 *   variables: {
 *      idSortDirection: // value for 'idSortDirection'
 *      idSearch: // value for 'idSearch'
 *      partnerAccountNumberSortDirection: // value for 'partnerAccountNumberSortDirection'
 *      partnerAccountNumberSearch: // value for 'partnerAccountNumberSearch'
 *      hasPromo: // value for 'hasPromo'
 *      statusSortDirection: // value for 'statusSortDirection'
 *      statusSelections: // value for 'statusSelections'
 *      programIdSortDirection: // value for 'programIdSortDirection'
 *      programIdSearch: // value for 'programIdSearch'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useListLoansQuery(baseOptions?: Apollo.QueryHookOptions<ListLoansQuery, ListLoansQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListLoansQuery, ListLoansQueryVariables>(ListLoansDocument, options);
}
export function useListLoansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListLoansQuery, ListLoansQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListLoansQuery, ListLoansQueryVariables>(ListLoansDocument, options);
}
// @ts-ignore
export function useListLoansSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListLoansQuery, ListLoansQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListLoansQuery, ListLoansQueryVariables>;
export function useListLoansSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLoansQuery, ListLoansQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListLoansQuery | undefined, ListLoansQueryVariables>;
export function useListLoansSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLoansQuery, ListLoansQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListLoansQuery, ListLoansQueryVariables>(ListLoansDocument, options);
}
export type ListLoansQueryHookResult = ReturnType<typeof useListLoansQuery>;
export type ListLoansLazyQueryHookResult = ReturnType<typeof useListLoansLazyQuery>;
export type ListLoansSuspenseQueryHookResult = ReturnType<typeof useListLoansSuspenseQuery>;
export type ListLoansQueryResult = Apollo.QueryResult<ListLoansQuery, ListLoansQueryVariables>;
export const ListProgramsDocument = /*#__PURE__*/ gql`
  query listPrograms(
    $idSortDirection: SortDirection
    $idSearch: String
    $nameSortDirection: SortDirection
    $nameSearch: String
    $active: Boolean
    $insertedAtSortDirection: SortDirection
    $paginationDetailsOnly: Boolean
    $fullResults: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    listPrograms(
      idSortDirection: $idSortDirection
      idSearch: $idSearch
      nameSortDirection: $nameSortDirection
      nameSearch: $nameSearch
      active: $active
      insertedAtSortDirection: $insertedAtSortDirection
      paginationDetailsOnly: $paginationDetailsOnly
      fullResults: $fullResults
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      programs {
        ...BaseProgramFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${BaseProgramFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useListProgramsQuery__
 *
 * To run a query within a React component, call `useListProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProgramsQuery({
 *   variables: {
 *      idSortDirection: // value for 'idSortDirection'
 *      idSearch: // value for 'idSearch'
 *      nameSortDirection: // value for 'nameSortDirection'
 *      nameSearch: // value for 'nameSearch'
 *      active: // value for 'active'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      fullResults: // value for 'fullResults'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useListProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListProgramsQuery, ListProgramsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListProgramsQuery, ListProgramsQueryVariables>(ListProgramsDocument, options);
}
export function useListProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListProgramsQuery, ListProgramsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListProgramsQuery, ListProgramsQueryVariables>(ListProgramsDocument, options);
}
// @ts-ignore
export function useListProgramsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListProgramsQuery, ListProgramsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListProgramsQuery, ListProgramsQueryVariables>;
export function useListProgramsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProgramsQuery, ListProgramsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListProgramsQuery | undefined, ListProgramsQueryVariables>;
export function useListProgramsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProgramsQuery, ListProgramsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListProgramsQuery, ListProgramsQueryVariables>(ListProgramsDocument, options);
}
export type ListProgramsQueryHookResult = ReturnType<typeof useListProgramsQuery>;
export type ListProgramsLazyQueryHookResult = ReturnType<typeof useListProgramsLazyQuery>;
export type ListProgramsSuspenseQueryHookResult = ReturnType<typeof useListProgramsSuspenseQuery>;
export type ListProgramsQueryResult = Apollo.QueryResult<ListProgramsQuery, ListProgramsQueryVariables>;
export const ListStatementsDocument = /*#__PURE__*/ gql`
  query listStatements(
    $insertedAtSortDirection: SortDirection
    $creditLimitSortDirection: SortDirection
    $idSortDirection: SortDirection
    $idSearch: String
    $loanIdSortDirection: SortDirection
    $loanIdSearch: String
    $paginationDetailsOnly: Boolean
    $loanId: ID
    $to: Date
    $from: Date
    $fullResults: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    listStatements(
      insertedAtSortDirection: $insertedAtSortDirection
      creditLimitSortDirection: $creditLimitSortDirection
      idSortDirection: $idSortDirection
      idSearch: $idSearch
      loanIdSortDirection: $loanIdSortDirection
      loanIdSearch: $loanIdSearch
      paginationDetailsOnly: $paginationDetailsOnly
      loanId: $loanId
      to: $to
      from: $from
      fullResults: $fullResults
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      statements {
        ...StatementFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${StatementFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useListStatementsQuery__
 *
 * To run a query within a React component, call `useListStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStatementsQuery({
 *   variables: {
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      creditLimitSortDirection: // value for 'creditLimitSortDirection'
 *      idSortDirection: // value for 'idSortDirection'
 *      idSearch: // value for 'idSearch'
 *      loanIdSortDirection: // value for 'loanIdSortDirection'
 *      loanIdSearch: // value for 'loanIdSearch'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      loanId: // value for 'loanId'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      fullResults: // value for 'fullResults'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useListStatementsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListStatementsQuery, ListStatementsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListStatementsQuery, ListStatementsQueryVariables>(ListStatementsDocument, options);
}
export function useListStatementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListStatementsQuery, ListStatementsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListStatementsQuery, ListStatementsQueryVariables>(ListStatementsDocument, options);
}
// @ts-ignore
export function useListStatementsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListStatementsQuery, ListStatementsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListStatementsQuery, ListStatementsQueryVariables>;
export function useListStatementsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListStatementsQuery, ListStatementsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListStatementsQuery | undefined, ListStatementsQueryVariables>;
export function useListStatementsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListStatementsQuery, ListStatementsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListStatementsQuery, ListStatementsQueryVariables>(ListStatementsDocument, options);
}
export type ListStatementsQueryHookResult = ReturnType<typeof useListStatementsQuery>;
export type ListStatementsLazyQueryHookResult = ReturnType<typeof useListStatementsLazyQuery>;
export type ListStatementsSuspenseQueryHookResult = ReturnType<typeof useListStatementsSuspenseQuery>;
export type ListStatementsQueryResult = Apollo.QueryResult<ListStatementsQuery, ListStatementsQueryVariables>;
export const ListUsersDocument = /*#__PURE__*/ gql`
  query listUsers(
    $idSortDirection: SortDirection
    $idSearch: String
    $firstNameSortDirection: SortDirection
    $firstNameSearch: String
    $lastNameSortDirection: SortDirection
    $lastNameSearch: String
    $phoneSortDirection: SortDirection
    $phoneSearch: String
    $dobSortDirection: SortDirection
    $dobSearch: String
    $isFriendsAndFam: Boolean
    $insertedAtSortDirection: SortDirection
    $roleSortDirection: SortDirection
    $roleSelections: [UserRole]
    $adminProgramIdSortDirection: SortDirection
    $adminProgramIdSearch: String
    $paginationDetailsOnly: Boolean
    $to: Date
    $from: Date
    $fullResults: Boolean
    $resultsPerPage: Int
    $pageNumber: Int
  ) {
    listUsers(
      idSortDirection: $idSortDirection
      idSearch: $idSearch
      firstNameSortDirection: $firstNameSortDirection
      firstNameSearch: $firstNameSearch
      lastNameSortDirection: $lastNameSortDirection
      lastNameSearch: $lastNameSearch
      phoneSortDirection: $phoneSortDirection
      phoneSearch: $phoneSearch
      dobSortDirection: $dobSortDirection
      dobSearch: $dobSearch
      isFriendsAndFam: $isFriendsAndFam
      insertedAtSortDirection: $insertedAtSortDirection
      roleSortDirection: $roleSortDirection
      roleSelections: $roleSelections
      adminProgramIdSortDirection: $adminProgramIdSortDirection
      adminProgramIdSearch: $adminProgramIdSearch
      paginationDetailsOnly: $paginationDetailsOnly
      to: $to
      from: $from
      fullResults: $fullResults
      resultsPerPage: $resultsPerPage
      pageNumber: $pageNumber
    ) {
      users {
        ...UserFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${UserFragmentFragmentDoc}
  ${PaginationFragmentFragmentDoc}
`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      idSortDirection: // value for 'idSortDirection'
 *      idSearch: // value for 'idSearch'
 *      firstNameSortDirection: // value for 'firstNameSortDirection'
 *      firstNameSearch: // value for 'firstNameSearch'
 *      lastNameSortDirection: // value for 'lastNameSortDirection'
 *      lastNameSearch: // value for 'lastNameSearch'
 *      phoneSortDirection: // value for 'phoneSortDirection'
 *      phoneSearch: // value for 'phoneSearch'
 *      dobSortDirection: // value for 'dobSortDirection'
 *      dobSearch: // value for 'dobSearch'
 *      isFriendsAndFam: // value for 'isFriendsAndFam'
 *      insertedAtSortDirection: // value for 'insertedAtSortDirection'
 *      roleSortDirection: // value for 'roleSortDirection'
 *      roleSelections: // value for 'roleSelections'
 *      adminProgramIdSortDirection: // value for 'adminProgramIdSortDirection'
 *      adminProgramIdSearch: // value for 'adminProgramIdSearch'
 *      paginationDetailsOnly: // value for 'paginationDetailsOnly'
 *      to: // value for 'to'
 *      from: // value for 'from'
 *      fullResults: // value for 'fullResults'
 *      resultsPerPage: // value for 'resultsPerPage'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions?: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
}
export function useListUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
}
// @ts-ignore
export function useListUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListUsersQuery, ListUsersQueryVariables>;
export function useListUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListUsersQuery | undefined, ListUsersQueryVariables>;
export function useListUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
}
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersSuspenseQueryHookResult = ReturnType<typeof useListUsersSuspenseQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const ListVelocityControlsDocument = /*#__PURE__*/ gql`
  query ListVelocityControls {
    listVelocityControls {
      ...VelocityControlFragment
    }
  }
  ${VelocityControlFragmentFragmentDoc}
`;

/**
 * __useListVelocityControlsQuery__
 *
 * To run a query within a React component, call `useListVelocityControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListVelocityControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListVelocityControlsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListVelocityControlsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListVelocityControlsQuery, ListVelocityControlsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListVelocityControlsQuery, ListVelocityControlsQueryVariables>(
    ListVelocityControlsDocument,
    options,
  );
}
export function useListVelocityControlsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListVelocityControlsQuery, ListVelocityControlsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListVelocityControlsQuery, ListVelocityControlsQueryVariables>(
    ListVelocityControlsDocument,
    options,
  );
}
// @ts-ignore
export function useListVelocityControlsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListVelocityControlsQuery, ListVelocityControlsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListVelocityControlsQuery, ListVelocityControlsQueryVariables>;
export function useListVelocityControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListVelocityControlsQuery, ListVelocityControlsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListVelocityControlsQuery | undefined, ListVelocityControlsQueryVariables>;
export function useListVelocityControlsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListVelocityControlsQuery, ListVelocityControlsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListVelocityControlsQuery, ListVelocityControlsQueryVariables>(
    ListVelocityControlsDocument,
    options,
  );
}
export type ListVelocityControlsQueryHookResult = ReturnType<typeof useListVelocityControlsQuery>;
export type ListVelocityControlsLazyQueryHookResult = ReturnType<typeof useListVelocityControlsLazyQuery>;
export type ListVelocityControlsSuspenseQueryHookResult = ReturnType<typeof useListVelocityControlsSuspenseQuery>;
export type ListVelocityControlsQueryResult = Apollo.QueryResult<
  ListVelocityControlsQuery,
  ListVelocityControlsQueryVariables
>;
export const LoansWithoutServicingDataDocument = /*#__PURE__*/ gql`
  query loansWithoutServicingData($programId: ID!) {
    loansWithoutServicingData(programId: $programId) {
      id
      partnerAccountNumber
      originationDate
      status
      members {
        userId
        firstName
        lastName
        joinedAt
      }
    }
  }
`;

/**
 * __useLoansWithoutServicingDataQuery__
 *
 * To run a query within a React component, call `useLoansWithoutServicingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoansWithoutServicingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoansWithoutServicingDataQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useLoansWithoutServicingDataQuery(
  baseOptions: Apollo.QueryHookOptions<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables> &
    ({ variables: LoansWithoutServicingDataQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>(
    LoansWithoutServicingDataDocument,
    options,
  );
}
export function useLoansWithoutServicingDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>(
    LoansWithoutServicingDataDocument,
    options,
  );
}
// @ts-ignore
export function useLoansWithoutServicingDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LoansWithoutServicingDataQuery,
    LoansWithoutServicingDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>;
export function useLoansWithoutServicingDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>,
): Apollo.UseSuspenseQueryResult<LoansWithoutServicingDataQuery | undefined, LoansWithoutServicingDataQueryVariables>;
export function useLoansWithoutServicingDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LoansWithoutServicingDataQuery, LoansWithoutServicingDataQueryVariables>(
    LoansWithoutServicingDataDocument,
    options,
  );
}
export type LoansWithoutServicingDataQueryHookResult = ReturnType<typeof useLoansWithoutServicingDataQuery>;
export type LoansWithoutServicingDataLazyQueryHookResult = ReturnType<typeof useLoansWithoutServicingDataLazyQuery>;
export type LoansWithoutServicingDataSuspenseQueryHookResult = ReturnType<
  typeof useLoansWithoutServicingDataSuspenseQuery
>;
export type LoansWithoutServicingDataQueryResult = Apollo.QueryResult<
  LoansWithoutServicingDataQuery,
  LoansWithoutServicingDataQueryVariables
>;
export const PendingDrawdownsDocument = /*#__PURE__*/ gql`
  query pendingDrawdowns {
    pendingDrawdowns {
      id
      status
      userId
      amountCents
      insertedAt
      plaidAccountId
      ledgerRefId
      loan {
        id
        partnerAccountNumber
        programId
      }
    }
  }
`;

/**
 * __usePendingDrawdownsQuery__
 *
 * To run a query within a React component, call `usePendingDrawdownsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingDrawdownsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingDrawdownsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingDrawdownsQuery(
  baseOptions?: Apollo.QueryHookOptions<PendingDrawdownsQuery, PendingDrawdownsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PendingDrawdownsQuery, PendingDrawdownsQueryVariables>(PendingDrawdownsDocument, options);
}
export function usePendingDrawdownsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PendingDrawdownsQuery, PendingDrawdownsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PendingDrawdownsQuery, PendingDrawdownsQueryVariables>(PendingDrawdownsDocument, options);
}
// @ts-ignore
export function usePendingDrawdownsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PendingDrawdownsQuery, PendingDrawdownsQueryVariables>,
): Apollo.UseSuspenseQueryResult<PendingDrawdownsQuery, PendingDrawdownsQueryVariables>;
export function usePendingDrawdownsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PendingDrawdownsQuery, PendingDrawdownsQueryVariables>,
): Apollo.UseSuspenseQueryResult<PendingDrawdownsQuery | undefined, PendingDrawdownsQueryVariables>;
export function usePendingDrawdownsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PendingDrawdownsQuery, PendingDrawdownsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PendingDrawdownsQuery, PendingDrawdownsQueryVariables>(
    PendingDrawdownsDocument,
    options,
  );
}
export type PendingDrawdownsQueryHookResult = ReturnType<typeof usePendingDrawdownsQuery>;
export type PendingDrawdownsLazyQueryHookResult = ReturnType<typeof usePendingDrawdownsLazyQuery>;
export type PendingDrawdownsSuspenseQueryHookResult = ReturnType<typeof usePendingDrawdownsSuspenseQuery>;
export type PendingDrawdownsQueryResult = Apollo.QueryResult<PendingDrawdownsQuery, PendingDrawdownsQueryVariables>;
export const SearchUsersDocument = /*#__PURE__*/ gql`
  query searchUsers($firstNameSearch: String, $lastNameSearch: String, $phoneSearch: String, $resultsPerPage: Int) {
    listUsers(
      firstNameSearch: $firstNameSearch
      lastNameSearch: $lastNameSearch
      phoneSearch: $phoneSearch
      resultsPerPage: $resultsPerPage
      pageNumber: 1
    ) {
      users {
        ...BasicUserFragment
      }
    }
  }
  ${BasicUserFragmentFragmentDoc}
`;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      firstNameSearch: // value for 'firstNameSearch'
 *      lastNameSearch: // value for 'lastNameSearch'
 *      phoneSearch: // value for 'phoneSearch'
 *      resultsPerPage: // value for 'resultsPerPage'
 *   },
 * });
 */
export function useSearchUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
}
export function useSearchUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
}
// @ts-ignore
export function useSearchUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchUsersQuery | undefined, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
}
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const LedgerBalancesDocument = /*#__PURE__*/ gql`
  query ledgerBalances($loanId: ID!) {
    ledgerBalances(loanId: $loanId) {
      twispLoanAccount {
        ...BaseLedgerBalance
      }
      twispFeesAccount {
        ...BaseLedgerBalance
      }
      twispInterestAccount {
        ...BaseLedgerBalance
      }
      twispRepaymentAccount {
        ...BaseLedgerBalance
      }
      twispCreditLineAccount {
        ...BaseLedgerBalance
      }
      twispCreditLineFeesAccount {
        ...BaseLedgerBalance
      }
      twispCreditLineInterestAccount {
        ...BaseLedgerBalance
      }
      twispCardAccount {
        ...BaseLedgerBalance
      }
      twispCardFeesAccount {
        ...BaseLedgerBalance
      }
      twispCardInterestAccount {
        ...BaseLedgerBalance
      }
    }
  }
  ${BaseLedgerBalanceFragmentDoc}
`;

/**
 * __useLedgerBalancesQuery__
 *
 * To run a query within a React component, call `useLedgerBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerBalancesQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useLedgerBalancesQuery(
  baseOptions: Apollo.QueryHookOptions<LedgerBalancesQuery, LedgerBalancesQueryVariables> &
    ({ variables: LedgerBalancesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LedgerBalancesQuery, LedgerBalancesQueryVariables>(LedgerBalancesDocument, options);
}
export function useLedgerBalancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LedgerBalancesQuery, LedgerBalancesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LedgerBalancesQuery, LedgerBalancesQueryVariables>(LedgerBalancesDocument, options);
}
// @ts-ignore
export function useLedgerBalancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<LedgerBalancesQuery, LedgerBalancesQueryVariables>,
): Apollo.UseSuspenseQueryResult<LedgerBalancesQuery, LedgerBalancesQueryVariables>;
export function useLedgerBalancesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerBalancesQuery, LedgerBalancesQueryVariables>,
): Apollo.UseSuspenseQueryResult<LedgerBalancesQuery | undefined, LedgerBalancesQueryVariables>;
export function useLedgerBalancesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerBalancesQuery, LedgerBalancesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LedgerBalancesQuery, LedgerBalancesQueryVariables>(LedgerBalancesDocument, options);
}
export type LedgerBalancesQueryHookResult = ReturnType<typeof useLedgerBalancesQuery>;
export type LedgerBalancesLazyQueryHookResult = ReturnType<typeof useLedgerBalancesLazyQuery>;
export type LedgerBalancesSuspenseQueryHookResult = ReturnType<typeof useLedgerBalancesSuspenseQuery>;
export type LedgerBalancesQueryResult = Apollo.QueryResult<LedgerBalancesQuery, LedgerBalancesQueryVariables>;
export const ListPartnersDocument = /*#__PURE__*/ gql`
  query listPartners {
    listPartners {
      id
      name
      active
    }
  }
`;

/**
 * __useListPartnersQuery__
 *
 * To run a query within a React component, call `useListPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPartnersQuery(
  baseOptions?: Apollo.QueryHookOptions<ListPartnersQuery, ListPartnersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPartnersQuery, ListPartnersQueryVariables>(ListPartnersDocument, options);
}
export function useListPartnersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListPartnersQuery, ListPartnersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPartnersQuery, ListPartnersQueryVariables>(ListPartnersDocument, options);
}
// @ts-ignore
export function useListPartnersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListPartnersQuery, ListPartnersQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListPartnersQuery, ListPartnersQueryVariables>;
export function useListPartnersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPartnersQuery, ListPartnersQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListPartnersQuery | undefined, ListPartnersQueryVariables>;
export function useListPartnersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPartnersQuery, ListPartnersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPartnersQuery, ListPartnersQueryVariables>(ListPartnersDocument, options);
}
export type ListPartnersQueryHookResult = ReturnType<typeof useListPartnersQuery>;
export type ListPartnersLazyQueryHookResult = ReturnType<typeof useListPartnersLazyQuery>;
export type ListPartnersSuspenseQueryHookResult = ReturnType<typeof useListPartnersSuspenseQuery>;
export type ListPartnersQueryResult = Apollo.QueryResult<ListPartnersQuery, ListPartnersQueryVariables>;
export const ListPrimeRatesDocument = /*#__PURE__*/ gql`
  query listPrimeRates {
    listPrimeRates {
      ...BasePrimeRateFragment
    }
  }
  ${BasePrimeRateFragmentFragmentDoc}
`;

/**
 * __useListPrimeRatesQuery__
 *
 * To run a query within a React component, call `useListPrimeRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPrimeRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPrimeRatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPrimeRatesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListPrimeRatesQuery, ListPrimeRatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPrimeRatesQuery, ListPrimeRatesQueryVariables>(ListPrimeRatesDocument, options);
}
export function useListPrimeRatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListPrimeRatesQuery, ListPrimeRatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPrimeRatesQuery, ListPrimeRatesQueryVariables>(ListPrimeRatesDocument, options);
}
// @ts-ignore
export function useListPrimeRatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListPrimeRatesQuery, ListPrimeRatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListPrimeRatesQuery, ListPrimeRatesQueryVariables>;
export function useListPrimeRatesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPrimeRatesQuery, ListPrimeRatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListPrimeRatesQuery | undefined, ListPrimeRatesQueryVariables>;
export function useListPrimeRatesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPrimeRatesQuery, ListPrimeRatesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListPrimeRatesQuery, ListPrimeRatesQueryVariables>(ListPrimeRatesDocument, options);
}
export type ListPrimeRatesQueryHookResult = ReturnType<typeof useListPrimeRatesQuery>;
export type ListPrimeRatesLazyQueryHookResult = ReturnType<typeof useListPrimeRatesLazyQuery>;
export type ListPrimeRatesSuspenseQueryHookResult = ReturnType<typeof useListPrimeRatesSuspenseQuery>;
export type ListPrimeRatesQueryResult = Apollo.QueryResult<ListPrimeRatesQuery, ListPrimeRatesQueryVariables>;
export const ListReconciliationRunsDocument = /*#__PURE__*/ gql`
  query listReconciliationRuns($check: String!, $limit: Int!) {
    listReconciliationRuns(check: $check, limit: $limit) {
      ...BaseReconciliationRunFragment
    }
  }
  ${BaseReconciliationRunFragmentFragmentDoc}
`;

/**
 * __useListReconciliationRunsQuery__
 *
 * To run a query within a React component, call `useListReconciliationRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReconciliationRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReconciliationRunsQuery({
 *   variables: {
 *      check: // value for 'check'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListReconciliationRunsQuery(
  baseOptions: Apollo.QueryHookOptions<ListReconciliationRunsQuery, ListReconciliationRunsQueryVariables> &
    ({ variables: ListReconciliationRunsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListReconciliationRunsQuery, ListReconciliationRunsQueryVariables>(
    ListReconciliationRunsDocument,
    options,
  );
}
export function useListReconciliationRunsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListReconciliationRunsQuery, ListReconciliationRunsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListReconciliationRunsQuery, ListReconciliationRunsQueryVariables>(
    ListReconciliationRunsDocument,
    options,
  );
}
// @ts-ignore
export function useListReconciliationRunsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListReconciliationRunsQuery, ListReconciliationRunsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListReconciliationRunsQuery, ListReconciliationRunsQueryVariables>;
export function useListReconciliationRunsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListReconciliationRunsQuery, ListReconciliationRunsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListReconciliationRunsQuery | undefined, ListReconciliationRunsQueryVariables>;
export function useListReconciliationRunsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListReconciliationRunsQuery, ListReconciliationRunsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListReconciliationRunsQuery, ListReconciliationRunsQueryVariables>(
    ListReconciliationRunsDocument,
    options,
  );
}
export type ListReconciliationRunsQueryHookResult = ReturnType<typeof useListReconciliationRunsQuery>;
export type ListReconciliationRunsLazyQueryHookResult = ReturnType<typeof useListReconciliationRunsLazyQuery>;
export type ListReconciliationRunsSuspenseQueryHookResult = ReturnType<typeof useListReconciliationRunsSuspenseQuery>;
export type ListReconciliationRunsQueryResult = Apollo.QueryResult<
  ListReconciliationRunsQuery,
  ListReconciliationRunsQueryVariables
>;
export const PlatformBalancesDocument = /*#__PURE__*/ gql`
  query platformBalances($programId: ID!, $effectiveDate: Date) {
    platformBalances(programId: $programId, effectiveDate: $effectiveDate) {
      accounts {
        key
        label
        kind
        normalBalanceType
        balance {
          ...BaseLedgerBalance
        }
      }
      exposureRollup {
        ...BaseLedgerBalance
      }
    }
  }
  ${BaseLedgerBalanceFragmentDoc}
`;

/**
 * __usePlatformBalancesQuery__
 *
 * To run a query within a React component, call `usePlatformBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformBalancesQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      effectiveDate: // value for 'effectiveDate'
 *   },
 * });
 */
export function usePlatformBalancesQuery(
  baseOptions: Apollo.QueryHookOptions<PlatformBalancesQuery, PlatformBalancesQueryVariables> &
    ({ variables: PlatformBalancesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PlatformBalancesQuery, PlatformBalancesQueryVariables>(PlatformBalancesDocument, options);
}
export function usePlatformBalancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PlatformBalancesQuery, PlatformBalancesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PlatformBalancesQuery, PlatformBalancesQueryVariables>(PlatformBalancesDocument, options);
}
// @ts-ignore
export function usePlatformBalancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformBalancesQuery, PlatformBalancesQueryVariables>,
): Apollo.UseSuspenseQueryResult<PlatformBalancesQuery, PlatformBalancesQueryVariables>;
export function usePlatformBalancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PlatformBalancesQuery, PlatformBalancesQueryVariables>,
): Apollo.UseSuspenseQueryResult<PlatformBalancesQuery | undefined, PlatformBalancesQueryVariables>;
export function usePlatformBalancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PlatformBalancesQuery, PlatformBalancesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PlatformBalancesQuery, PlatformBalancesQueryVariables>(
    PlatformBalancesDocument,
    options,
  );
}
export type PlatformBalancesQueryHookResult = ReturnType<typeof usePlatformBalancesQuery>;
export type PlatformBalancesLazyQueryHookResult = ReturnType<typeof usePlatformBalancesLazyQuery>;
export type PlatformBalancesSuspenseQueryHookResult = ReturnType<typeof usePlatformBalancesSuspenseQuery>;
export type PlatformBalancesQueryResult = Apollo.QueryResult<PlatformBalancesQuery, PlatformBalancesQueryVariables>;
export const ProgramDocument = /*#__PURE__*/ gql`
  query program($programId: ID!) {
    program(programId: $programId) {
      ...BaseProgramFragment
    }
  }
  ${BaseProgramFragmentFragmentDoc}
`;

/**
 * __useProgramQuery__
 *
 * To run a query within a React component, call `useProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramQuery(
  baseOptions: Apollo.QueryHookOptions<ProgramQuery, ProgramQueryVariables> &
    ({ variables: ProgramQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, options);
}
export function useProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramQuery, ProgramQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, options);
}
// @ts-ignore
export function useProgramSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ProgramQuery, ProgramQueryVariables>,
): Apollo.UseSuspenseQueryResult<ProgramQuery, ProgramQueryVariables>;
export function useProgramSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramQuery, ProgramQueryVariables>,
): Apollo.UseSuspenseQueryResult<ProgramQuery | undefined, ProgramQueryVariables>;
export function useProgramSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProgramQuery, ProgramQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProgramQuery, ProgramQueryVariables>(ProgramDocument, options);
}
export type ProgramQueryHookResult = ReturnType<typeof useProgramQuery>;
export type ProgramLazyQueryHookResult = ReturnType<typeof useProgramLazyQuery>;
export type ProgramSuspenseQueryHookResult = ReturnType<typeof useProgramSuspenseQuery>;
export type ProgramQueryResult = Apollo.QueryResult<ProgramQuery, ProgramQueryVariables>;
export const ReconciliationStatusDocument = /*#__PURE__*/ gql`
  query reconciliationStatus {
    reconciliationStatus {
      check
      severity
      newFindings
      latestRun {
        ...BaseReconciliationRunFragment
      }
    }
  }
  ${BaseReconciliationRunFragmentFragmentDoc}
`;

/**
 * __useReconciliationStatusQuery__
 *
 * To run a query within a React component, call `useReconciliationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useReconciliationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReconciliationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useReconciliationStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<ReconciliationStatusQuery, ReconciliationStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReconciliationStatusQuery, ReconciliationStatusQueryVariables>(
    ReconciliationStatusDocument,
    options,
  );
}
export function useReconciliationStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReconciliationStatusQuery, ReconciliationStatusQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReconciliationStatusQuery, ReconciliationStatusQueryVariables>(
    ReconciliationStatusDocument,
    options,
  );
}
// @ts-ignore
export function useReconciliationStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ReconciliationStatusQuery, ReconciliationStatusQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReconciliationStatusQuery, ReconciliationStatusQueryVariables>;
export function useReconciliationStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReconciliationStatusQuery, ReconciliationStatusQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReconciliationStatusQuery | undefined, ReconciliationStatusQueryVariables>;
export function useReconciliationStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReconciliationStatusQuery, ReconciliationStatusQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReconciliationStatusQuery, ReconciliationStatusQueryVariables>(
    ReconciliationStatusDocument,
    options,
  );
}
export type ReconciliationStatusQueryHookResult = ReturnType<typeof useReconciliationStatusQuery>;
export type ReconciliationStatusLazyQueryHookResult = ReturnType<typeof useReconciliationStatusLazyQuery>;
export type ReconciliationStatusSuspenseQueryHookResult = ReturnType<typeof useReconciliationStatusSuspenseQuery>;
export type ReconciliationStatusQueryResult = Apollo.QueryResult<
  ReconciliationStatusQuery,
  ReconciliationStatusQueryVariables
>;
export const ReportAccountStateCsvDocument = /*#__PURE__*/ gql`
  query reportAccountStateCsv($date: Date!) {
    reportAccountStateCsv(date: $date)
  }
`;

/**
 * __useReportAccountStateCsvQuery__
 *
 * To run a query within a React component, call `useReportAccountStateCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportAccountStateCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportAccountStateCsvQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useReportAccountStateCsvQuery(
  baseOptions: Apollo.QueryHookOptions<ReportAccountStateCsvQuery, ReportAccountStateCsvQueryVariables> &
    ({ variables: ReportAccountStateCsvQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportAccountStateCsvQuery, ReportAccountStateCsvQueryVariables>(
    ReportAccountStateCsvDocument,
    options,
  );
}
export function useReportAccountStateCsvLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReportAccountStateCsvQuery, ReportAccountStateCsvQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReportAccountStateCsvQuery, ReportAccountStateCsvQueryVariables>(
    ReportAccountStateCsvDocument,
    options,
  );
}
// @ts-ignore
export function useReportAccountStateCsvSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ReportAccountStateCsvQuery, ReportAccountStateCsvQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReportAccountStateCsvQuery, ReportAccountStateCsvQueryVariables>;
export function useReportAccountStateCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReportAccountStateCsvQuery, ReportAccountStateCsvQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReportAccountStateCsvQuery | undefined, ReportAccountStateCsvQueryVariables>;
export function useReportAccountStateCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReportAccountStateCsvQuery, ReportAccountStateCsvQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReportAccountStateCsvQuery, ReportAccountStateCsvQueryVariables>(
    ReportAccountStateCsvDocument,
    options,
  );
}
export type ReportAccountStateCsvQueryHookResult = ReturnType<typeof useReportAccountStateCsvQuery>;
export type ReportAccountStateCsvLazyQueryHookResult = ReturnType<typeof useReportAccountStateCsvLazyQuery>;
export type ReportAccountStateCsvSuspenseQueryHookResult = ReturnType<typeof useReportAccountStateCsvSuspenseQuery>;
export type ReportAccountStateCsvQueryResult = Apollo.QueryResult<
  ReportAccountStateCsvQuery,
  ReportAccountStateCsvQueryVariables
>;
export const ReportDatesDocument = /*#__PURE__*/ gql`
  query reportDates {
    reportDates
  }
`;

/**
 * __useReportDatesQuery__
 *
 * To run a query within a React component, call `useReportDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportDatesQuery(
  baseOptions?: Apollo.QueryHookOptions<ReportDatesQuery, ReportDatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportDatesQuery, ReportDatesQueryVariables>(ReportDatesDocument, options);
}
export function useReportDatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReportDatesQuery, ReportDatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReportDatesQuery, ReportDatesQueryVariables>(ReportDatesDocument, options);
}
// @ts-ignore
export function useReportDatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ReportDatesQuery, ReportDatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReportDatesQuery, ReportDatesQueryVariables>;
export function useReportDatesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportDatesQuery, ReportDatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReportDatesQuery | undefined, ReportDatesQueryVariables>;
export function useReportDatesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportDatesQuery, ReportDatesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReportDatesQuery, ReportDatesQueryVariables>(ReportDatesDocument, options);
}
export type ReportDatesQueryHookResult = ReturnType<typeof useReportDatesQuery>;
export type ReportDatesLazyQueryHookResult = ReturnType<typeof useReportDatesLazyQuery>;
export type ReportDatesSuspenseQueryHookResult = ReturnType<typeof useReportDatesSuspenseQuery>;
export type ReportDatesQueryResult = Apollo.QueryResult<ReportDatesQuery, ReportDatesQueryVariables>;
export const ReportLithicSettlementCsvDocument = /*#__PURE__*/ gql`
  query reportLithicSettlementCsv($programId: ID!, $reportDate: Date!) {
    reportLithicSettlementCsv(programId: $programId, reportDate: $reportDate)
  }
`;

/**
 * __useReportLithicSettlementCsvQuery__
 *
 * To run a query within a React component, call `useReportLithicSettlementCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportLithicSettlementCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportLithicSettlementCsvQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      reportDate: // value for 'reportDate'
 *   },
 * });
 */
export function useReportLithicSettlementCsvQuery(
  baseOptions: Apollo.QueryHookOptions<ReportLithicSettlementCsvQuery, ReportLithicSettlementCsvQueryVariables> &
    ({ variables: ReportLithicSettlementCsvQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportLithicSettlementCsvQuery, ReportLithicSettlementCsvQueryVariables>(
    ReportLithicSettlementCsvDocument,
    options,
  );
}
export function useReportLithicSettlementCsvLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReportLithicSettlementCsvQuery, ReportLithicSettlementCsvQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReportLithicSettlementCsvQuery, ReportLithicSettlementCsvQueryVariables>(
    ReportLithicSettlementCsvDocument,
    options,
  );
}
// @ts-ignore
export function useReportLithicSettlementCsvSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReportLithicSettlementCsvQuery,
    ReportLithicSettlementCsvQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ReportLithicSettlementCsvQuery, ReportLithicSettlementCsvQueryVariables>;
export function useReportLithicSettlementCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReportLithicSettlementCsvQuery, ReportLithicSettlementCsvQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReportLithicSettlementCsvQuery | undefined, ReportLithicSettlementCsvQueryVariables>;
export function useReportLithicSettlementCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReportLithicSettlementCsvQuery, ReportLithicSettlementCsvQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReportLithicSettlementCsvQuery, ReportLithicSettlementCsvQueryVariables>(
    ReportLithicSettlementCsvDocument,
    options,
  );
}
export type ReportLithicSettlementCsvQueryHookResult = ReturnType<typeof useReportLithicSettlementCsvQuery>;
export type ReportLithicSettlementCsvLazyQueryHookResult = ReturnType<typeof useReportLithicSettlementCsvLazyQuery>;
export type ReportLithicSettlementCsvSuspenseQueryHookResult = ReturnType<
  typeof useReportLithicSettlementCsvSuspenseQuery
>;
export type ReportLithicSettlementCsvQueryResult = Apollo.QueryResult<
  ReportLithicSettlementCsvQuery,
  ReportLithicSettlementCsvQueryVariables
>;
export const ReportPaymentsRemittanceCsvDocument = /*#__PURE__*/ gql`
  query reportPaymentsRemittanceCsv($programId: ID!, $from: Date!, $to: Date!) {
    reportPaymentsRemittanceCsv(programId: $programId, from: $from, to: $to)
  }
`;

/**
 * __useReportPaymentsRemittanceCsvQuery__
 *
 * To run a query within a React component, call `useReportPaymentsRemittanceCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportPaymentsRemittanceCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportPaymentsRemittanceCsvQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useReportPaymentsRemittanceCsvQuery(
  baseOptions: Apollo.QueryHookOptions<ReportPaymentsRemittanceCsvQuery, ReportPaymentsRemittanceCsvQueryVariables> &
    ({ variables: ReportPaymentsRemittanceCsvQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportPaymentsRemittanceCsvQuery, ReportPaymentsRemittanceCsvQueryVariables>(
    ReportPaymentsRemittanceCsvDocument,
    options,
  );
}
export function useReportPaymentsRemittanceCsvLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportPaymentsRemittanceCsvQuery,
    ReportPaymentsRemittanceCsvQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReportPaymentsRemittanceCsvQuery, ReportPaymentsRemittanceCsvQueryVariables>(
    ReportPaymentsRemittanceCsvDocument,
    options,
  );
}
// @ts-ignore
export function useReportPaymentsRemittanceCsvSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReportPaymentsRemittanceCsvQuery,
    ReportPaymentsRemittanceCsvQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ReportPaymentsRemittanceCsvQuery, ReportPaymentsRemittanceCsvQueryVariables>;
export function useReportPaymentsRemittanceCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReportPaymentsRemittanceCsvQuery, ReportPaymentsRemittanceCsvQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ReportPaymentsRemittanceCsvQuery | undefined,
  ReportPaymentsRemittanceCsvQueryVariables
>;
export function useReportPaymentsRemittanceCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReportPaymentsRemittanceCsvQuery, ReportPaymentsRemittanceCsvQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReportPaymentsRemittanceCsvQuery, ReportPaymentsRemittanceCsvQueryVariables>(
    ReportPaymentsRemittanceCsvDocument,
    options,
  );
}
export type ReportPaymentsRemittanceCsvQueryHookResult = ReturnType<typeof useReportPaymentsRemittanceCsvQuery>;
export type ReportPaymentsRemittanceCsvLazyQueryHookResult = ReturnType<typeof useReportPaymentsRemittanceCsvLazyQuery>;
export type ReportPaymentsRemittanceCsvSuspenseQueryHookResult = ReturnType<
  typeof useReportPaymentsRemittanceCsvSuspenseQuery
>;
export type ReportPaymentsRemittanceCsvQueryResult = Apollo.QueryResult<
  ReportPaymentsRemittanceCsvQuery,
  ReportPaymentsRemittanceCsvQueryVariables
>;
export const ReportTransactionsCsvDocument = /*#__PURE__*/ gql`
  query reportTransactionsCsv($date: Date!) {
    reportTransactionsCsv(date: $date)
  }
`;

/**
 * __useReportTransactionsCsvQuery__
 *
 * To run a query within a React component, call `useReportTransactionsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTransactionsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTransactionsCsvQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useReportTransactionsCsvQuery(
  baseOptions: Apollo.QueryHookOptions<ReportTransactionsCsvQuery, ReportTransactionsCsvQueryVariables> &
    ({ variables: ReportTransactionsCsvQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportTransactionsCsvQuery, ReportTransactionsCsvQueryVariables>(
    ReportTransactionsCsvDocument,
    options,
  );
}
export function useReportTransactionsCsvLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReportTransactionsCsvQuery, ReportTransactionsCsvQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReportTransactionsCsvQuery, ReportTransactionsCsvQueryVariables>(
    ReportTransactionsCsvDocument,
    options,
  );
}
// @ts-ignore
export function useReportTransactionsCsvSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ReportTransactionsCsvQuery, ReportTransactionsCsvQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReportTransactionsCsvQuery, ReportTransactionsCsvQueryVariables>;
export function useReportTransactionsCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReportTransactionsCsvQuery, ReportTransactionsCsvQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReportTransactionsCsvQuery | undefined, ReportTransactionsCsvQueryVariables>;
export function useReportTransactionsCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ReportTransactionsCsvQuery, ReportTransactionsCsvQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReportTransactionsCsvQuery, ReportTransactionsCsvQueryVariables>(
    ReportTransactionsCsvDocument,
    options,
  );
}
export type ReportTransactionsCsvQueryHookResult = ReturnType<typeof useReportTransactionsCsvQuery>;
export type ReportTransactionsCsvLazyQueryHookResult = ReturnType<typeof useReportTransactionsCsvLazyQuery>;
export type ReportTransactionsCsvSuspenseQueryHookResult = ReturnType<typeof useReportTransactionsCsvSuspenseQuery>;
export type ReportTransactionsCsvQueryResult = Apollo.QueryResult<
  ReportTransactionsCsvQuery,
  ReportTransactionsCsvQueryVariables
>;
export const UsioPrefundingBalanceDocument = /*#__PURE__*/ gql`
  query usioPrefundingBalance($programId: ID!) {
    usioPrefundingBalance(programId: $programId) {
      achPrefundingBalance
    }
  }
`;

/**
 * __useUsioPrefundingBalanceQuery__
 *
 * To run a query within a React component, call `useUsioPrefundingBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsioPrefundingBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsioPrefundingBalanceQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useUsioPrefundingBalanceQuery(
  baseOptions: Apollo.QueryHookOptions<UsioPrefundingBalanceQuery, UsioPrefundingBalanceQueryVariables> &
    ({ variables: UsioPrefundingBalanceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsioPrefundingBalanceQuery, UsioPrefundingBalanceQueryVariables>(
    UsioPrefundingBalanceDocument,
    options,
  );
}
export function useUsioPrefundingBalanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UsioPrefundingBalanceQuery, UsioPrefundingBalanceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UsioPrefundingBalanceQuery, UsioPrefundingBalanceQueryVariables>(
    UsioPrefundingBalanceDocument,
    options,
  );
}
// @ts-ignore
export function useUsioPrefundingBalanceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<UsioPrefundingBalanceQuery, UsioPrefundingBalanceQueryVariables>,
): Apollo.UseSuspenseQueryResult<UsioPrefundingBalanceQuery, UsioPrefundingBalanceQueryVariables>;
export function useUsioPrefundingBalanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UsioPrefundingBalanceQuery, UsioPrefundingBalanceQueryVariables>,
): Apollo.UseSuspenseQueryResult<UsioPrefundingBalanceQuery | undefined, UsioPrefundingBalanceQueryVariables>;
export function useUsioPrefundingBalanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UsioPrefundingBalanceQuery, UsioPrefundingBalanceQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UsioPrefundingBalanceQuery, UsioPrefundingBalanceQueryVariables>(
    UsioPrefundingBalanceDocument,
    options,
  );
}
export type UsioPrefundingBalanceQueryHookResult = ReturnType<typeof useUsioPrefundingBalanceQuery>;
export type UsioPrefundingBalanceLazyQueryHookResult = ReturnType<typeof useUsioPrefundingBalanceLazyQuery>;
export type UsioPrefundingBalanceSuspenseQueryHookResult = ReturnType<typeof useUsioPrefundingBalanceSuspenseQuery>;
export type UsioPrefundingBalanceQueryResult = Apollo.QueryResult<
  UsioPrefundingBalanceQuery,
  UsioPrefundingBalanceQueryVariables
>;
